export default function () {
  return {
    countrySelected: 'Austria',
    data: {
      Guadeloupe: {
        name: 'Guadeloupe',
        population: 400201,
        info: {
          name: 'Guadeloupe',
          region: 'America',
          country: 'France',
          area: 1628
        }
      },
      Quebec: {
        name: 'Quebec',
        population: 8164361,
        info: {
          name: 'Quebec',
          region: 'America',
          country: 'Canada',
          area: 1542056
        }
      },
      Madeira: {
        name: 'Madeira',
        population: 289000,
        info: {
          name: 'Madeira',
          region: 'Europe',
          country: 'Portugal',
          area: 801
        }
      },
      'Ile de la Reunion': {
        name: 'Ile de la Reunion',
        population: 858450,
        info: {
          name: 'Ile de la Reunion',
          region: 'Africa',
          country: 'France',
          area: 2511
        }
      },
      'French Guiana': {
        name: 'French Guiana',
        population: 294071,
        info: {
          name: 'French Guiana',
          region: 'America',
          country: 'France',
          area: 91000
        }
      },
      California: {
        name: 'California',
        population: 39538223,
        info: {
          name: 'California',
          region: 'America',
          country: 'United States of America',
          demonym: 'californian',
          area: 423970
        }
      },
      Florida: {
        name: 'Florida',
        population: 21570527,
        info: {
          name: 'Florida',
          region: 'America',
          country: 'United States of America',
          demonym: 'floridian',
          area: 170312
        }
      },
      Miami: {
        name: 'Miami',
        population: 442241,
        info: {
          name: 'Miami',
          region: 'America',
          country: 'United States of America',
          demonym: 'miamian',
          area: 145
        }
      },
      'Las Vegas': {
        name: 'Las Vegas',
        population: 641903,
        info: {
          name: 'Las Vegas',
          region: 'America',
          country: 'United States of America',
          demonym: 'las vegan',
          area: 367
        }
      },
      'New York': {
        name: 'New York',
        population: 8804190,
        info: {
          name: 'New York',
          region: 'America',
          country: 'United States of America',
          demonym: 'new yorker',
          area: 1223
        }
      },
      'Fort Myers': {
        name: 'Fort Myers',
        population: 62298,
        info: {
          name: 'Fort Myers',
          region: 'America',
          country: 'United States of America',
          area: 127
        }
      },
      Andalusia: {
        name: 'Andalusia',
        population: 8388107,
        info: {
          name: 'Andalusia',
          region: 'Europe',
          country: 'Spain',
          demonym: 'andalusian',
          area: 87268
        }
      },
      Sevilla: {
        name: 'Sevilla',
        population: 688711,
        info: {
          name: 'Sevilla',
          region: 'Europe',
          country: 'Spain',
          demonym: 'sevillan',
          area: 140
        }
      },
      Malaga: {
        name: 'Malaga',
        population: 571026,
        info: {
          name: 'Malaga',
          region: 'Europe',
          country: 'Spain',
          area: 398
        }
      },
      Tarragona: {
        name: 'Tarragona',
        population: 132299,
        info: {
          name: 'Tarragona',
          region: 'Europe',
          country: 'Spain',
          area: 58
        }
      },
      Tenerife: {
        name: 'Tenerife',
        population: 966354,
        info: {
          name: 'Tenerife',
          region: 'Europe',
          country: 'Spain',
          area: 2034
        }
      },
      Girona: {
        name: 'Girona',
        population: 739607,
        info: {
          name: 'Girona',
          region: 'Europe',
          country: 'Spain',
          demonym: 'gerundense',
          area: 5905
        }
      },
      Granada: {
        name: 'Granada',
        population: 233648,
        info: {
          name: 'Granada',
          region: 'Europe',
          country: 'Spain',
          demonym: 'granadan'
        }
      },
      Catalonia: {
        name: 'Catalonia',
        population: 7727029,
        info: {
          name: 'Catalonia',
          region: 'Europe',
          country: 'Spain',
          demonym: 'catalan',
          area: 32108
        }
      },
      'Costa Brava': {
        name: 'Costa Brava',
        population: 452119,
        info: {
          name: 'Costa Brava',
          region: 'Europe',
          country: 'Spain'
        }
      },
      Catalonia: {
        name: 'Catalonia',
        population: 7727029,
        info: {
          name: 'Catalonia',
          region: 'Europe',
          country: 'Spain',
          demonym: 'catalan',
          area: 32108
        }
      },
      'Canary Islands': {
        name: 'Canary Islands',
        population: 2153389,
        info: {
          name: 'Canary Islands',
          region: 'Europe',
          country: 'Spain',
          demonym: 'canarian',
          area: 7493
        }
      },
      Barcelona: {
        name: 'Barcelona',
        population: 1620343,
        info: {
          name: 'Barcelona',
          region: 'Europe',
          country: 'Spain',
          demonym: 'barcelonan',
          area: 101
        }
      },
      'Balearic Islands': {
        name: 'Balearic Islands',
        population: 1215174,
        info: {
          name: 'Balearic Islands',
          region: 'Europe',
          country: 'Spain',
          demonym: 'balearic',
          area: 4992
        }
      },
      England: {
        name: 'England',
        population: 56286961,
        slug: 'england',
        domain: '.gb-eng',
        info: {
          alpha2Code: 'AL',
          name: 'England',
          region: 'Europe',
          country: 'United Kingdom',
          demonym: 'english',
          area: 130279
        }
      },
      Scotland: {
        name: 'Scotland',
        population: 5463300,
        info: {
          name: 'Scotland',
          region: 'Europe',
          country: 'United Kingdom',
          demonym: 'scottish',
          area: 77933
        }
      },
      Wales: {
        name: 'Wales',
        population: 3153000,
        info: {
          name: 'Wales',
          region: 'Europe',
          country: 'United Kingdom',
          demonym: 'welsh',
          area: 20779
        }
      },
      'Northern Ireland': {
        name: 'Northern Ireland',
        population: 1900000,
        info: {
          name: 'Northern Ireland',
          region: 'Europe',
          country: 'United Kingdom',
          demonym: 'irish',
          area: 14130
        }
      },
      'Ras Al Khaimah': {
        name: 'Ras Al Khaimah',
        population: 115949,
        info: {
          name: 'Ras Al Khaimah',
          region: 'Asia',
          country: 'United Arab Emirates',
          area: 373
        }
      },
      Sharjah: {
        name: 'Sharjah',
        population: 1274749,
        info: {
          name: 'Sharjah',
          region: 'Asia',
          country: 'United Arab Emirates',
          area: 235
        }
      },
      Dubai: {
        name: 'Dubai',
        population: 3331420,
        info: {
          name: 'Dubai',
          region: 'Asia',
          country: 'United Arab Emirates',
          demonym: 'Dubaian',
          area: 4114
        }
      },
      'Abu Dhabi': {
        name: 'Abu Dhabi',
        population: 1450000,
        info: {
          name: 'Abu Dhabi',
          region: 'Asia',
          country: 'United Arab Emirates',
          demonym: 'Abu Dhabian',
          area: 972
        }
      },
      Tahiti: {
        name: 'Tahiti',
        population: 189517,
        info: {
          name: 'Tahiti',
          region: 'America',
          country: 'French Polynesia',
          demonym: 'Tahitian',
          area: 1
        }
      },
      Afghanistan: {
        name: 'Afghanistan',
        slug: 'afghanistan',
        population: 37466414,
        domain: '.af',
        sex: {
          male: 50.64,
          female: 49.36
        },
        age: [
          {
            group: '0-14 years',
            value: '40.62',
            male: '7562703',
            female: '7321646'
          },
          {
            group: '15-24 years',
            value: '21.26',
            male: '3960044',
            female: '3828670'
          },
          {
            group: '25-54 years',
            value: '31.44',
            male: '5858675',
            female: '5661887'
          },
          {
            group: '55-64 years',
            value: '4.01',
            male: '724597',
            female: '744910'
          },
          {
            group: '65 years and over',
            value: '2.68',
            male: '451852',
            female: '528831'
          }
        ],
        info: {
          name: 'Afghanistan',
          alpha2Code: 'AF',
          alpha3Code: 'AFG',
          capital: 'Kabul',
          region: 'Asia',
          subregion: 'Southern Asia',
          latlng: [33, 65],
          demonym: 'Afghan',
          area: 652230,
          gini: 27.8,
          borders: ['IRN', 'PAK', 'TKM', 'UZB', 'TJK', 'CHN'],
          nativeName: 'افغانستان',
          translations: {
            de: 'Afghanistan',
            es: 'Afganistán',
            fr: 'Afghanistan',
            ja: 'アフガニスタン',
            it: 'Afghanistan',
            br: 'Afeganistão',
            pt: 'Afeganistão',
            nl: 'Afghanistan',
            hr: 'Afganistan',
            fa: 'افغانستان'
          },
          flag: 'https://restcountries.eu/data/afg.svg'
        }
      },
      Akrotiri: {
        name: 'Akrotiri',
        slug: 'akrotiri',
        population: 0
      },
      Albania: {
        name: 'Albania',
        slug: 'albania',
        population: 3088385,
        domain: '.al',
        sex: {
          male: 49.39,
          female: 50.61
        },
        age: [
          {
            group: '0-14 years',
            value: '17.6',
            male: '284636',
            female: '256474'
          },
          {
            group: '15-24 years',
            value: '15.39',
            male: '246931',
            female: '226318'
          },
          {
            group: '25-54 years',
            value: '42.04',
            male: '622100',
            female: '670307'
          },
          {
            group: '55-64 years',
            value: '11.94',
            male: '178419',
            female: '188783'
          },
          {
            group: '65 years and over',
            value: '13.03',
            male: '186335',
            female: '214276'
          }
        ],
        info: {
          name: 'Albania',
          alpha2Code: 'AL',
          alpha3Code: 'ALB',
          capital: 'Tirana',
          region: 'Europe',
          subregion: 'Southern Europe',
          latlng: [41, 20],
          demonym: 'Albanian',
          area: 28748,
          gini: 34.5,
          borders: ['MNE', 'GRC', 'MKD', 'KOS'],
          nativeName: 'Shqipëria',
          translations: {
            de: 'Albanien',
            es: 'Albania',
            fr: 'Albanie',
            ja: 'アルバニア',
            it: 'Albania',
            br: 'Albânia',
            pt: 'Albânia',
            nl: 'Albanië',
            hr: 'Albanija',
            fa: 'آلبانی'
          },
          flag: 'https://restcountries.eu/data/alb.svg'
        }
      },
      Algeria: {
        name: 'Algeria',
        slug: 'algeria',
        population: 43576691,
        domain: '.dz',
        sex: {
          male: 50.66,
          female: 49.34
        },
        age: [
          {
            group: '0-14 years',
            value: '29.58',
            male: '6509490',
            female: '6201450'
          },
          {
            group: '15-24 years',
            value: '13.93',
            male: '3063972',
            female: '2922368'
          },
          {
            group: '25-54 years',
            value: '42.91',
            male: '9345997',
            female: '9091558'
          },
          {
            group: '55-64 years',
            value: '7.41',
            male: '1599369',
            female: '1585233'
          },
          {
            group: '65 years and over',
            value: '6.17',
            male: '1252084',
            female: '1401357'
          }
        ],
        info: {
          name: 'Algeria',
          alpha2Code: 'DZ',
          alpha3Code: 'DZA',
          capital: 'Algiers',
          region: 'Africa',
          subregion: 'Northern Africa',
          latlng: [28, 3],
          demonym: 'Algerian',
          area: 2381741,
          gini: 35.3,
          borders: ['TUN', 'LBY', 'NER', 'ESH', 'MRT', 'MLI', 'MAR'],
          nativeName: 'الجزائر',
          translations: {
            de: 'Algerien',
            es: 'Argelia',
            fr: 'Algérie',
            ja: 'アルジェリア',
            it: 'Algeria',
            br: 'Argélia',
            pt: 'Argélia',
            nl: 'Algerije',
            hr: 'Alžir',
            fa: 'الجزایر'
          },
          flag: 'https://restcountries.eu/data/dza.svg'
        }
      },
      'American Samoa': {
        name: 'American Samoa',
        slug: 'american-samoa',
        population: 46366,
        domain: '.as',
        sex: {
          male: 49.9,
          female: 50.1
        },
        age: [
          {
            group: '0-14 years',
            value: '27.76',
            male: '7063',
            female: '6662'
          },
          {
            group: '15-24 years',
            value: '18.16',
            male: '4521',
            female: '4458'
          },
          {
            group: '25-54 years',
            value: '37.49',
            male: '9164',
            female: '9370'
          },
          {
            group: '55-64 years',
            value: '9.69',
            male: '2341',
            female: '2447'
          },
          {
            group: '65 years and over',
            value: '6.9',
            male: '1580',
            female: '1831'
          }
        ],
        info: {
          name: 'American Samoa',
          alpha2Code: 'AS',
          alpha3Code: 'ASM',
          capital: 'Pago Pago',
          region: 'Oceania',
          subregion: 'Polynesia',
          latlng: [-14.33333333, -170],
          demonym: 'American Samoan',
          area: 199,
          gini: null,
          borders: [],
          nativeName: 'American Samoa',
          translations: {
            de: 'Amerikanisch-Samoa',
            es: 'Samoa Americana',
            fr: 'Samoa américaines',
            ja: 'アメリカ領サモア',
            it: 'Samoa Americane',
            br: 'Samoa Americana',
            pt: 'Samoa Americana',
            nl: 'Amerikaans Samoa',
            hr: 'Američka Samoa',
            fa: 'ساموآی آمریکا'
          },
          flag: 'https://restcountries.eu/data/asm.svg'
        }
      },
      Andorra: {
        name: 'Andorra',
        slug: 'andorra',
        population: 85645,
        domain: '.ad',
        sex: {
          male: 51.33,
          female: 48.67
        },
        age: [
          {
            group: '0-14 years',
            value: '13.37',
            male: '5901',
            female: '5551'
          },
          {
            group: '15-24 years',
            value: '10.16',
            male: '4474',
            female: '4227'
          },
          {
            group: '25-54 years',
            value: '43.19',
            male: '18857',
            female: '18131'
          },
          {
            group: '55-64 years',
            value: '15.91',
            male: '7184',
            female: '6443'
          },
          {
            group: '65 years and over',
            value: '17.36',
            male: '7544',
            female: '7323'
          }
        ],
        info: {
          name: 'Andorra',
          alpha2Code: 'AD',
          alpha3Code: 'AND',
          capital: 'Andorra la Vella',
          region: 'Europe',
          subregion: 'Southern Europe',
          latlng: [42.5, 1.5],
          demonym: 'Andorran',
          area: 468,
          gini: null,
          borders: ['FRA', 'ESP'],
          nativeName: 'Andorra',
          translations: {
            de: 'Andorra',
            es: 'Andorra',
            fr: 'Andorre',
            ja: 'アンドラ',
            it: 'Andorra',
            br: 'Andorra',
            pt: 'Andorra',
            nl: 'Andorra',
            hr: 'Andora',
            fa: 'آندورا'
          },
          flag: 'https://restcountries.eu/data/and.svg'
        }
      },
      Angola: {
        name: 'Angola',
        slug: 'angola',
        population: 33642646,
        domain: '.ao',
        sex: {
          male: 48.73,
          female: 51.27
        },
        age: [
          {
            group: '0-14 years',
            value: '47.83',
            male: '7758636',
            female: '7797869'
          },
          {
            group: '15-24 years',
            value: '18.64',
            male: '2950999',
            female: '3109741'
          },
          {
            group: '25-54 years',
            value: '27.8',
            male: '4301618',
            female: '4740463'
          },
          {
            group: '55-64 years',
            value: '3.43',
            male: '523517',
            female: '591249'
          },
          {
            group: '65 years and over',
            value: '2.3',
            male: '312197',
            female: '436050'
          }
        ],
        info: {
          name: 'Angola',
          alpha2Code: 'AO',
          alpha3Code: 'AGO',
          capital: 'Luanda',
          region: 'Africa',
          subregion: 'Middle Africa',
          latlng: [-12.5, 18.5],
          demonym: 'Angolan',
          area: 1246700,
          gini: 58.6,
          borders: ['COG', 'COD', 'ZMB', 'NAM'],
          nativeName: 'Angola',
          translations: {
            de: 'Angola',
            es: 'Angola',
            fr: 'Angola',
            ja: 'アンゴラ',
            it: 'Angola',
            br: 'Angola',
            pt: 'Angola',
            nl: 'Angola',
            hr: 'Angola',
            fa: 'آنگولا'
          },
          flag: 'https://restcountries.eu/data/ago.svg'
        }
      },
      Anguilla: {
        name: 'Anguilla',
        slug: 'anguilla',
        population: 18403,
        domain: '.ai',
        sex: {
          male: 47.29,
          female: 52.71
        },
        age: [
          {
            group: '0-14 years',
            value: '21.63',
            male: '1991',
            female: '1922'
          },
          {
            group: '15-24 years',
            value: '13.9',
            male: '1269',
            female: '1246'
          },
          {
            group: '25-54 years',
            value: '42.27',
            male: '3428',
            female: '4218'
          },
          {
            group: '55-64 years',
            value: '12.42',
            male: '993',
            female: '1254'
          },
          {
            group: '65 years and over',
            value: '9.78',
            male: '874',
            female: '895'
          }
        ],
        info: {
          name: 'Anguilla',
          alpha2Code: 'AI',
          alpha3Code: 'AIA',
          capital: 'The Valley',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [18.25, -63.16666666],
          demonym: 'Anguillian',
          area: 91,
          gini: null,
          borders: [],
          nativeName: 'Anguilla',
          translations: {
            de: 'Anguilla',
            es: 'Anguilla',
            fr: 'Anguilla',
            ja: 'アンギラ',
            it: 'Anguilla',
            br: 'Anguila',
            pt: 'Anguila',
            nl: 'Anguilla',
            hr: 'Angvila',
            fa: 'آنگویلا'
          },
          flag: 'https://restcountries.eu/data/aia.svg'
        }
      },
      Antarctica: {
        name: 'Antarctica',
        slug: 'antarctica',
        population: 0,
        domain: '.aq',
        info: {
          name: 'Antarctica',
          alpha2Code: 'AQ',
          alpha3Code: 'ATA',
          capital: '',
          region: 'Polar',
          subregion: '',
          latlng: [-74.65, 4.48],
          demonym: '',
          area: 14000000,
          gini: null,
          borders: [],
          nativeName: 'Antarctica',
          translations: {
            de: 'Antarktika',
            es: 'Antártida',
            fr: 'Antarctique',
            ja: '南極大陸',
            it: 'Antartide',
            br: 'Antártida',
            pt: 'Antárctida',
            nl: 'Antarctica',
            hr: 'Antarktika',
            fa: 'جنوبگان'
          },
          flag: 'https://restcountries.eu/data/ata.svg'
        }
      },
      'Antigua and Barbuda': {
        name: 'Antigua and Barbuda',
        slug: 'antigua-and-barbuda',
        population: 99175,
        domain: '.ag',
        sex: {
          male: 47.18,
          female: 52.82
        },
        age: [
          {
            group: '0-14 years',
            value: '22.52',
            male: '11243',
            female: '10871'
          },
          {
            group: '15-24 years',
            value: '16.15',
            male: '7891',
            female: '7961'
          },
          {
            group: '25-54 years',
            value: '41.68',
            male: '18757',
            female: '22167'
          },
          {
            group: '55-64 years',
            value: '10.74',
            male: '4693',
            female: '5848'
          },
          {
            group: '65 years and over',
            value: '8.91',
            male: '3736',
            female: '5012'
          }
        ],
        info: {
          name: 'Antigua and Barbuda',
          alpha2Code: 'AG',
          alpha3Code: 'ATG',
          capital: "Saint John's",
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [17.05, -61.8],
          demonym: 'Antiguan, Barbudan',
          area: 442,
          gini: null,
          borders: [],
          nativeName: 'Antigua and Barbuda',
          translations: {
            de: 'Antigua und Barbuda',
            es: 'Antigua y Barbuda',
            fr: 'Antigua-et-Barbuda',
            ja: 'アンティグア・バーブーダ',
            it: 'Antigua e Barbuda',
            br: 'Antígua e Barbuda',
            pt: 'Antígua e Barbuda',
            nl: 'Antigua en Barbuda',
            hr: 'Antigva i Barbuda',
            fa: 'آنتیگوا و باربودا'
          },
          flag: 'https://restcountries.eu/data/atg.svg'
        }
      },
      Argentina: {
        name: 'Argentina',
        slug: 'argentina',
        population: 45864941,
        domain: '.ar',
        sex: {
          male: 49.49,
          female: 50.51
        },
        age: [
          {
            group: '0-14 years',
            value: '24.02',
            male: '5629188',
            female: '5294723'
          },
          {
            group: '15-24 years',
            value: '15.19',
            male: '3539021',
            female: '3367321'
          },
          {
            group: '25-54 years',
            value: '39.6',
            male: '9005758',
            female: '9002931'
          },
          {
            group: '55-64 years',
            value: '9.07',
            male: '2000536',
            female: '2122699'
          },
          {
            group: '65 years and over',
            value: '12.13',
            male: '2331679',
            female: '3185262'
          }
        ],
        info: {
          name: 'Argentina',
          alpha2Code: 'AR',
          alpha3Code: 'ARG',
          capital: 'Buenos Aires',
          region: 'Americas',
          subregion: 'South America',
          latlng: [-34, -64],
          demonym: 'Argentinean',
          area: 2780400,
          gini: 44.5,
          borders: ['BOL', 'BRA', 'CHL', 'PRY', 'URY'],
          nativeName: 'Argentina',
          translations: {
            de: 'Argentinien',
            es: 'Argentina',
            fr: 'Argentine',
            ja: 'アルゼンチン',
            it: 'Argentina',
            br: 'Argentina',
            pt: 'Argentina',
            nl: 'Argentinië',
            hr: 'Argentina',
            fa: 'آرژانتین'
          },
          flag: 'https://restcountries.eu/data/arg.svg'
        }
      },
      Armenia: {
        name: 'Armenia',
        slug: 'armenia',
        population: 3011609,
        domain: '.am',
        sex: {
          male: 48.67,
          female: 51.33
        },
        age: [
          {
            group: '0-14 years',
            value: '18.64',
            male: '297320',
            female: '265969'
          },
          {
            group: '15-24 years',
            value: '11.63',
            male: '184258',
            female: '167197'
          },
          {
            group: '25-54 years',
            value: '43.04',
            male: '639101',
            female: '661421'
          },
          {
            group: '55-64 years',
            value: '14.08',
            male: '195754',
            female: '229580'
          },
          {
            group: '65 years and over',
            value: '12.6',
            male: '154117',
            female: '226607'
          }
        ],
        info: {
          name: 'Armenia',
          alpha2Code: 'AM',
          alpha3Code: 'ARM',
          capital: 'Yerevan',
          region: 'Asia',
          subregion: 'Western Asia',
          latlng: [40, 45],
          demonym: 'Armenian',
          area: 29743,
          gini: 30.9,
          borders: ['AZE', 'GEO', 'IRN', 'TUR'],
          nativeName: 'Հայաստան',
          translations: {
            de: 'Armenien',
            es: 'Armenia',
            fr: 'Arménie',
            ja: 'アルメニア',
            it: 'Armenia',
            br: 'Armênia',
            pt: 'Arménia',
            nl: 'Armenië',
            hr: 'Armenija',
            fa: 'ارمنستان'
          },
          flag: 'https://restcountries.eu/data/arm.svg'
        }
      },
      Aruba: {
        name: 'Aruba',
        slug: 'aruba',
        population: 120917,
        domain: '.aw',
        sex: {
          male: 47.3,
          female: 52.7
        },
        age: [
          {
            group: '0-14 years',
            value: '17.55',
            male: '10524',
            female: '10437'
          },
          {
            group: '15-24 years',
            value: '12.06',
            male: '7231',
            female: '7175'
          },
          {
            group: '25-54 years',
            value: '40.54',
            male: '23387',
            female: '25029'
          },
          {
            group: '55-64 years',
            value: '14.79',
            male: '8285',
            female: '9383'
          },
          {
            group: '65 years and over',
            value: '15.05',
            male: '7064',
            female: '10913'
          }
        ],
        info: {
          name: 'Aruba',
          alpha2Code: 'AW',
          alpha3Code: 'ABW',
          capital: 'Oranjestad',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [12.5, -69.96666666],
          demonym: 'Aruban',
          area: 180,
          gini: null,
          borders: [],
          nativeName: 'Aruba',
          translations: {
            de: 'Aruba',
            es: 'Aruba',
            fr: 'Aruba',
            ja: 'アルバ',
            it: 'Aruba',
            br: 'Aruba',
            pt: 'Aruba',
            nl: 'Aruba',
            hr: 'Aruba',
            fa: 'آروبا'
          },
          flag: 'https://restcountries.eu/data/abw.svg'
        }
      },
      'Ashmore and Cartier Islands': {
        name: 'Ashmore and Cartier Islands',
        slug: 'ashmore-and-cartier-islands',
        population: 0
      },
      Australia: {
        name: 'Australia',
        slug: 'australia',
        population: 25809973,
        domain: '.au',
        sex: {
          male: 49.69,
          female: 50.31
        },
        age: [
          {
            group: '0-14 years',
            value: '18.72',
            male: '2457418',
            female: '2309706'
          },
          {
            group: '15-24 years',
            value: '12.89',
            male: '1710253',
            female: '1572794'
          },
          {
            group: '25-54 years',
            value: '41.15',
            male: '5224840',
            female: '5255041'
          },
          {
            group: '55-64 years',
            value: '11.35',
            male: '1395844',
            female: '1495806'
          },
          {
            group: '65 years and over',
            value: '15.88',
            male: '1866761',
            female: '2177996'
          }
        ],
        info: {
          name: 'Australia',
          alpha2Code: 'AU',
          alpha3Code: 'AUS',
          capital: 'Canberra',
          region: 'Oceania',
          subregion: 'Australia and New Zealand',
          latlng: [-27, 133],
          demonym: 'Australian',
          area: 7692024,
          gini: 30.5,
          borders: [],
          nativeName: 'Australia',
          translations: {
            de: 'Australien',
            es: 'Australia',
            fr: 'Australie',
            ja: 'オーストラリア',
            it: 'Australia',
            br: 'Austrália',
            pt: 'Austrália',
            nl: 'Australië',
            hr: 'Australija',
            fa: 'استرالیا'
          },
          flag: 'https://restcountries.eu/data/aus.svg'
        }
      },
      Austria: {
        name: 'Austria',
        slug: 'austria',
        population: 8884864,
        domain: '.at',
        sex: {
          male: 48.97,
          female: 51.03
        },
        age: [
          {
            group: '0-14 years',
            value: '14.01',
            male: '635803',
            female: '605065'
          },
          {
            group: '15-24 years',
            value: '10.36',
            male: '466921',
            female: '451248'
          },
          {
            group: '25-54 years',
            value: '41.35',
            male: '1831704',
            female: '1831669'
          },
          {
            group: '55-64 years',
            value: '14.41',
            male: '635342',
            female: '641389'
          },
          {
            group: '65 years and over',
            value: '19.87',
            male: '768687',
            female: '991621'
          }
        ],
        info: {
          name: 'Austria',
          alpha2Code: 'AT',
          alpha3Code: 'AUT',
          capital: 'Vienna',
          region: 'Europe',
          subregion: 'Western Europe',
          latlng: [47.33333333, 13.33333333],
          demonym: 'Austrian',
          area: 83871,
          gini: 26,
          borders: ['CZE', 'DEU', 'HUN', 'ITA', 'LIE', 'SVK', 'SVN', 'CHE'],
          nativeName: 'Österreich',
          translations: {
            de: 'Österreich',
            es: 'Austria',
            fr: 'Autriche',
            ja: 'オーストリア',
            it: 'Austria',
            br: 'áustria',
            pt: 'áustria',
            nl: 'Oostenrijk',
            hr: 'Austrija',
            fa: 'اتریش'
          },
          flag: 'https://restcountries.eu/data/aut.svg'
        }
      },
      Azerbaijan: {
        name: 'Azerbaijan',
        slug: 'azerbaijan',
        population: 10282283,
        domain: '.az',
        sex: {
          male: 49.59,
          female: 50.41
        },
        age: [
          {
            group: '0-14 years',
            value: '22.84',
            male: '1235292',
            female: '1095308'
          },
          {
            group: '15-24 years',
            value: '13.17',
            male: '714718',
            female: '629494'
          },
          {
            group: '25-54 years',
            value: '45.29',
            male: '2291600',
            female: '2330843'
          },
          {
            group: '55-64 years',
            value: '11.41',
            male: '530046',
            female: '634136'
          },
          {
            group: '65 years and over',
            value: '7.29',
            male: '289604',
            female: '454769'
          }
        ],
        info: {
          name: 'Azerbaijan',
          alpha2Code: 'AZ',
          alpha3Code: 'AZE',
          capital: 'Baku',
          region: 'Asia',
          subregion: 'Western Asia',
          latlng: [40.5, 47.5],
          demonym: 'Azerbaijani',
          area: 86600,
          gini: 33.7,
          borders: ['ARM', 'GEO', 'IRN', 'RUS', 'TUR'],
          nativeName: 'Azərbaycan',
          translations: {
            de: 'Aserbaidschan',
            es: 'Azerbaijan',
            fr: 'Azerbaïdjan',
            ja: 'アゼルバイジャン',
            it: 'Azerbaijan',
            br: 'Azerbaijão',
            pt: 'Azerbaijão',
            nl: 'Azerbeidzjan',
            hr: 'Azerbajdžan',
            fa: 'آذربایجان'
          },
          flag: 'https://restcountries.eu/data/aze.svg'
        }
      },
      Bahamas: {
        name: 'Bahamas, The',
        slug: 'bahamas-the',
        population: 352655,
        domain: '.bs',
        sex: {
          male: 48.79,
          female: 51.21
        },
        age: [
          {
            group: '0-14 years',
            value: '21.7',
            male: '38811',
            female: '37719'
          },
          {
            group: '15-24 years',
            value: '14.91',
            male: '26636',
            female: '25945'
          },
          {
            group: '25-54 years',
            value: '43.56',
            male: '76505',
            female: '77119'
          },
          {
            group: '55-64 years',
            value: '10.75',
            male: '17508',
            female: '20391'
          },
          {
            group: '65 years and over',
            value: '9.08',
            male: '12587',
            female: '19434'
          }
        ],
        info: {
          name: 'Bahamas',
          alpha2Code: 'BS',
          alpha3Code: 'BHS',
          capital: 'Nassau',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [24.25, -76],
          demonym: 'Bahamian',
          area: 13943,
          gini: null,
          borders: [],
          nativeName: 'Bahamas',
          translations: {
            de: 'Bahamas',
            es: 'Bahamas',
            fr: 'Bahamas',
            ja: 'バハマ',
            it: 'Bahamas',
            br: 'Bahamas',
            pt: 'Baamas',
            nl: 'Bahama’s',
            hr: 'Bahami',
            fa: 'باهاما'
          },
          flag: 'https://restcountries.eu/data/bhs.svg'
        }
      },
      Bahrain: {
        name: 'Bahrain',
        slug: 'bahrain',
        population: 1526929,
        domain: '.bh',
        sex: {
          male: 60.53,
          female: 39.47
        },
        age: [
          {
            group: '0-14 years',
            value: '18.45',
            male: '141039',
            female: '136687'
          },
          {
            group: '15-24 years',
            value: '15.16',
            male: '129310',
            female: '98817'
          },
          {
            group: '25-54 years',
            value: '56.14',
            male: '550135',
            female: '294778'
          },
          {
            group: '55-64 years',
            value: '6.89',
            male: '64761',
            female: '38870'
          },
          {
            group: '65 years and over',
            value: '3.36',
            male: '25799',
            female: '24807'
          }
        ],
        info: {
          name: 'Bahrain',
          alpha2Code: 'BH',
          alpha3Code: 'BHR',
          capital: 'Manama',
          region: 'Asia',
          subregion: 'Western Asia',
          latlng: [26, 50.55],
          demonym: 'Bahraini',
          area: 765,
          gini: null,
          borders: [],
          nativeName: '‏البحرين',
          translations: {
            de: 'Bahrain',
            es: 'Bahrein',
            fr: 'Bahreïn',
            ja: 'バーレーン',
            it: 'Bahrein',
            br: 'Bahrein',
            pt: 'Barém',
            nl: 'Bahrein',
            hr: 'Bahrein',
            fa: 'بحرین'
          },
          flag: 'https://restcountries.eu/data/bhr.svg'
        }
      },
      Bangladesh: {
        name: 'Bangladesh',
        slug: 'bangladesh',
        population: 164098818,
        domain: '.bd',
        sex: {
          male: 49.16,
          female: 50.84
        },
        age: [
          {
            group: '0-14 years',
            value: '26.48',
            male: '21918651',
            female: '21158574'
          },
          {
            group: '15-24 years',
            value: '18.56',
            male: '15186470',
            female: '15001950'
          },
          {
            group: '25-54 years',
            value: '40.72',
            male: '31694267',
            female: '34535643'
          },
          {
            group: '55-64 years',
            value: '7.41',
            male: '5941825',
            female: '6115856'
          },
          {
            group: '65 years and over',
            value: '6.82',
            male: '5218206',
            female: '5879411'
          }
        ],
        info: {
          name: 'Bangladesh',
          alpha2Code: 'BD',
          alpha3Code: 'BGD',
          capital: 'Dhaka',
          region: 'Asia',
          subregion: 'Southern Asia',
          latlng: [24, 90],
          demonym: 'Bangladeshi',
          area: 147570,
          gini: 32.1,
          borders: ['MMR', 'IND'],
          nativeName: 'Bangladesh',
          translations: {
            de: 'Bangladesch',
            es: 'Bangladesh',
            fr: 'Bangladesh',
            ja: 'バングラデシュ',
            it: 'Bangladesh',
            br: 'Bangladesh',
            pt: 'Bangladeche',
            nl: 'Bangladesh',
            hr: 'Bangladeš',
            fa: 'بنگلادش'
          },
          flag: 'https://restcountries.eu/data/bgd.svg'
        }
      },
      Barbados: {
        name: 'Barbados',
        slug: 'barbados',
        population: 301865,
        domain: '.bb',
        sex: {
          male: 48.33,
          female: 51.67
        },
        age: [
          {
            group: '0-14 years',
            value: '17.49',
            male: '25762',
            female: '25764'
          },
          {
            group: '15-24 years',
            value: '12.34',
            male: '18024',
            female: '18330'
          },
          {
            group: '25-54 years',
            value: '42.69',
            male: '62655',
            female: '63093'
          },
          {
            group: '55-64 years',
            value: '13.91',
            male: '19533',
            female: '21430'
          },
          {
            group: '65 years and over',
            value: '13.57',
            male: '16398',
            female: '23571'
          }
        ],
        info: {
          name: 'Barbados',
          alpha2Code: 'BB',
          alpha3Code: 'BRB',
          capital: 'Bridgetown',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [13.16666666, -59.53333333],
          demonym: 'Barbadian',
          area: 430,
          gini: null,
          borders: [],
          nativeName: 'Barbados',
          translations: {
            de: 'Barbados',
            es: 'Barbados',
            fr: 'Barbade',
            ja: 'バルバドス',
            it: 'Barbados',
            br: 'Barbados',
            pt: 'Barbados',
            nl: 'Barbados',
            hr: 'Barbados',
            fa: 'باربادوس'
          },
          flag: 'https://restcountries.eu/data/brb.svg'
        }
      },
      Belarus: {
        name: 'Belarus',
        slug: 'belarus',
        population: 9441842,
        domain: '.by',
        sex: {
          male: 46.52,
          female: 53.48
        },
        age: [
          {
            group: '0-14 years',
            value: '16.09',
            male: '784231',
            female: '740373'
          },
          {
            group: '15-24 years',
            value: '9.59',
            male: '467393',
            female: '441795'
          },
          {
            group: '25-54 years',
            value: '43.94',
            male: '2058648',
            female: '2105910'
          },
          {
            group: '55-64 years',
            value: '14.45',
            male: '605330',
            female: '763972'
          },
          {
            group: '65 years and over',
            value: '15.93',
            male: '493055',
            female: '1017211'
          }
        ],
        info: {
          name: 'Belarus',
          alpha2Code: 'BY',
          alpha3Code: 'BLR',
          capital: 'Minsk',
          region: 'Europe',
          subregion: 'Eastern Europe',
          latlng: [53, 28],
          demonym: 'Belarusian',
          area: 207600,
          gini: 26.5,
          borders: ['LVA', 'LTU', 'POL', 'RUS', 'UKR'],
          nativeName: 'Белару́сь',
          translations: {
            de: 'Weißrussland',
            es: 'Bielorrusia',
            fr: 'Biélorussie',
            ja: 'ベラルーシ',
            it: 'Bielorussia',
            br: 'Bielorrússia',
            pt: 'Bielorrússia',
            nl: 'Wit-Rusland',
            hr: 'Bjelorusija',
            fa: 'بلاروس'
          },
          flag: 'https://restcountries.eu/data/blr.svg'
        }
      },
      Belgium: {
        name: 'Belgium',
        slug: 'belgium',
        population: 11778842,
        domain: '.be',
        sex: {
          male: 49.29,
          female: 50.71
        },
        age: [
          {
            group: '0-14 years',
            value: '17.22',
            male: '1033383',
            female: '984624'
          },
          {
            group: '15-24 years',
            value: '11.2',
            male: '670724',
            female: '642145'
          },
          {
            group: '25-54 years',
            value: '39.23',
            male: '2319777',
            female: '2278450'
          },
          {
            group: '55-64 years',
            value: '13.14',
            male: '764902',
            female: '775454'
          },
          {
            group: '65 years and over',
            value: '19.21',
            male: '988148',
            female: '1263109'
          }
        ],
        info: {
          name: 'Belgium',
          alpha2Code: 'BE',
          alpha3Code: 'BEL',
          capital: 'Brussels',
          region: 'Europe',
          subregion: 'Western Europe',
          latlng: [50.83333333, 4],
          demonym: 'Belgian',
          area: 30528,
          gini: 33,
          borders: ['FRA', 'DEU', 'LUX', 'NLD'],
          nativeName: 'België',
          translations: {
            de: 'Belgien',
            es: 'Bélgica',
            fr: 'Belgique',
            ja: 'ベルギー',
            it: 'Belgio',
            br: 'Bélgica',
            pt: 'Bélgica',
            nl: 'België',
            hr: 'Belgija',
            fa: 'بلژیک'
          },
          flag: 'https://restcountries.eu/data/bel.svg'
        }
      },
      Belize: {
        name: 'Belize',
        slug: 'belize',
        population: 405633,
        domain: '.bz',
        sex: {
          male: 50.09,
          female: 49.91
        },
        age: [
          {
            group: '0-14 years',
            value: '32.57',
            male: '66454',
            female: '63700'
          },
          {
            group: '15-24 years',
            value: '19',
            male: '39238',
            female: '36683'
          },
          {
            group: '25-54 years',
            value: '37.72',
            male: '73440',
            female: '77300'
          },
          {
            group: '55-64 years',
            value: '6.18',
            male: '12235',
            female: '12444'
          },
          {
            group: '65 years and over',
            value: '4.53',
            male: '8781',
            female: '9323'
          }
        ],
        info: {
          name: 'Belize',
          alpha2Code: 'BZ',
          alpha3Code: 'BLZ',
          capital: 'Belmopan',
          region: 'Americas',
          subregion: 'Central America',
          latlng: [17.25, -88.75],
          demonym: 'Belizean',
          area: 22966,
          gini: 53.1,
          borders: ['GTM', 'MEX'],
          nativeName: 'Belize',
          translations: {
            de: 'Belize',
            es: 'Belice',
            fr: 'Belize',
            ja: 'ベリーズ',
            it: 'Belize',
            br: 'Belize',
            pt: 'Belize',
            nl: 'Belize',
            hr: 'Belize',
            fa: 'بلیز'
          },
          flag: 'https://restcountries.eu/data/blz.svg'
        }
      },
      Benin: {
        name: 'Benin',
        slug: 'benin',
        population: 13301694,
        domain: '.bj',
        sex: {
          male: 49.17,
          female: 50.83
        },
        age: [
          {
            group: '0-14 years',
            value: '45.56',
            male: '2955396',
            female: '2906079'
          },
          {
            group: '15-24 years',
            value: '20.36',
            male: '1300453',
            female: '1318880'
          },
          {
            group: '25-54 years',
            value: '28.54',
            male: '1735229',
            female: '1935839'
          },
          {
            group: '55-64 years',
            value: '3.15',
            male: '193548',
            female: '211427'
          },
          {
            group: '65 years and over',
            value: '2.39',
            male: '140513',
            female: '167270'
          }
        ],
        info: {
          name: 'Benin',
          alpha2Code: 'BJ',
          alpha3Code: 'BEN',
          capital: 'Porto-Novo',
          region: 'Africa',
          subregion: 'Western Africa',
          latlng: [9.5, 2.25],
          demonym: 'Beninese',
          area: 112622,
          gini: 38.6,
          borders: ['BFA', 'NER', 'NGA', 'TGO'],
          nativeName: 'Bénin',
          translations: {
            de: 'Benin',
            es: 'Benín',
            fr: 'Bénin',
            ja: 'ベナン',
            it: 'Benin',
            br: 'Benin',
            pt: 'Benim',
            nl: 'Benin',
            hr: 'Benin',
            fa: 'بنین'
          },
          flag: 'https://restcountries.eu/data/ben.svg'
        }
      },
      Bermuda: {
        name: 'Bermuda',
        slug: 'bermuda',
        population: 72084,
        domain: '.bm',
        sex: {
          male: 48.35,
          female: 51.65
        },
        age: [
          {
            group: '0-14 years',
            value: '16.7',
            male: '6053',
            female: '5928'
          },
          {
            group: '15-24 years',
            value: '11.88',
            male: '4290',
            female: '4235'
          },
          {
            group: '25-54 years',
            value: '35.31',
            male: '12758',
            female: '12575'
          },
          {
            group: '55-64 years',
            value: '16.37',
            male: '5560',
            female: '6185'
          },
          {
            group: '65 years and over',
            value: '19.74',
            male: '6032',
            female: '8134'
          }
        ],
        info: {
          name: 'Bermuda',
          alpha2Code: 'BM',
          alpha3Code: 'BMU',
          capital: 'Hamilton',
          region: 'Americas',
          subregion: 'Northern America',
          latlng: [32.33333333, -64.75],
          demonym: 'Bermudian',
          area: 54,
          gini: null,
          borders: [],
          nativeName: 'Bermuda',
          translations: {
            de: 'Bermuda',
            es: 'Bermudas',
            fr: 'Bermudes',
            ja: 'バミューダ',
            it: 'Bermuda',
            br: 'Bermudas',
            pt: 'Bermudas',
            nl: 'Bermuda',
            hr: 'Bermudi',
            fa: 'برمودا'
          },
          flag: 'https://restcountries.eu/data/bmu.svg'
        }
      },
      Bhutan: {
        name: 'Bhutan',
        slug: 'bhutan',
        population: 857423,
        domain: '.bt',
        sex: {
          male: 52.01,
          female: 47.99
        },
        age: [
          {
            group: '0-14 years',
            value: '24.52',
            male: '98113',
            female: '93740'
          },
          {
            group: '15-24 years',
            value: '17.77',
            male: '70768',
            female: '68211'
          },
          {
            group: '25-54 years',
            value: '44.72',
            male: '184500',
            female: '165374'
          },
          {
            group: '55-64 years',
            value: '6.39',
            male: '26714',
            female: '23280'
          },
          {
            group: '65 years and over',
            value: '6.6',
            male: '26797',
            female: '24821'
          }
        ],
        info: {
          name: 'Bhutan',
          alpha2Code: 'BT',
          alpha3Code: 'BTN',
          capital: 'Thimphu',
          region: 'Asia',
          subregion: 'Southern Asia',
          latlng: [27.5, 90.5],
          demonym: 'Bhutanese',
          area: 38394,
          gini: 38.1,
          borders: ['CHN', 'IND'],
          nativeName: 'ʼbrug-yul',
          translations: {
            de: 'Bhutan',
            es: 'Bután',
            fr: 'Bhoutan',
            ja: 'ブータン',
            it: 'Bhutan',
            br: 'Butão',
            pt: 'Butão',
            nl: 'Bhutan',
            hr: 'Butan',
            fa: 'بوتان'
          },
          flag: 'https://restcountries.eu/data/btn.svg'
        }
      },
      Bolivia: {
        name: 'Bolivia',
        slug: 'bolivia',
        population: 11758869,
        domain: '.bo',
        sex: {
          male: 49.48,
          female: 50.52
        },
        age: [
          {
            group: '0-14 years',
            value: '30.34',
            male: '1799925',
            female: '1731565'
          },
          {
            group: '15-24 years',
            value: '19.21',
            male: '1133120',
            female: '1103063'
          },
          {
            group: '25-54 years',
            value: '38.68',
            male: '2212096',
            female: '2289888'
          },
          {
            group: '55-64 years',
            value: '6.06',
            male: '323210',
            female: '382139'
          },
          {
            group: '65 years and over',
            value: '5.71',
            male: '291368',
            female: '373535'
          }
        ],
        info: {
          name: 'Bolivia (Plurinational State of)',
          alpha2Code: 'BO',
          alpha3Code: 'BOL',
          capital: 'Sucre',
          region: 'Americas',
          subregion: 'South America',
          latlng: [-17, -65],
          demonym: 'Bolivian',
          area: 1098581,
          gini: 56.3,
          borders: ['ARG', 'BRA', 'CHL', 'PRY', 'PER'],
          nativeName: 'Bolivia',
          translations: {
            de: 'Bolivien',
            es: 'Bolivia',
            fr: 'Bolivie',
            ja: 'ボリビア多民族国',
            it: 'Bolivia',
            br: 'Bolívia',
            pt: 'Bolívia',
            nl: 'Bolivia',
            hr: 'Bolivija',
            fa: 'بولیوی'
          },
          flag: 'https://restcountries.eu/data/bol.svg'
        }
      },
      'Bosnia-Herzegovina': {
        name: 'Bosnia and Herzegovina',
        slug: 'bosnia-and-herzegovina',
        population: 3824782,
        domain: '.ba',
        sex: {
          male: 48.74,
          female: 51.26
        },
        age: [
          {
            group: '0-14 years',
            value: '13.18',
            male: '261430',
            female: '244242'
          },
          {
            group: '15-24 years',
            value: '10.83',
            male: '214319',
            female: '201214'
          },
          {
            group: '25-54 years',
            value: '44.52',
            male: '859509',
            female: '848071'
          },
          {
            group: '55-64 years',
            value: '15.24',
            male: '284415',
            female: '300168'
          },
          {
            group: '65 years and over',
            value: '16.22',
            male: '249624',
            female: '372594'
          }
        ],
        info: {
          name: 'Bosnia and Herzegovina',
          alpha2Code: 'BA',
          alpha3Code: 'BIH',
          capital: 'Sarajevo',
          region: 'Europe',
          subregion: 'Southern Europe',
          latlng: [44, 18],
          demonym: 'Bosnian, Herzegovinian',
          area: 51209,
          gini: 36.2,
          borders: ['HRV', 'MNE', 'SRB'],
          nativeName: 'Bosna i Hercegovina',
          translations: {
            de: 'Bosnien und Herzegowina',
            es: 'Bosnia y Herzegovina',
            fr: 'Bosnie-Herzégovine',
            ja: 'ボスニア・ヘルツェゴビナ',
            it: 'Bosnia ed Erzegovina',
            br: 'Bósnia e Herzegovina',
            pt: 'Bósnia e Herzegovina',
            nl: 'Bosnië en Herzegovina',
            hr: 'Bosna i Hercegovina',
            fa: 'بوسنی و هرزگوین'
          },
          flag: 'https://restcountries.eu/data/bih.svg'
        }
      },
      Botswana: {
        name: 'Botswana',
        slug: 'botswana',
        population: 2350667,
        domain: '.bw',
        sex: {
          male: 48.04,
          female: 51.96
        },
        age: [
          {
            group: '0-14 years',
            value: '30.54',
            male: '357065',
            female: '350550'
          },
          {
            group: '15-24 years',
            value: '18.31',
            male: '208824',
            female: '215462'
          },
          {
            group: '25-54 years',
            value: '39.67',
            male: '434258',
            female: '484922'
          },
          {
            group: '55-64 years',
            value: '5.92',
            male: '59399',
            female: '77886'
          },
          {
            group: '65 years and over',
            value: '5.56',
            male: '53708',
            female: '75159'
          }
        ],
        info: {
          name: 'Botswana',
          alpha2Code: 'BW',
          alpha3Code: 'BWA',
          capital: 'Gaborone',
          region: 'Africa',
          subregion: 'Southern Africa',
          latlng: [-22, 24],
          demonym: 'Motswana',
          area: 582000,
          gini: 61,
          borders: ['NAM', 'ZAF', 'ZMB', 'ZWE'],
          nativeName: 'Botswana',
          translations: {
            de: 'Botswana',
            es: 'Botswana',
            fr: 'Botswana',
            ja: 'ボツワナ',
            it: 'Botswana',
            br: 'Botsuana',
            pt: 'Botsuana',
            nl: 'Botswana',
            hr: 'Bocvana',
            fa: 'بوتسوانا'
          },
          flag: 'https://restcountries.eu/data/bwa.svg'
        }
      },
      'Bouvet Island': {
        name: 'Bouvet Island',
        slug: 'bouvet-island',
        population: 0,
        domain: '.bv',
        info: {
          name: 'Bouvet Island',
          alpha2Code: 'BV',
          alpha3Code: 'BVT',
          capital: '',
          region: '',
          subregion: '',
          latlng: [-54.43333333, 3.4],
          demonym: '',
          area: 49,
          gini: null,
          borders: [],
          nativeName: 'Bouvetøya',
          translations: {
            de: 'Bouvetinsel',
            es: 'Isla Bouvet',
            fr: 'Île Bouvet',
            ja: 'ブーベ島',
            it: 'Isola Bouvet',
            br: 'Ilha Bouvet',
            pt: 'Ilha Bouvet',
            nl: 'Bouveteiland',
            hr: 'Otok Bouvet',
            fa: 'جزیره بووه'
          },
          flag: 'https://restcountries.eu/data/bvt.svg'
        }
      },
      Brazil: {
        name: 'Brazil',
        slug: 'brazil',
        population: 213445417,
        domain: '.br',
        sex: {
          male: 49.24,
          female: 50.76
        },
        age: [
          {
            group: '0-14 years',
            value: '21.11',
            male: '22790634',
            female: '21907018'
          },
          {
            group: '15-24 years',
            value: '16.06',
            male: '17254363',
            female: '16750581'
          },
          {
            group: '25-54 years',
            value: '43.83',
            male: '46070240',
            female: '46729640'
          },
          {
            group: '55-64 years',
            value: '9.78',
            male: '9802995',
            female: '10911140'
          },
          {
            group: '65 years and over',
            value: '9.21',
            male: '8323344',
            female: '11176018'
          }
        ],
        info: {
          name: 'Brazil',
          alpha2Code: 'BR',
          alpha3Code: 'BRA',
          capital: 'Brasília',
          region: 'Americas',
          subregion: 'South America',
          latlng: [-10, -55],
          demonym: 'Brazilian',
          area: 8515767,
          gini: 54.7,
          borders: [
            'ARG',
            'BOL',
            'COL',
            'GUF',
            'GUY',
            'PRY',
            'PER',
            'SUR',
            'URY',
            'VEN'
          ],
          nativeName: 'Brasil',
          translations: {
            de: 'Brasilien',
            es: 'Brasil',
            fr: 'Brésil',
            ja: 'ブラジル',
            it: 'Brasile',
            br: 'Brasil',
            pt: 'Brasil',
            nl: 'Brazilië',
            hr: 'Brazil',
            fa: 'برزیل'
          },
          flag: 'https://restcountries.eu/data/bra.svg'
        }
      },
      'British Indian Ocean Territory': {
        name: 'British Indian Ocean Territory',
        slug: 'british-indian-ocean-territory',
        population: 0,
        domain: '.io',
        info: {
          name: 'British Indian Ocean Territory',
          alpha2Code: 'IO',
          alpha3Code: 'IOT',
          capital: 'Diego Garcia',
          region: 'Africa',
          subregion: 'Eastern Africa',
          latlng: [-6, 71.5],
          demonym: 'Indian',
          area: 60,
          gini: null,
          borders: [],
          nativeName: 'British Indian Ocean Territory',
          translations: {
            de: 'Britisches Territorium im Indischen Ozean',
            es: 'Territorio Británico del Océano Índico',
            fr: "Territoire britannique de l'océan Indien",
            ja: 'イギリス領インド洋地域',
            it: "Territorio britannico dell'oceano indiano",
            br: 'Território Britânico do Oceano íÍdico',
            pt: 'Território Britânico do Oceano Índico',
            nl: 'Britse Gebieden in de Indische Oceaan',
            hr: 'Britanski Indijskooceanski teritorij',
            fa: 'قلمرو بریتانیا در اقیانوس هند'
          },
          flag: 'https://restcountries.eu/data/iot.svg'
        }
      },
      'British Virgin Islands': {
        name: 'British Virgin Islands',
        slug: 'british-virgin-islands',
        population: 37891,
        domain: '.vg',
        sex: {
          male: 47.47,
          female: 52.53
        },
        age: [
          {
            group: '0-14 years',
            value: '16.48',
            male: '3088',
            female: '3156'
          },
          {
            group: '15-24 years',
            value: '12.22',
            male: '2212',
            female: '2418'
          },
          {
            group: '25-54 years',
            value: '47.84',
            male: '8476',
            female: '9652'
          },
          {
            group: '55-64 years',
            value: '12.83',
            male: '2242',
            female: '2521'
          },
          {
            group: '65 years and over',
            value: '10.63',
            male: '1921',
            female: '2105'
          }
        ],
        info: {
          name: 'Virgin Islands (British)',
          alpha2Code: 'VG',
          alpha3Code: 'VGB',
          capital: 'Road Town',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [18.431383, -64.62305],
          demonym: 'Virgin Islander',
          area: 151,
          gini: null,
          borders: [],
          nativeName: 'British Virgin Islands',
          translations: {
            de: 'Britische Jungferninseln',
            es: 'Islas Vírgenes del Reino Unido',
            fr: 'Îles Vierges britanniques',
            ja: 'イギリス領ヴァージン諸島',
            it: 'Isole Vergini Britanniche',
            br: 'Ilhas Virgens Britânicas',
            pt: 'Ilhas Virgens Britânicas',
            nl: 'Britse Maagdeneilanden',
            hr: 'Britanski Djevičanski Otoci',
            fa: 'جزایر ویرجین بریتانیا'
          },
          flag: 'https://restcountries.eu/data/vgb.svg'
        }
      },
      Brunei: {
        name: 'Brunei',
        slug: 'brunei',
        population: 471103,
        domain: '.bn',
        sex: {
          male: 48.99,
          female: 51.01
        },
        age: [
          {
            group: '0-14 years',
            value: '22.41',
            male: '53653',
            female: '50446'
          },
          {
            group: '15-24 years',
            value: '16.14',
            male: '37394',
            female: '37559'
          },
          {
            group: '25-54 years',
            value: '47.21',
            male: '103991',
            female: '115291'
          },
          {
            group: '55-64 years',
            value: '8.34',
            male: '19159',
            female: '19585'
          },
          {
            group: '65 years and over',
            value: '5.9',
            male: '13333',
            female: '14067'
          }
        ],
        info: {
          name: 'Brunei Darussalam',
          alpha2Code: 'BN',
          alpha3Code: 'BRN',
          capital: 'Bandar Seri Begawan',
          region: 'Asia',
          subregion: 'South-Eastern Asia',
          latlng: [4.5, 114.66666666],
          demonym: 'Bruneian',
          area: 5765,
          gini: null,
          borders: ['MYS'],
          nativeName: 'Negara Brunei Darussalam',
          translations: {
            de: 'Brunei',
            es: 'Brunei',
            fr: 'Brunei',
            ja: 'ブルネイ・ダルサラーム',
            it: 'Brunei',
            br: 'Brunei',
            pt: 'Brunei',
            nl: 'Brunei',
            hr: 'Brunej',
            fa: 'برونئی'
          },
          flag: 'https://restcountries.eu/data/brn.svg'
        }
      },
      Bulgaria: {
        name: 'Bulgaria',
        slug: 'bulgaria',
        population: 6919180,
        domain: '.bg',
        sex: {
          male: 48.74,
          female: 51.26
        },
        age: [
          {
            group: '0-14 years',
            value: '14.52',
            male: '520190',
            female: '491506'
          },
          {
            group: '15-24 years',
            value: '9.4',
            male: '340306',
            female: '314241'
          },
          {
            group: '25-54 years',
            value: '42.87',
            male: '1538593',
            female: '1448080'
          },
          {
            group: '55-64 years',
            value: '13.15',
            male: '433943',
            female: '482474'
          },
          {
            group: '65 years and over',
            value: '20.06',
            male: '562513',
            female: '835053'
          }
        ],
        info: {
          name: 'Bulgaria',
          alpha2Code: 'BG',
          alpha3Code: 'BGR',
          capital: 'Sofia',
          region: 'Europe',
          subregion: 'Eastern Europe',
          latlng: [43, 25],
          demonym: 'Bulgarian',
          area: 110879,
          gini: 28.2,
          borders: ['GRC', 'MKD', 'ROU', 'SRB', 'TUR'],
          nativeName: 'България',
          translations: {
            de: 'Bulgarien',
            es: 'Bulgaria',
            fr: 'Bulgarie',
            ja: 'ブルガリア',
            it: 'Bulgaria',
            br: 'Bulgária',
            pt: 'Bulgária',
            nl: 'Bulgarije',
            hr: 'Bugarska',
            fa: 'بلغارستان'
          },
          flag: 'https://restcountries.eu/data/bgr.svg'
        }
      },
      'Burkina Faso': {
        name: 'Burkina Faso',
        slug: 'burkina-faso',
        population: 21382659,
        domain: '.bf',
        sex: {
          male: 48.88,
          female: 51.12
        },
        age: [
          {
            group: '0-14 years',
            value: '43.58',
            male: '4606350',
            female: '4473951'
          },
          {
            group: '15-24 years',
            value: '20.33',
            male: '2121012',
            female: '2114213'
          },
          {
            group: '25-54 years',
            value: '29.36',
            male: '2850621',
            female: '3265926'
          },
          {
            group: '55-64 years',
            value: '3.57',
            male: '321417',
            female: '423016'
          },
          {
            group: '65 years and over',
            value: '3.16',
            male: '284838',
            female: '374057'
          }
        ],
        info: {
          name: 'Burkina Faso',
          alpha2Code: 'BF',
          alpha3Code: 'BFA',
          capital: 'Ouagadougou',
          region: 'Africa',
          subregion: 'Western Africa',
          latlng: [13, -2],
          demonym: 'Burkinabe',
          area: 272967,
          gini: 39.8,
          borders: ['BEN', 'CIV', 'GHA', 'MLI', 'NER', 'TGO'],
          nativeName: 'Burkina Faso',
          translations: {
            de: 'Burkina Faso',
            es: 'Burkina Faso',
            fr: 'Burkina Faso',
            ja: 'ブルキナファソ',
            it: 'Burkina Faso',
            br: 'Burkina Faso',
            pt: 'Burquina Faso',
            nl: 'Burkina Faso',
            hr: 'Burkina Faso',
            fa: 'بورکینافاسو'
          },
          flag: 'https://restcountries.eu/data/bfa.svg'
        }
      },
      Burma: {
        name: 'Burma',
        slug: 'burma',
        population: 57069099,
        domain: '.mm',
        sex: {
          male: 49.32,
          female: 50.68
        },
        age: [
          {
            group: '0-14 years',
            value: '25.97',
            male: '7524869',
            female: '7173333'
          },
          {
            group: '15-24 years',
            value: '17',
            male: '4852122',
            female: '4769412'
          },
          {
            group: '25-54 years',
            value: '42.76',
            male: '11861971',
            female: '12337482'
          },
          {
            group: '55-64 years',
            value: '8.22',
            male: '2179616',
            female: '2472681'
          },
          {
            group: '65 years and over',
            value: '6.04',
            male: '1489807',
            female: '1928778'
          }
        ],
        info: {
          name: 'Myanmar',
          alpha2Code: 'MM',
          alpha3Code: 'MMR',
          capital: 'Naypyidaw',
          region: 'Asia',
          subregion: 'South-Eastern Asia',
          latlng: [22, 98],
          demonym: 'Burmese',
          area: 676578,
          gini: null,
          borders: ['BGD', 'CHN', 'IND', 'LAO', 'THA'],
          nativeName: 'Myanma',
          translations: {
            de: 'Myanmar',
            es: 'Myanmar',
            fr: 'Myanmar',
            ja: 'ミャンマー',
            it: 'Birmania',
            br: 'Myanmar',
            pt: 'Myanmar',
            nl: 'Myanmar',
            hr: 'Mijanmar',
            fa: 'میانمار'
          },
          flag: 'https://restcountries.eu/data/mmr.svg'
        }
      },
      Burundi: {
        name: 'Burundi',
        slug: 'burundi',
        population: 12241065,
        domain: '.bi',
        sex: {
          male: 49.66,
          female: 50.34
        },
        age: [
          {
            group: '0-14 years',
            value: '43.83',
            male: '2618868',
            female: '2581597'
          },
          {
            group: '15-24 years',
            value: '19.76',
            male: '1172858',
            female: '1171966'
          },
          {
            group: '25-54 years',
            value: '29.18',
            male: '1713985',
            female: '1748167'
          },
          {
            group: '55-64 years',
            value: '4.17',
            male: '231088',
            female: '264131'
          },
          {
            group: '65 years and over',
            value: '3.06',
            male: '155262',
            female: '207899'
          }
        ],
        info: {
          name: 'Burundi',
          alpha2Code: 'BI',
          alpha3Code: 'BDI',
          capital: 'Bujumbura',
          region: 'Africa',
          subregion: 'Eastern Africa',
          latlng: [-3.5, 30],
          demonym: 'Burundian',
          area: 27834,
          gini: 33.3,
          borders: ['COD', 'RWA', 'TZA'],
          nativeName: 'Burundi',
          translations: {
            de: 'Burundi',
            es: 'Burundi',
            fr: 'Burundi',
            ja: 'ブルンジ',
            it: 'Burundi',
            br: 'Burundi',
            pt: 'Burúndi',
            nl: 'Burundi',
            hr: 'Burundi',
            fa: 'بوروندی'
          },
          flag: 'https://restcountries.eu/data/bdi.svg'
        }
      },
      'Cabo Verde': {
        name: 'Cabo Verde',
        slug: 'cabo-verde',
        population: 589451,
        domain: '.cv',
        sex: {
          male: 48.58,
          female: 51.42
        },
        age: [
          {
            group: '0-14 years',
            value: '27.95',
            male: '82010',
            female: '81012'
          },
          {
            group: '15-24 years',
            value: '18.69',
            male: '54521',
            female: '54504'
          },
          {
            group: '25-54 years',
            value: '40.76',
            male: '115811',
            female: '121923'
          },
          {
            group: '55-64 years',
            value: '7.12',
            male: '18939',
            female: '22597'
          },
          {
            group: '65 years and over',
            value: '5.48',
            male: '12037',
            female: '19901'
          }
        ],
        info: {
          name: 'Cabo Verde',
          alpha2Code: 'CV',
          alpha3Code: 'CPV',
          capital: 'Praia',
          region: 'Africa',
          subregion: 'Western Africa',
          latlng: [16, -24],
          demonym: 'Cape Verdian',
          area: 4033,
          gini: 50.5,
          borders: [],
          nativeName: 'Cabo Verde',
          translations: {
            de: 'Kap Verde',
            es: 'Cabo Verde',
            fr: 'Cap Vert',
            ja: 'カーボベルデ',
            it: 'Capo Verde',
            br: 'Cabo Verde',
            pt: 'Cabo Verde',
            nl: 'Kaapverdië',
            hr: 'Zelenortska Republika',
            fa: 'کیپ ورد'
          },
          flag: 'https://restcountries.eu/data/cpv.svg'
        }
      },
      Cambodia: {
        name: 'Cambodia',
        slug: 'cambodia',
        population: 17304363,
        domain: '.kh',
        sex: {
          male: 48.68,
          female: 51.32
        },
        age: [
          {
            group: '0-14 years',
            value: '30.18',
            male: '2582427',
            female: '2525619'
          },
          {
            group: '15-24 years',
            value: '17.28',
            male: '1452784',
            female: '1472769'
          },
          {
            group: '25-54 years',
            value: '41.51',
            male: '3442051',
            female: '3584592'
          },
          {
            group: '55-64 years',
            value: '6.44',
            male: '476561',
            female: '612706'
          },
          {
            group: '65 years and over',
            value: '4.59',
            male: '287021',
            female: '490454'
          }
        ],
        info: {
          name: 'Cambodia',
          alpha2Code: 'KH',
          alpha3Code: 'KHM',
          capital: 'Phnom Penh',
          region: 'Asia',
          subregion: 'South-Eastern Asia',
          latlng: [13, 105],
          demonym: 'Cambodian',
          area: 181035,
          gini: 37.9,
          borders: ['LAO', 'THA', 'VNM'],
          nativeName: 'Kâmpŭchéa',
          translations: {
            de: 'Kambodscha',
            es: 'Camboya',
            fr: 'Cambodge',
            ja: 'カンボジア',
            it: 'Cambogia',
            br: 'Camboja',
            pt: 'Camboja',
            nl: 'Cambodja',
            hr: 'Kambodža',
            fa: 'کامبوج'
          },
          flag: 'https://restcountries.eu/data/khm.svg'
        }
      },
      Cameroon: {
        name: 'Cameroon',
        slug: 'cameroon',
        population: 28524175,
        domain: '.cm',
        sex: {
          male: 49.83,
          female: 50.17
        },
        age: [
          {
            group: '0-14 years',
            value: '42.34',
            male: '5927640',
            female: '5820226'
          },
          {
            group: '15-24 years',
            value: '20.04',
            male: '2782376',
            female: '2776873'
          },
          {
            group: '25-54 years',
            value: '30.64',
            male: '4191151',
            female: '4309483'
          },
          {
            group: '55-64 years',
            value: '3.87',
            male: '520771',
            female: '552801'
          },
          {
            group: '65 years and over',
            value: '3.11',
            male: '403420',
            female: '460248'
          }
        ],
        info: {
          name: 'Cameroon',
          alpha2Code: 'CM',
          alpha3Code: 'CMR',
          capital: 'Yaoundé',
          region: 'Africa',
          subregion: 'Middle Africa',
          latlng: [6, 12],
          demonym: 'Cameroonian',
          area: 475442,
          gini: 38.9,
          borders: ['CAF', 'TCD', 'COG', 'GNQ', 'GAB', 'NGA'],
          nativeName: 'Cameroon',
          translations: {
            de: 'Kamerun',
            es: 'Camerún',
            fr: 'Cameroun',
            ja: 'カメルーン',
            it: 'Camerun',
            br: 'Camarões',
            pt: 'Camarões',
            nl: 'Kameroen',
            hr: 'Kamerun',
            fa: 'کامرون'
          },
          flag: 'https://restcountries.eu/data/cmr.svg'
        }
      },
      Canada: {
        name: 'Canada',
        slug: 'canada',
        population: 37943231,
        domain: '.ca',
        sex: {
          male: 49.58,
          female: 50.42
        },
        age: [
          {
            group: '0-14 years',
            value: '15.99',
            male: '3094008',
            female: '2931953'
          },
          {
            group: '15-24 years',
            value: '11.14',
            male: '2167013',
            female: '2032064'
          },
          {
            group: '25-54 years',
            value: '39.81',
            male: '7527554',
            female: '7478737'
          },
          {
            group: '55-64 years',
            value: '14.08',
            male: '2624474',
            female: '2682858'
          },
          {
            group: '65 years and over',
            value: '18.98',
            male: '3274298',
            female: '3881126'
          }
        ],
        info: {
          name: 'Canada',
          alpha2Code: 'CA',
          alpha3Code: 'CAN',
          capital: 'Ottawa',
          region: 'Americas',
          subregion: 'Northern America',
          latlng: [60, -95],
          demonym: 'Canadian',
          area: 9984670,
          gini: 32.6,
          borders: ['USA'],
          nativeName: 'Canada',
          translations: {
            de: 'Kanada',
            es: 'Canadá',
            fr: 'Canada',
            ja: 'カナダ',
            it: 'Canada',
            br: 'Canadá',
            pt: 'Canadá',
            nl: 'Canada',
            hr: 'Kanada',
            fa: 'کانادا'
          },
          flag: 'https://restcountries.eu/data/can.svg'
        }
      },
      'Cayman Islands': {
        name: 'Cayman Islands',
        slug: 'cayman-islands',
        population: 63131,
        domain: '.ky',
        sex: {
          male: 48.67,
          female: 51.33
        },
        age: [
          {
            group: '0-14 years',
            value: '17.75',
            male: '5535',
            female: '5457'
          },
          {
            group: '15-24 years',
            value: '11.86',
            male: '3673',
            female: '3675'
          },
          {
            group: '25-54 years',
            value: '41.37',
            male: '12489',
            female: '13140'
          },
          {
            group: '55-64 years',
            value: '14.78',
            male: '4398',
            female: '4755'
          },
          {
            group: '65 years and over',
            value: '14.24',
            male: '4053',
            female: '4769'
          }
        ],
        info: {
          name: 'Cayman Islands',
          alpha2Code: 'KY',
          alpha3Code: 'CYM',
          capital: 'George Town',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [19.5, -80.5],
          demonym: 'Caymanian',
          area: 264,
          gini: null,
          borders: [],
          nativeName: 'Cayman Islands',
          translations: {
            de: 'Kaimaninseln',
            es: 'Islas Caimán',
            fr: 'Îles Caïmans',
            ja: 'ケイマン諸島',
            it: 'Isole Cayman',
            br: 'Ilhas Cayman',
            pt: 'Ilhas Caimão',
            nl: 'Caymaneilanden',
            hr: 'Kajmanski otoci',
            fa: 'جزایر کیمن'
          },
          flag: 'https://restcountries.eu/data/cym.svg'
        }
      },
      'Central African Republic': {
        name: 'Central African Republic',
        slug: 'central-african-republic',
        population: 5357984,
        domain: '.cf',
        sex: {
          male: 49.7,
          female: 50.3
        },
        age: [
          {
            group: '0-14 years',
            value: '39.49',
            male: '1188682',
            female: '1176958'
          },
          {
            group: '15-24 years',
            value: '19.89',
            male: '598567',
            female: '593075'
          },
          {
            group: '25-54 years',
            value: '32.95',
            male: '988077',
            female: '986019'
          },
          {
            group: '55-64 years',
            value: '4.32',
            male: '123895',
            female: '134829'
          },
          {
            group: '65 years and over',
            value: '3.35',
            male: '78017',
            female: '122736'
          }
        ],
        info: {
          name: 'Central African Republic',
          alpha2Code: 'CF',
          alpha3Code: 'CAF',
          capital: 'Bangui',
          region: 'Africa',
          subregion: 'Middle Africa',
          latlng: [7, 21],
          demonym: 'Central African',
          area: 622984,
          gini: 56.3,
          borders: ['CMR', 'TCD', 'COD', 'COG', 'SSD', 'SDN'],
          nativeName: 'Ködörösêse tî Bêafrîka',
          translations: {
            de: 'Zentralafrikanische Republik',
            es: 'República Centroafricana',
            fr: 'République centrafricaine',
            ja: '中央アフリカ共和国',
            it: 'Repubblica Centrafricana',
            br: 'República Centro-Africana',
            pt: 'República Centro-Africana',
            nl: 'Centraal-Afrikaanse Republiek',
            hr: 'Srednjoafrička Republika',
            fa: 'جمهوری آفریقای مرکزی'
          },
          flag: 'https://restcountries.eu/data/caf.svg'
        }
      },
      Chad: {
        name: 'Chad',
        slug: 'chad',
        population: 17414108,
        domain: '.td',
        sex: {
          male: 49.48,
          female: 50.52
        },
        age: [
          {
            group: '0-14 years',
            value: '47.43',
            male: '4050505',
            female: '3954413'
          },
          {
            group: '15-24 years',
            value: '19.77',
            male: '1676495',
            female: '1660417'
          },
          {
            group: '25-54 years',
            value: '27.14',
            male: '2208181',
            female: '2371490'
          },
          {
            group: '55-64 years',
            value: '3.24',
            male: '239634',
            female: '306477'
          },
          {
            group: '65 years and over',
            value: '2.43',
            male: '176658',
            female: '233087'
          }
        ],
        info: {
          name: 'Chad',
          alpha2Code: 'TD',
          alpha3Code: 'TCD',
          capital: "N'Djamena",
          region: 'Africa',
          subregion: 'Middle Africa',
          latlng: [15, 19],
          demonym: 'Chadian',
          area: 1284000,
          gini: 39.8,
          borders: ['CMR', 'CAF', 'LBY', 'NER', 'NGA', 'SSD'],
          nativeName: 'Tchad',
          translations: {
            de: 'Tschad',
            es: 'Chad',
            fr: 'Tchad',
            ja: 'チャド',
            it: 'Ciad',
            br: 'Chade',
            pt: 'Chade',
            nl: 'Tsjaad',
            hr: 'Čad',
            fa: 'چاد'
          },
          flag: 'https://restcountries.eu/data/tcd.svg'
        }
      },
      Chile: {
        name: 'Chile',
        slug: 'chile',
        population: 18307925,
        domain: '.cl',
        sex: {
          male: 49.15,
          female: 50.85
        },
        age: [
          {
            group: '0-14 years',
            value: '19.79',
            male: '1836240',
            female: '1763124'
          },
          {
            group: '15-24 years',
            value: '13.84',
            male: '1283710',
            female: '1233238'
          },
          {
            group: '25-54 years',
            value: '42.58',
            male: '3882405',
            female: '3860700'
          },
          {
            group: '55-64 years',
            value: '11.98',
            male: '1034049',
            female: '1145022'
          },
          {
            group: '65 years and over',
            value: '11.81',
            male: '902392',
            female: '1245890'
          }
        ],
        info: {
          name: 'Chile',
          alpha2Code: 'CL',
          alpha3Code: 'CHL',
          capital: 'Santiago',
          region: 'Americas',
          subregion: 'South America',
          latlng: [-30, -71],
          demonym: 'Chilean',
          area: 756102,
          gini: 52.1,
          borders: ['ARG', 'BOL', 'PER'],
          nativeName: 'Chile',
          translations: {
            de: 'Chile',
            es: 'Chile',
            fr: 'Chili',
            ja: 'チリ',
            it: 'Cile',
            br: 'Chile',
            pt: 'Chile',
            nl: 'Chili',
            hr: 'Čile',
            fa: 'شیلی'
          },
          flag: 'https://restcountries.eu/data/chl.svg'
        }
      },
      China: {
        name: 'China',
        slug: 'china',
        population: 1397897720,
        domain: '.cn',
        sex: {
          male: 51.34,
          female: 48.66
        },
        age: [
          {
            group: '0-14 years',
            value: '17.29',
            male: '129296339',
            female: '111782427'
          },
          {
            group: '15-24 years',
            value: '11.48',
            male: '86129841',
            female: '73876148'
          },
          {
            group: '25-54 years',
            value: '46.81',
            male: '333789731',
            female: '318711557'
          },
          {
            group: '55-64 years',
            value: '12.08',
            male: '84827645',
            female: '83557507'
          },
          {
            group: '65 years and over',
            value: '12.34',
            male: '81586490',
            female: '90458292'
          }
        ],
        info: {
          name: 'China',
          alpha2Code: 'CN',
          alpha3Code: 'CHN',
          capital: 'Beijing',
          region: 'Asia',
          subregion: 'Eastern Asia',
          latlng: [35, 105],
          demonym: 'Chinese',
          area: 9640011,
          gini: 47,
          borders: [
            'AFG',
            'BTN',
            'MMR',
            'HKG',
            'IND',
            'KAZ',
            'PRK',
            'KGZ',
            'LAO',
            'MAC',
            'MNG',
            'PAK',
            'RUS',
            'TJK',
            'VNM'
          ],
          nativeName: '中国',
          translations: {
            de: 'China',
            es: 'China',
            fr: 'Chine',
            ja: '中国',
            it: 'Cina',
            br: 'China',
            pt: 'China',
            nl: 'China',
            hr: 'Kina',
            fa: 'چین'
          },
          flag: 'https://restcountries.eu/data/chn.svg'
        }
      },
      'Christmas Island': {
        name: 'Christmas Island',
        slug: 'christmas-island',
        population: 2205,
        domain: '.cx',
        sex: {
          male: 70.75,
          female: 29.25
        },
        age: [
          {
            group: '0-14 years',
            value: '12.79',
            male: '147',
            female: '135'
          },
          {
            group: '15-24 years',
            value: '12.2',
            male: '202',
            female: '67'
          },
          {
            group: '25-54 years',
            value: '57.91',
            male: '955',
            female: '322'
          },
          {
            group: '55-64 years',
            value: '11.66',
            male: '172',
            female: '85'
          },
          {
            group: '65 years and over',
            value: '5.44',
            male: '84',
            female: '36'
          }
        ],
        info: {
          name: 'Christmas Island',
          alpha2Code: 'CX',
          alpha3Code: 'CXR',
          capital: 'Flying Fish Cove',
          region: 'Oceania',
          subregion: 'Australia and New Zealand',
          latlng: [-10.5, 105.66666666],
          demonym: 'Christmas Island',
          area: 135,
          gini: null,
          borders: [],
          nativeName: 'Christmas Island',
          translations: {
            de: 'Weihnachtsinsel',
            es: 'Isla de Navidad',
            fr: 'Île Christmas',
            ja: 'クリスマス島',
            it: 'Isola di Natale',
            br: 'Ilha Christmas',
            pt: 'Ilha do Natal',
            nl: 'Christmaseiland',
            hr: 'Božićni otok',
            fa: 'جزیره کریسمس'
          },
          flag: 'https://restcountries.eu/data/cxr.svg'
        }
      },
      'Clipperton Island': {
        name: 'Clipperton Island',
        slug: 'clipperton-island',
        population: 0
      },
      'Cocos (Keeling) Islands': {
        name: 'Cocos (Keeling) Islands',
        slug: 'cocos-keeling-islands',
        population: 596,
        domain: '.cc',
        info: {
          name: 'Cocos (Keeling) Islands',
          alpha2Code: 'CC',
          alpha3Code: 'CCK',
          capital: 'West Island',
          region: 'Oceania',
          subregion: 'Australia and New Zealand',
          latlng: [-12.5, 96.83333333],
          demonym: 'Cocos Islander',
          area: 14,
          gini: null,
          borders: [],
          nativeName: 'Cocos (Keeling) Islands',
          translations: {
            de: 'Kokosinseln',
            es: 'Islas Cocos o Islas Keeling',
            fr: 'Îles Cocos',
            ja: 'ココス（キーリング）諸島',
            it: 'Isole Cocos e Keeling',
            br: 'Ilhas Cocos',
            pt: 'Ilhas dos Cocos',
            nl: 'Cocoseilanden',
            hr: 'Kokosovi Otoci',
            fa: 'جزایر کوکوس'
          },
          flag: 'https://restcountries.eu/data/cck.svg'
        }
      },
      Colombia: {
        name: 'Colombia',
        slug: 'colombia',
        population: 50355650,
        domain: '.co',
        sex: {
          male: 49.42,
          female: 50.58
        },
        age: [
          {
            group: '0-14 years',
            value: '23.27',
            male: '5853351',
            female: '5567196'
          },
          {
            group: '15-24 years',
            value: '16.38',
            male: '4098421',
            female: '3939870'
          },
          {
            group: '25-54 years',
            value: '42.04',
            male: '10270516',
            female: '10365423'
          },
          {
            group: '55-64 years',
            value: '9.93',
            male: '2307705',
            female: '2566173'
          },
          {
            group: '65 years and over',
            value: '8.39',
            male: '1725461',
            female: '2390725'
          }
        ],
        info: {
          name: 'Colombia',
          alpha2Code: 'CO',
          alpha3Code: 'COL',
          capital: 'Bogotá',
          region: 'Americas',
          subregion: 'South America',
          latlng: [4, -72],
          demonym: 'Colombian',
          area: 1141748,
          gini: 55.9,
          borders: ['BRA', 'ECU', 'PAN', 'PER', 'VEN'],
          nativeName: 'Colombia',
          translations: {
            de: 'Kolumbien',
            es: 'Colombia',
            fr: 'Colombie',
            ja: 'コロンビア',
            it: 'Colombia',
            br: 'Colômbia',
            pt: 'Colômbia',
            nl: 'Colombia',
            hr: 'Kolumbija',
            fa: 'کلمبیا'
          },
          flag: 'https://restcountries.eu/data/col.svg'
        }
      },
      Comoros: {
        name: 'Comoros',
        slug: 'comoros',
        population: 864335,
        domain: '.km',
        sex: {
          male: 48.35,
          female: 51.65
        },
        age: [
          {
            group: '0-14 years',
            value: '36.68',
            male: '154853',
            female: '155602'
          },
          {
            group: '15-24 years',
            value: '20.75',
            male: '85208',
            female: '90422'
          },
          {
            group: '25-54 years',
            value: '33.99',
            male: '136484',
            female: '151178'
          },
          {
            group: '55-64 years',
            value: '4.49',
            male: '17237',
            female: '20781'
          },
          {
            group: '65 years and over',
            value: '4.08',
            male: '15437',
            female: '19079'
          }
        ],
        info: {
          name: 'Comoros',
          alpha2Code: 'KM',
          alpha3Code: 'COM',
          capital: 'Moroni',
          region: 'Africa',
          subregion: 'Eastern Africa',
          latlng: [-12.16666666, 44.25],
          demonym: 'Comoran',
          area: 1862,
          gini: 64.3,
          borders: [],
          nativeName: 'Komori',
          translations: {
            de: 'Union der Komoren',
            es: 'Comoras',
            fr: 'Comores',
            ja: 'コモロ',
            it: 'Comore',
            br: 'Comores',
            pt: 'Comores',
            nl: 'Comoren',
            hr: 'Komori',
            fa: 'کومور'
          },
          flag: 'https://restcountries.eu/data/com.svg'
        }
      },
      'Congo, Democratic Republic of the': {
        name: 'Congo, Democratic Republic of the',
        slug: 'congo-democratic-republic-of-the',
        population: 105044646,
        domain: '.cd',
        sex: {
          male: 49.97,
          female: 50.03
        },
        age: [
          {
            group: '0-14 years',
            value: '46.38',
            male: '23757297',
            female: '23449057'
          },
          {
            group: '15-24 years',
            value: '19.42',
            male: '9908686',
            female: '9856841'
          },
          {
            group: '25-54 years',
            value: '28.38',
            male: '14459453',
            female: '14422912'
          },
          {
            group: '55-64 years',
            value: '3.36',
            male: '1647267',
            female: '1769429'
          },
          {
            group: '65 years and over',
            value: '2.47',
            male: '1085539',
            female: '1423782'
          }
        ],
        info: {
          name: 'Congo (Democratic Republic of the)',
          alpha2Code: 'CD',
          alpha3Code: 'COD',
          capital: 'Kinshasa',
          region: 'Africa',
          subregion: 'Middle Africa',
          latlng: [0, 25],
          demonym: 'Congolese',
          area: 2344858,
          gini: null,
          borders: [
            'AGO',
            'BDI',
            'CAF',
            'COG',
            'RWA',
            'SSD',
            'TZA',
            'UGA',
            'ZMB'
          ],
          nativeName: 'République démocratique du Congo',
          translations: {
            de: 'Kongo (Dem. Rep.)',
            es: 'Congo (Rep. Dem.)',
            fr: 'Congo (Rép. dém.)',
            ja: 'コンゴ民主共和国',
            it: 'Congo (Rep. Dem.)',
            br: 'RD Congo',
            pt: 'RD Congo',
            nl: 'Congo [DRC]',
            hr: 'Kongo, Demokratska Republika',
            fa: 'جمهوری کنگو'
          },
          flag: 'https://restcountries.eu/data/cod.svg'
        }
      },
      'Congo, Republic of the': {
        name: 'Congo, Republic of the',
        slug: 'congo-republic-of-the',
        population: 5417414,
        domain: '.cg',
        sex: {
          male: 50.13,
          female: 49.87
        },
        age: [
          {
            group: '0-14 years',
            value: '41.57',
            male: '1110484',
            female: '1089732'
          },
          {
            group: '15-24 years',
            value: '17.14',
            male: '454981',
            female: '452204'
          },
          {
            group: '25-54 years',
            value: '33.5',
            male: '886743',
            female: '886312'
          },
          {
            group: '55-64 years',
            value: '4.59',
            male: '125207',
            female: '117810'
          },
          {
            group: '65 years and over',
            value: '3.2',
            male: '75921',
            female: '93676'
          }
        ],
        info: {
          name: 'Congo',
          alpha2Code: 'CG',
          alpha3Code: 'COG',
          capital: 'Brazzaville',
          region: 'Africa',
          subregion: 'Middle Africa',
          latlng: [-1, 15],
          demonym: 'Congolese',
          area: 342000,
          gini: 47.3,
          borders: ['AGO', 'CMR', 'CAF', 'COD', 'GAB'],
          nativeName: 'République du Congo',
          translations: {
            de: 'Kongo',
            es: 'Congo',
            fr: 'Congo',
            ja: 'コンゴ共和国',
            it: 'Congo',
            br: 'Congo',
            pt: 'Congo',
            nl: 'Congo [Republiek]',
            hr: 'Kongo',
            fa: 'کنگو'
          },
          flag: 'https://restcountries.eu/data/cog.svg'
        }
      },
      'Cook Islands': {
        name: 'Cook Islands',
        slug: 'cook-islands',
        population: 8327,
        domain: '.ck',
        sex: {
          male: 51.42,
          female: 48.58
        },
        age: [
          {
            group: '0-14 years',
            value: '19.93',
            male: '901',
            female: '808'
          },
          {
            group: '15-24 years',
            value: '14.89',
            male: '684',
            female: '593'
          },
          {
            group: '25-54 years',
            value: '37.66',
            male: '1595',
            female: '1634'
          },
          {
            group: '55-64 years',
            value: '14.15',
            male: '674',
            female: '539'
          },
          {
            group: '65 years and over',
            value: '13.37',
            male: '555',
            female: '591'
          }
        ],
        info: {
          name: 'Cook Islands',
          alpha2Code: 'CK',
          alpha3Code: 'COK',
          capital: 'Avarua',
          region: 'Oceania',
          subregion: 'Polynesia',
          latlng: [-21.23333333, -159.76666666],
          demonym: 'Cook Islander',
          area: 236,
          gini: null,
          borders: [],
          nativeName: 'Cook Islands',
          translations: {
            de: 'Cookinseln',
            es: 'Islas Cook',
            fr: 'Îles Cook',
            ja: 'クック諸島',
            it: 'Isole Cook',
            br: 'Ilhas Cook',
            pt: 'Ilhas Cook',
            nl: 'Cookeilanden',
            hr: 'Cookovo Otočje',
            fa: 'جزایر کوک'
          },
          flag: 'https://restcountries.eu/data/cok.svg'
        }
      },
      'Coral Sea Islands': {
        name: 'Coral Sea Islands',
        slug: 'coral-sea-islands',
        population: 0
      },
      'Costa Rica': {
        name: 'Costa Rica',
        slug: 'costa-rica',
        population: 5151140,
        domain: '.cr',
        sex: {
          male: 50.1,
          female: 49.9
        },
        age: [
          {
            group: '0-14 years',
            value: '22.08',
            male: '575731',
            female: '549802'
          },
          {
            group: '15-24 years',
            value: '15.19',
            male: '395202',
            female: '379277'
          },
          {
            group: '25-54 years',
            value: '43.98',
            male: '1130387',
            female: '1111791'
          },
          {
            group: '55-64 years',
            value: '9.99',
            male: '247267',
            female: '261847'
          },
          {
            group: '65 years and over',
            value: '8.76',
            male: '205463',
            female: '241221'
          }
        ],
        info: {
          name: 'Costa Rica',
          alpha2Code: 'CR',
          alpha3Code: 'CRI',
          capital: 'San José',
          region: 'Americas',
          subregion: 'Central America',
          latlng: [10, -84],
          demonym: 'Costa Rican',
          area: 51100,
          gini: 50.7,
          borders: ['NIC', 'PAN'],
          nativeName: 'Costa Rica',
          translations: {
            de: 'Costa Rica',
            es: 'Costa Rica',
            fr: 'Costa Rica',
            ja: 'コスタリカ',
            it: 'Costa Rica',
            br: 'Costa Rica',
            pt: 'Costa Rica',
            nl: 'Costa Rica',
            hr: 'Kostarika',
            fa: 'کاستاریکا'
          },
          flag: 'https://restcountries.eu/data/cri.svg'
        }
      },
      "Cote d'Ivoire": {
        name: "Cote d'Ivoire",
        slug: 'cote-divoire',
        population: 28088455,
        domain: '.ci',
        sex: {
          male: 50.21,
          female: 49.79
        },
        age: [
          {
            group: '0-14 years',
            value: '38.53',
            male: '5311971',
            female: '5276219'
          },
          {
            group: '15-24 years',
            value: '20.21',
            male: '2774374',
            female: '2779012'
          },
          {
            group: '25-54 years',
            value: '34.88',
            male: '4866957',
            female: '4719286'
          },
          {
            group: '55-64 years',
            value: '3.53',
            male: '494000',
            female: '476060'
          },
          {
            group: '65 years and over',
            value: '2.85',
            male: '349822',
            female: '433385'
          }
        ],
        info: {
          name: "Côte d'Ivoire",
          alpha2Code: 'CI',
          alpha3Code: 'CIV',
          capital: 'Yamoussoukro',
          region: 'Africa',
          subregion: 'Western Africa',
          latlng: [8, -5],
          demonym: 'Ivorian',
          area: 322463,
          gini: 41.5,
          borders: ['BFA', 'GHA', 'GIN', 'LBR', 'MLI'],
          nativeName: "Côte d'Ivoire",
          translations: {
            de: 'Elfenbeinküste',
            es: 'Costa de Marfil',
            fr: "Côte d'Ivoire",
            ja: 'コートジボワール',
            it: "Costa D'Avorio",
            br: 'Costa do Marfim',
            pt: 'Costa do Marfim',
            nl: 'Ivoorkust',
            hr: 'Obala Bjelokosti',
            fa: 'ساحل عاج'
          },
          flag: 'https://restcountries.eu/data/civ.svg'
        }
      },
      Croatia: {
        name: 'Croatia',
        slug: 'croatia',
        population: 4208973,
        domain: '.hr',
        sex: {
          male: 48.24,
          female: 51.76
        },
        age: [
          {
            group: '0-14 years',
            value: '14.16',
            male: '308668',
            female: '289996'
          },
          {
            group: '15-24 years',
            value: '10.76',
            male: '233602',
            female: '221495'
          },
          {
            group: '25-54 years',
            value: '39.77',
            male: '841930',
            female: '839601'
          },
          {
            group: '55-64 years',
            value: '14.24',
            male: '290982',
            female: '310969'
          },
          {
            group: '65 years and over',
            value: '21.06',
            male: '364076',
            female: '526427'
          }
        ],
        info: {
          name: 'Croatia',
          alpha2Code: 'HR',
          alpha3Code: 'HRV',
          capital: 'Zagreb',
          region: 'Europe',
          subregion: 'Southern Europe',
          latlng: [45.16666666, 15.5],
          demonym: 'Croatian',
          area: 56594,
          gini: 33.7,
          borders: ['BIH', 'HUN', 'MNE', 'SRB', 'SVN'],
          nativeName: 'Hrvatska',
          translations: {
            de: 'Kroatien',
            es: 'Croacia',
            fr: 'Croatie',
            ja: 'クロアチア',
            it: 'Croazia',
            br: 'Croácia',
            pt: 'Croácia',
            nl: 'Kroatië',
            hr: 'Hrvatska',
            fa: 'کرواسی'
          },
          flag: 'https://restcountries.eu/data/hrv.svg'
        }
      },
      Cuba: {
        name: 'Cuba',
        slug: 'cuba',
        population: 11032343,
        domain: '.cu',
        sex: {
          male: 49.72,
          female: 50.28
        },
        age: [
          {
            group: '0-14 years',
            value: '16.34',
            male: '929927',
            female: '877035'
          },
          {
            group: '15-24 years',
            value: '11.81',
            male: '678253',
            female: '627384'
          },
          {
            group: '25-54 years',
            value: '41.95',
            male: '2335680',
            female: '2303793'
          },
          {
            group: '55-64 years',
            value: '14.11',
            male: '760165',
            female: '799734'
          },
          {
            group: '65 years and over',
            value: '15.8',
            male: '794743',
            female: '952348'
          }
        ],
        info: {
          name: 'Cuba',
          alpha2Code: 'CU',
          alpha3Code: 'CUB',
          capital: 'Havana',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [21.5, -80],
          demonym: 'Cuban',
          area: 109884,
          gini: null,
          borders: [],
          nativeName: 'Cuba',
          translations: {
            de: 'Kuba',
            es: 'Cuba',
            fr: 'Cuba',
            ja: 'キューバ',
            it: 'Cuba',
            br: 'Cuba',
            pt: 'Cuba',
            nl: 'Cuba',
            hr: 'Kuba',
            fa: 'کوبا'
          },
          flag: 'https://restcountries.eu/data/cub.svg'
        }
      },
      Curacao: {
        name: 'Curacao',
        slug: 'curacao',
        population: 151885,
        domain: '.cw',
        sex: {
          male: 48.01,
          female: 51.99
        },
        age: [
          {
            group: '0-14 years',
            value: '19.68',
            male: '15227',
            female: '14553'
          },
          {
            group: '15-24 years',
            value: '13.38',
            male: '10438',
            female: '9806'
          },
          {
            group: '25-54 years',
            value: '36.55',
            male: '27733',
            female: '27589'
          },
          {
            group: '55-64 years',
            value: '13.88',
            male: '9130',
            female: '11873'
          },
          {
            group: '65 years and over',
            value: '16.52',
            male: '10127',
            female: '14869'
          }
        ],
        info: {
          name: 'Curaçao',
          alpha2Code: 'CW',
          alpha3Code: 'CUW',
          capital: 'Willemstad',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [12.116667, -68.933333],
          demonym: 'Dutch',
          area: 444,
          gini: null,
          borders: [],
          nativeName: 'Curaçao',
          translations: {
            de: 'Curaçao',
            es: null,
            fr: 'Curaçao',
            ja: null,
            it: 'Curaçao',
            br: 'Curaçao',
            pt: 'Curaçao',
            nl: 'Curaçao',
            hr: null,
            fa: 'کوراسائو'
          },
          flag: 'https://restcountries.eu/data/cuw.svg'
        }
      },
      Cyprus: {
        name: 'Cyprus',
        slug: 'cyprus',
        population: 1281506,
        domain: '.cy',
        sex: {
          male: 51.09,
          female: 48.91
        },
        age: [
          {
            group: '0-14 years',
            value: '15.69',
            male: '102095',
            female: '96676'
          },
          {
            group: '15-24 years',
            value: '12.29',
            male: '84832',
            female: '70879'
          },
          {
            group: '25-54 years',
            value: '47.12',
            male: '316710',
            female: '280167'
          },
          {
            group: '55-64 years',
            value: '11.92',
            male: '72476',
            female: '78511'
          },
          {
            group: '65 years and over',
            value: '12.97',
            male: '71053',
            female: '93277'
          }
        ],
        info: {
          name: 'Cyprus',
          alpha2Code: 'CY',
          alpha3Code: 'CYP',
          capital: 'Nicosia',
          region: 'Europe',
          subregion: 'Southern Europe',
          latlng: [35, 33],
          demonym: 'Cypriot',
          area: 9251,
          gini: null,
          borders: ['GBR'],
          nativeName: 'Κύπρος',
          translations: {
            de: 'Zypern',
            es: 'Chipre',
            fr: 'Chypre',
            ja: 'キプロス',
            it: 'Cipro',
            br: 'Chipre',
            pt: 'Chipre',
            nl: 'Cyprus',
            hr: 'Cipar',
            fa: 'قبرس'
          },
          flag: 'https://restcountries.eu/data/cyp.svg'
        }
      },
      'Czech Republic': {
        name: 'Czechia',
        slug: 'czechia',
        population: 10702596,
        domain: '.cz',
        sex: {
          male: 49.23,
          female: 50.77
        },
        age: [
          {
            group: '0-14 years',
            value: '15.17',
            male: '834447',
            female: '789328'
          },
          {
            group: '15-24 years',
            value: '9.2',
            male: '508329',
            female: '475846'
          },
          {
            group: '25-54 years',
            value: '43.29',
            male: '2382899',
            female: '2249774'
          },
          {
            group: '55-64 years',
            value: '12.12',
            male: '636357',
            female: '660748'
          },
          {
            group: '65 years and over',
            value: '20.23',
            male: '907255',
            female: '1257515'
          }
        ],
        info: {
          name: 'Czech Republic',
          alpha2Code: 'CZ',
          alpha3Code: 'CZE',
          capital: 'Prague',
          region: 'Europe',
          subregion: 'Eastern Europe',
          latlng: [49.75, 15.5],
          demonym: 'Czech',
          area: 78865,
          gini: 26,
          borders: ['AUT', 'DEU', 'POL', 'SVK'],
          nativeName: 'Česká republika',
          translations: {
            de: 'Tschechische Republik',
            es: 'República Checa',
            fr: 'République tchèque',
            ja: 'チェコ',
            it: 'Repubblica Ceca',
            br: 'República Tcheca',
            pt: 'República Checa',
            nl: 'Tsjechië',
            hr: 'Češka',
            fa: 'جمهوری چک'
          },
          flag: 'https://restcountries.eu/data/cze.svg'
        }
      },
      Denmark: {
        name: 'Denmark',
        slug: 'denmark',
        population: 5894687,
        domain: '.dk',
        sex: {
          male: 49.81,
          female: 50.19
        },
        age: [
          {
            group: '0-14 years',
            value: '16.42',
            male: '494806',
            female: '469005'
          },
          {
            group: '15-24 years',
            value: '12.33',
            male: '370557',
            female: '352977'
          },
          {
            group: '25-54 years',
            value: '38.71',
            male: '1149991',
            female: '1122016'
          },
          {
            group: '55-64 years',
            value: '12.63',
            male: '370338',
            female: '371149'
          },
          {
            group: '65 years and over',
            value: '19.91',
            male: '538096',
            female: '630475'
          }
        ],
        info: {
          name: 'Denmark',
          alpha2Code: 'DK',
          alpha3Code: 'DNK',
          capital: 'Copenhagen',
          region: 'Europe',
          subregion: 'Northern Europe',
          latlng: [56, 10],
          demonym: 'Danish',
          area: 43094,
          gini: 24,
          borders: ['DEU'],
          nativeName: 'Danmark',
          translations: {
            de: 'Dänemark',
            es: 'Dinamarca',
            fr: 'Danemark',
            ja: 'デンマーク',
            it: 'Danimarca',
            br: 'Dinamarca',
            pt: 'Dinamarca',
            nl: 'Denemarken',
            hr: 'Danska',
            fa: 'دانمارک'
          },
          flag: 'https://restcountries.eu/data/dnk.svg'
        }
      },
      Dhekelia: {
        name: 'Dhekelia',
        slug: 'dhekelia',
        population: 0
      },
      Djibouti: {
        name: 'Djibouti',
        slug: 'djibouti',
        population: 938413,
        domain: '.dj',
        sex: {
          male: 45.48,
          female: 54.52
        },
        age: [
          {
            group: '0-14 years',
            value: '29.97',
            male: '138701',
            female: '137588'
          },
          {
            group: '15-24 years',
            value: '20.32',
            male: '88399',
            female: '98955'
          },
          {
            group: '25-54 years',
            value: '40.73',
            male: '156016',
            female: '219406'
          },
          {
            group: '55-64 years',
            value: '5.01',
            male: '19868',
            female: '26307'
          },
          {
            group: '65 years and over',
            value: '3.97',
            male: '16245',
            female: '20319'
          }
        ],
        info: {
          name: 'Djibouti',
          alpha2Code: 'DJ',
          alpha3Code: 'DJI',
          capital: 'Djibouti',
          region: 'Africa',
          subregion: 'Eastern Africa',
          latlng: [11.5, 43],
          demonym: 'Djibouti',
          area: 23200,
          gini: 40,
          borders: ['ERI', 'ETH', 'SOM'],
          nativeName: 'Djibouti',
          translations: {
            de: 'Dschibuti',
            es: 'Yibuti',
            fr: 'Djibouti',
            ja: 'ジブチ',
            it: 'Gibuti',
            br: 'Djibuti',
            pt: 'Djibuti',
            nl: 'Djibouti',
            hr: 'Džibuti',
            fa: 'جیبوتی'
          },
          flag: 'https://restcountries.eu/data/dji.svg'
        }
      },
      Dominica: {
        name: 'Dominica',
        slug: 'dominica',
        population: 74584,
        domain: '.dm',
        sex: {
          male: 50.51,
          female: 49.49
        },
        age: [
          {
            group: '0-14 years',
            value: '21.41',
            male: '8135',
            female: '7760'
          },
          {
            group: '15-24 years',
            value: '13.15',
            male: '5017',
            female: '4746'
          },
          {
            group: '25-54 years',
            value: '42.79',
            male: '16133',
            female: '15637'
          },
          {
            group: '55-64 years',
            value: '10.53',
            male: '4089',
            female: '3731'
          },
          {
            group: '65 years and over',
            value: '12.12',
            male: '4128',
            female: '4867'
          }
        ],
        info: {
          name: 'Dominica',
          alpha2Code: 'DM',
          alpha3Code: 'DMA',
          capital: 'Roseau',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [15.41666666, -61.33333333],
          demonym: 'Dominican',
          area: 751,
          gini: null,
          borders: [],
          nativeName: 'Dominica',
          translations: {
            de: 'Dominica',
            es: 'Dominica',
            fr: 'Dominique',
            ja: 'ドミニカ国',
            it: 'Dominica',
            br: 'Dominica',
            pt: 'Dominica',
            nl: 'Dominica',
            hr: 'Dominika',
            fa: 'دومینیکا'
          },
          flag: 'https://restcountries.eu/data/dma.svg'
        }
      },
      'The Dominican Republic': {
        name: 'Dominican Republic',
        slug: 'dominican-republic',
        population: 10597348,
        domain: '.do',
        sex: {
          male: 50.56,
          female: 49.44
        },
        age: [
          {
            group: '0-14 years',
            value: '26.85',
            male: '1433166',
            female: '1385987'
          },
          {
            group: '15-24 years',
            value: '18.15',
            male: '968391',
            female: '937227'
          },
          {
            group: '25-54 years',
            value: '40.54',
            male: '2168122',
            female: '2088926'
          },
          {
            group: '55-64 years',
            value: '8.17',
            male: '429042',
            female: '428508'
          },
          {
            group: '65 years and over',
            value: '6.29',
            male: '310262',
            female: '350076'
          }
        ],
        info: {
          name: 'Dominican Republic',
          alpha2Code: 'DO',
          alpha3Code: 'DOM',
          capital: 'Santo Domingo',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [19, -70.66666666],
          demonym: 'Dominican',
          area: 48671,
          gini: 47.2,
          borders: ['HTI'],
          nativeName: 'República Dominicana',
          translations: {
            de: 'Dominikanische Republik',
            es: 'República Dominicana',
            fr: 'République dominicaine',
            ja: 'ドミニカ共和国',
            it: 'Repubblica Dominicana',
            br: 'República Dominicana',
            pt: 'República Dominicana',
            nl: 'Dominicaanse Republiek',
            hr: 'Dominikanska Republika',
            fa: 'جمهوری دومینیکن'
          },
          flag: 'https://restcountries.eu/data/dom.svg'
        }
      },
      Ecuador: {
        name: 'Ecuador',
        slug: 'ecuador',
        population: 17093159,
        domain: '.ec',
        sex: {
          male: 49.62,
          female: 50.38
        },
        age: [
          {
            group: '0-14 years',
            value: '25.82',
            male: '2226240',
            female: '2138219'
          },
          {
            group: '15-24 years',
            value: '17.8',
            male: '1531545',
            female: '1478222'
          },
          {
            group: '25-54 years',
            value: '40.31',
            male: '3333650',
            female: '3480262'
          },
          {
            group: '55-64 years',
            value: '7.92',
            male: '647718',
            female: '691759'
          },
          {
            group: '65 years and over',
            value: '8.15',
            male: '648761',
            female: '728491'
          }
        ],
        info: {
          name: 'Ecuador',
          alpha2Code: 'EC',
          alpha3Code: 'ECU',
          capital: 'Quito',
          region: 'Americas',
          subregion: 'South America',
          latlng: [-2, -77.5],
          demonym: 'Ecuadorean',
          area: 276841,
          gini: 49.3,
          borders: ['COL', 'PER'],
          nativeName: 'Ecuador',
          translations: {
            de: 'Ecuador',
            es: 'Ecuador',
            fr: 'Équateur',
            ja: 'エクアドル',
            it: 'Ecuador',
            br: 'Equador',
            pt: 'Equador',
            nl: 'Ecuador',
            hr: 'Ekvador',
            fa: 'اکوادور'
          },
          flag: 'https://restcountries.eu/data/ecu.svg'
        }
      },
      Egypt: {
        name: 'Egypt',
        slug: 'egypt',
        population: 106437241,
        domain: '.eg',
        sex: {
          male: 51.1,
          female: 48.9
        },
        age: [
          {
            group: '0-14 years',
            value: '33.62',
            male: '18112550',
            female: '16889155'
          },
          {
            group: '15-24 years',
            value: '18.01',
            male: '9684437',
            female: '9071163'
          },
          {
            group: '25-54 years',
            value: '37.85',
            male: '20032310',
            female: '19376847'
          },
          {
            group: '55-64 years',
            value: '6.08',
            male: '3160438',
            female: '3172544'
          },
          {
            group: '65 years and over',
            value: '4.44',
            male: '2213539',
            female: '2411457'
          }
        ],
        info: {
          name: 'Egypt',
          alpha2Code: 'EG',
          alpha3Code: 'EGY',
          capital: 'Cairo',
          region: 'Africa',
          subregion: 'Northern Africa',
          latlng: [27, 30],
          demonym: 'Egyptian',
          area: 1002450,
          gini: 30.8,
          borders: ['ISR', 'LBY', 'SDN'],
          nativeName: 'مصر‎',
          translations: {
            de: 'Ägypten',
            es: 'Egipto',
            fr: 'Égypte',
            ja: 'エジプト',
            it: 'Egitto',
            br: 'Egito',
            pt: 'Egipto',
            nl: 'Egypte',
            hr: 'Egipat',
            fa: 'مصر'
          },
          flag: 'https://restcountries.eu/data/egy.svg'
        }
      },
      'El Salvador': {
        name: 'El Salvador',
        slug: 'el-salvador',
        population: 6528135,
        domain: '.sv',
        sex: {
          male: 48,
          female: 52
        },
        age: [
          {
            group: '0-14 years',
            value: '25.83',
            male: '857003',
            female: '817336'
          },
          {
            group: '15-24 years',
            value: '18.82',
            male: '619368',
            female: '600501'
          },
          {
            group: '25-54 years',
            value: '40.51',
            male: '1221545',
            female: '1404163'
          },
          {
            group: '55-64 years',
            value: '7.23',
            male: '198029',
            female: '270461'
          },
          {
            group: '65 years and over',
            value: '7.6',
            male: '214717',
            female: '277979'
          }
        ],
        info: {
          name: 'El Salvador',
          alpha2Code: 'SV',
          alpha3Code: 'SLV',
          capital: 'San Salvador',
          region: 'Americas',
          subregion: 'Central America',
          latlng: [13.83333333, -88.91666666],
          demonym: 'Salvadoran',
          area: 21041,
          gini: 48.3,
          borders: ['GTM', 'HND'],
          nativeName: 'El Salvador',
          translations: {
            de: 'El Salvador',
            es: 'El Salvador',
            fr: 'Salvador',
            ja: 'エルサルバドル',
            it: 'El Salvador',
            br: 'El Salvador',
            pt: 'El Salvador',
            nl: 'El Salvador',
            hr: 'Salvador',
            fa: 'السالوادور'
          },
          flag: 'https://restcountries.eu/data/slv.svg'
        }
      },
      'Equatorial Guinea': {
        name: 'Equatorial Guinea',
        slug: 'equatorial-guinea',
        population: 857008,
        domain: '.gq',
        sex: {
          male: 49.94,
          female: 50.06
        },
        age: [
          {
            group: '0-14 years',
            value: '38.73',
            male: '164417',
            female: '159400'
          },
          {
            group: '15-24 years',
            value: '19.94',
            male: '84820',
            female: '81880'
          },
          {
            group: '25-54 years',
            value: '32.72',
            male: '137632',
            female: '135973'
          },
          {
            group: '55-64 years',
            value: '4.69',
            male: '17252',
            female: '22006'
          },
          {
            group: '65 years and over',
            value: '3.92',
            male: '13464',
            female: '19334'
          }
        ],
        info: {
          name: 'Equatorial Guinea',
          alpha2Code: 'GQ',
          alpha3Code: 'GNQ',
          capital: 'Malabo',
          region: 'Africa',
          subregion: 'Middle Africa',
          latlng: [2, 10],
          demonym: 'Equatorial Guinean',
          area: 28051,
          gini: null,
          borders: ['CMR', 'GAB'],
          nativeName: 'Guinea Ecuatorial',
          translations: {
            de: 'Äquatorial-Guinea',
            es: 'Guinea Ecuatorial',
            fr: 'Guinée-Équatoriale',
            ja: '赤道ギニア',
            it: 'Guinea Equatoriale',
            br: 'Guiné Equatorial',
            pt: 'Guiné Equatorial',
            nl: 'Equatoriaal-Guinea',
            hr: 'Ekvatorijalna Gvineja',
            fa: 'گینه استوایی'
          },
          flag: 'https://restcountries.eu/data/gnq.svg'
        }
      },
      Eritrea: {
        name: 'Eritrea',
        slug: 'eritrea',
        population: 6147398,
        domain: '.er',
        sex: {
          male: 49.23,
          female: 50.77
        },
        age: [
          {
            group: '0-14 years',
            value: '38.23',
            male: '1169456',
            female: '1155460'
          },
          {
            group: '15-24 years',
            value: '20.56',
            male: '622172',
            female: '627858'
          },
          {
            group: '25-54 years',
            value: '33.42',
            male: '997693',
            female: '1034550'
          },
          {
            group: '55-64 years',
            value: '3.8',
            male: '105092',
            female: '125735'
          },
          {
            group: '65 years and over',
            value: '4',
            male: '99231',
            female: '143949'
          }
        ],
        info: {
          name: 'Eritrea',
          alpha2Code: 'ER',
          alpha3Code: 'ERI',
          capital: 'Asmara',
          region: 'Africa',
          subregion: 'Eastern Africa',
          latlng: [15, 39],
          demonym: 'Eritrean',
          area: 117600,
          gini: null,
          borders: ['DJI', 'ETH', 'SDN'],
          nativeName: 'ኤርትራ',
          translations: {
            de: 'Eritrea',
            es: 'Eritrea',
            fr: 'Érythrée',
            ja: 'エリトリア',
            it: 'Eritrea',
            br: 'Eritreia',
            pt: 'Eritreia',
            nl: 'Eritrea',
            hr: 'Eritreja',
            fa: 'اریتره'
          },
          flag: 'https://restcountries.eu/data/eri.svg'
        }
      },
      Estonia: {
        name: 'Estonia',
        slug: 'estonia',
        population: 1220042,
        domain: '.ee',
        sex: {
          male: 46.92,
          female: 53.08
        },
        age: [
          {
            group: '0-14 years',
            value: '16.22',
            male: '102191',
            female: '97116'
          },
          {
            group: '15-24 years',
            value: '8.86',
            male: '56484',
            female: '52378'
          },
          {
            group: '25-54 years',
            value: '40.34',
            male: '252273',
            female: '243382'
          },
          {
            group: '55-64 years',
            value: '13.58',
            male: '76251',
            female: '90576'
          },
          {
            group: '65 years and over',
            value: '21',
            male: '89211',
            female: '168762'
          }
        ],
        info: {
          name: 'Estonia',
          alpha2Code: 'EE',
          alpha3Code: 'EST',
          capital: 'Tallinn',
          region: 'Europe',
          subregion: 'Northern Europe',
          latlng: [59, 26],
          demonym: 'Estonian',
          area: 45227,
          gini: 36,
          borders: ['LVA', 'RUS'],
          nativeName: 'Eesti',
          translations: {
            de: 'Estland',
            es: 'Estonia',
            fr: 'Estonie',
            ja: 'エストニア',
            it: 'Estonia',
            br: 'Estônia',
            pt: 'Estónia',
            nl: 'Estland',
            hr: 'Estonija',
            fa: 'استونی'
          },
          flag: 'https://restcountries.eu/data/est.svg'
        }
      },
      Eswatini: {
        name: 'Eswatini',
        slug: 'eswatini',
        population: 1113276,
        domain: '.sz',
        sex: {
          male: 47.31,
          female: 52.69
        },
        age: [
          {
            group: '0-14 years',
            value: '33.63',
            male: '185640',
            female: '185808'
          },
          {
            group: '15-24 years',
            value: '18.71',
            male: '98029',
            female: '108654'
          },
          {
            group: '25-54 years',
            value: '39.46',
            male: '202536',
            female: '233275'
          },
          {
            group: '55-64 years',
            value: '4.36',
            male: '20529',
            female: '27672'
          },
          {
            group: '65 years and over',
            value: '3.83',
            male: '15833',
            female: '26503'
          }
        ],
        info: {
          name: 'Swaziland',
          alpha2Code: 'SZ',
          alpha3Code: 'SWZ',
          capital: 'Lobamba',
          region: 'Africa',
          subregion: 'Southern Africa',
          latlng: [-26.5, 31.5],
          demonym: 'Swazi',
          area: 17364,
          gini: 51.5,
          borders: ['MOZ', 'ZAF'],
          nativeName: 'Swaziland',
          translations: {
            de: 'Swasiland',
            es: 'Suazilandia',
            fr: 'Swaziland',
            ja: 'スワジランド',
            it: 'Swaziland',
            br: 'Suazilândia',
            pt: 'Suazilândia',
            nl: 'Swaziland',
            hr: 'Svazi',
            fa: 'سوازیلند'
          },
          flag: 'https://restcountries.eu/data/swz.svg'
        }
      },
      Ethiopia: {
        name: 'Ethiopia',
        slug: 'ethiopia',
        population: 110871031,
        domain: '.et',
        sex: {
          male: 49.87,
          female: 50.13
        },
        age: [
          {
            group: '0-14 years',
            value: '39.81',
            male: '21657152',
            female: '21381628'
          },
          {
            group: '15-24 years',
            value: '19.47',
            male: '10506144',
            female: '10542128'
          },
          {
            group: '25-54 years',
            value: '32.92',
            male: '17720540',
            female: '17867298'
          },
          {
            group: '55-64 years',
            value: '4.42',
            male: '2350606',
            female: '2433319'
          },
          {
            group: '65 years and over',
            value: '3.38',
            male: '1676478',
            female: '1977857'
          }
        ],
        info: {
          name: 'Ethiopia',
          alpha2Code: 'ET',
          alpha3Code: 'ETH',
          capital: 'Addis Ababa',
          region: 'Africa',
          subregion: 'Eastern Africa',
          latlng: [8, 38],
          demonym: 'Ethiopian',
          area: 1104300,
          gini: 29.8,
          borders: ['DJI', 'ERI', 'KEN', 'SOM', 'SSD', 'SDN'],
          nativeName: 'ኢትዮጵያ',
          translations: {
            de: 'Äthiopien',
            es: 'Etiopía',
            fr: 'Éthiopie',
            ja: 'エチオピア',
            it: 'Etiopia',
            br: 'Etiópia',
            pt: 'Etiópia',
            nl: 'Ethiopië',
            hr: 'Etiopija',
            fa: 'اتیوپی'
          },
          flag: 'https://restcountries.eu/data/eth.svg'
        }
      },
      'European Union': {
        name: 'European Union',
        slug: 'european-union',
        population: 450131902,
        domain: '.eu',
        sex: {
          male: 48.83,
          female: 51.17
        },
        age: [
          {
            group: '0-14 years',
            value: '15.05',
            male: '34978216',
            female: '33217600'
          },
          {
            group: '15-24 years',
            value: '10.39',
            male: '24089260',
            female: '22990579'
          },
          {
            group: '25-54 years',
            value: '40.54',
            male: '92503000',
            female: '91144596'
          },
          {
            group: '55-64 years',
            value: '13.52',
            male: '29805200',
            female: '31424172'
          },
          {
            group: '65 years and over',
            value: '20.5',
            male: '39834507',
            female: '53020673'
          }
        ]
      },
      'Falkland Islands (Islas Malvinas)': {
        name: 'Falkland Islands (Islas Malvinas)',
        slug: 'falkland-islands-islas-malvinas',
        population: 3198,
        domain: '.fk',
        info: {
          name: 'Falkland Islands (Malvinas)',
          alpha2Code: 'FK',
          alpha3Code: 'FLK',
          capital: 'Stanley',
          region: 'Americas',
          subregion: 'South America',
          latlng: [-51.75, -59],
          demonym: 'Falkland Islander',
          area: 12173,
          gini: null,
          borders: [],
          nativeName: 'Falkland Islands',
          translations: {
            de: 'Falklandinseln',
            es: 'Islas Malvinas',
            fr: 'Îles Malouines',
            ja: 'フォークランド（マルビナス）諸島',
            it: 'Isole Falkland o Isole Malvine',
            br: 'Ilhas Malvinas',
            pt: 'Ilhas Falkland',
            nl: 'Falklandeilanden [Islas Malvinas]',
            hr: 'Falklandski Otoci',
            fa: 'جزایر فالکلند'
          },
          flag: 'https://restcountries.eu/data/flk.svg'
        }
      },
      'Faroe Islands': {
        name: 'Faroe Islands',
        slug: 'faroe-islands',
        population: 51943,
        domain: '.fo',
        sex: {
          male: 51.88,
          female: 48.12
        },
        age: [
          {
            group: '0-14 years',
            value: '19.69',
            male: '5247',
            female: '4920'
          },
          {
            group: '15-24 years',
            value: '13.89',
            male: '3708',
            female: '3465'
          },
          {
            group: '25-54 years',
            value: '37.01',
            male: '10277',
            female: '8828'
          },
          {
            group: '55-64 years',
            value: '12',
            male: '3199',
            female: '2996'
          },
          {
            group: '65 years and over',
            value: '17.41',
            male: '4352',
            female: '4636'
          }
        ],
        info: {
          name: 'Faroe Islands',
          alpha2Code: 'FO',
          alpha3Code: 'FRO',
          capital: 'Tórshavn',
          region: 'Europe',
          subregion: 'Northern Europe',
          latlng: [62, -7],
          demonym: 'Faroese',
          area: 1393,
          gini: null,
          borders: [],
          nativeName: 'Føroyar',
          translations: {
            de: 'Färöer-Inseln',
            es: 'Islas Faroe',
            fr: 'Îles Féroé',
            ja: 'フェロー諸島',
            it: 'Isole Far Oer',
            br: 'Ilhas Faroé',
            pt: 'Ilhas Faroé',
            nl: 'Faeröer',
            hr: 'Farski Otoci',
            fa: 'جزایر فارو'
          },
          flag: 'https://restcountries.eu/data/fro.svg'
        }
      },
      Fiji: {
        name: 'Fiji',
        slug: 'fiji',
        population: 939535,
        domain: '.fj',
        sex: {
          male: 50.73,
          female: 49.27
        },
        age: [
          {
            group: '0-14 years',
            value: '26.86',
            male: '128499',
            female: '122873'
          },
          {
            group: '15-24 years',
            value: '15.51',
            male: '73993',
            female: '71139'
          },
          {
            group: '25-54 years',
            value: '41.05',
            male: '196932',
            female: '187270'
          },
          {
            group: '55-64 years',
            value: '9.25',
            male: '43813',
            female: '42763'
          },
          {
            group: '65 years and over',
            value: '7.34',
            male: '31556',
            female: '37136'
          }
        ],
        info: {
          name: 'Fiji',
          alpha2Code: 'FJ',
          alpha3Code: 'FJI',
          capital: 'Suva',
          region: 'Oceania',
          subregion: 'Melanesia',
          latlng: [-18, 175],
          demonym: 'Fijian',
          area: 18272,
          gini: 42.8,
          borders: [],
          nativeName: 'Fiji',
          translations: {
            de: 'Fidschi',
            es: 'Fiyi',
            fr: 'Fidji',
            ja: 'フィジー',
            it: 'Figi',
            br: 'Fiji',
            pt: 'Fiji',
            nl: 'Fiji',
            hr: 'Fiđi',
            fa: 'فیجی'
          },
          flag: 'https://restcountries.eu/data/fji.svg'
        }
      },
      Finland: {
        name: 'Finland',
        slug: 'finland',
        population: 5587442,
        domain: '&nbsp',
        sex: {
          male: 49.26,
          female: 50.74
        },
        age: [
          {
            group: '0-14 years',
            value: '16.41',
            male: '467220',
            female: '447005'
          },
          {
            group: '15-24 years',
            value: '10.95',
            male: '312179',
            female: '297717'
          },
          {
            group: '25-54 years',
            value: '37.37',
            male: '1064326',
            female: '1017545'
          },
          {
            group: '55-64 years',
            value: '13.02',
            male: '357687',
            female: '367610'
          },
          {
            group: '65 years and over',
            value: '22.26',
            male: '543331',
            female: '697045'
          }
        ],
        info: {
          name: 'Finland',
          alpha2Code: 'FI',
          alpha3Code: 'FIN',
          capital: 'Helsinki',
          region: 'Europe',
          subregion: 'Northern Europe',
          latlng: [64, 26],
          demonym: 'Finnish',
          area: 338424,
          gini: 26.9,
          borders: ['NOR', 'SWE', 'RUS'],
          nativeName: 'Suomi',
          translations: {
            de: 'Finnland',
            es: 'Finlandia',
            fr: 'Finlande',
            ja: 'フィンランド',
            it: 'Finlandia',
            br: 'Finlândia',
            pt: 'Finlândia',
            nl: 'Finland',
            hr: 'Finska',
            fa: 'فنلاند'
          },
          flag: 'https://restcountries.eu/data/fin.svg'
        }
      },
      France: {
        name: 'France',
        slug: 'france',
        population: 68084217,
        domain: 'metropolitan France - .fr',
        sex: {
          male: 48.97,
          female: 51.03
        },
        age: [
          {
            group: '0-14 years',
            value: '18.36',
            male: '6368767',
            female: '6085318'
          },
          {
            group: '15-24 years',
            value: '11.88',
            male: '4122981',
            female: '3938938'
          },
          {
            group: '25-54 years',
            value: '36.83',
            male: '12619649',
            female: '12366120'
          },
          {
            group: '55-64 years',
            value: '12.47',
            male: '4085564',
            female: '4376272'
          },
          {
            group: '65 years and over',
            value: '20.46',
            male: '6029303',
            female: '7855244'
          }
        ],
        info: {
          name: 'France',
          alpha2Code: 'FR',
          alpha3Code: 'FRA',
          capital: 'Paris',
          region: 'Europe',
          subregion: 'Western Europe',
          latlng: [46, 2],
          demonym: 'French',
          area: 640679,
          gini: 32.7,
          borders: ['AND', 'BEL', 'DEU', 'ITA', 'LUX', 'MCO', 'ESP', 'CHE'],
          nativeName: 'France',
          translations: {
            de: 'Frankreich',
            es: 'Francia',
            fr: 'France',
            ja: 'フランス',
            it: 'Francia',
            br: 'França',
            pt: 'França',
            nl: 'Frankrijk',
            hr: 'Francuska',
            fa: 'فرانسه'
          },
          flag: 'https://restcountries.eu/data/fra.svg'
        }
      },
      'French Polynesia': {
        name: 'French Polynesia',
        slug: 'french-polynesia',
        population: 297154,
        domain: '.pf',
        sex: {
          male: 51.15,
          female: 48.85
        },
        age: [
          {
            group: '0-14 years',
            value: '21.69',
            male: '32920',
            female: '31100'
          },
          {
            group: '15-24 years',
            value: '14.72',
            male: '22640',
            female: '20793'
          },
          {
            group: '25-54 years',
            value: '44.24',
            male: '66921',
            female: '63636'
          },
          {
            group: '55-64 years',
            value: '10.31',
            male: '15610',
            female: '14823'
          },
          {
            group: '65 years and over',
            value: '9.04',
            male: '12854',
            female: '13824'
          }
        ],
        info: {
          name: 'French Polynesia',
          alpha2Code: 'PF',
          alpha3Code: 'PYF',
          capital: 'Papeetē',
          region: 'Oceania',
          subregion: 'Polynesia',
          latlng: [-15, -140],
          demonym: 'French Polynesian',
          area: 4167,
          gini: null,
          borders: [],
          nativeName: 'Polynésie française',
          translations: {
            de: 'Französisch-Polynesien',
            es: 'Polinesia Francesa',
            fr: 'Polynésie française',
            ja: 'フランス領ポリネシア',
            it: 'Polinesia Francese',
            br: 'Polinésia Francesa',
            pt: 'Polinésia Francesa',
            nl: 'Frans-Polynesië',
            hr: 'Francuska Polinezija',
            fa: 'پلی‌نزی فرانسه'
          },
          flag: 'https://restcountries.eu/data/pyf.svg'
        }
      },
      'French Southern and Antarctic Lands': {
        name: 'French Southern and Antarctic Lands',
        slug: 'french-southern-and-antarctic-lands',
        population: 0,
        domain: '.tf',
        info: {
          name: 'French Southern Territories',
          alpha2Code: 'TF',
          alpha3Code: 'ATF',
          capital: 'Port-aux-Français',
          region: 'Africa',
          subregion: 'Southern Africa',
          latlng: [-49.25, 69.167],
          demonym: 'French',
          area: 7747,
          gini: null,
          borders: [],
          nativeName:
            'Territoire des Terres australes et antarctiques françaises',
          translations: {
            de: 'Französische Süd- und Antarktisgebiete',
            es: 'Tierras Australes y Antárticas Francesas',
            fr: 'Terres australes et antarctiques françaises',
            ja: 'フランス領南方・南極地域',
            it: 'Territori Francesi del Sud',
            br: 'Terras Austrais e Antárticas Francesas',
            pt: 'Terras Austrais e Antárticas Francesas',
            nl: 'Franse Gebieden in de zuidelijke Indische Oceaan',
            hr: 'Francuski južni i antarktički teritoriji',
            fa: 'سرزمین‌های جنوبی و جنوبگانی فرانسه'
          },
          flag: 'https://restcountries.eu/data/atf.svg'
        }
      },
      Gabon: {
        name: 'Gabon',
        slug: 'gabon',
        population: 2284912,
        domain: '.ga',
        sex: {
          male: 51.94,
          female: 48.06
        },
        age: [
          {
            group: '0-14 years',
            value: '36.45',
            male: '413883',
            female: '399374'
          },
          {
            group: '15-24 years',
            value: '21.9',
            male: '254749',
            female: '233770'
          },
          {
            group: '25-54 years',
            value: '32.48',
            male: '386903',
            female: '337776'
          },
          {
            group: '55-64 years',
            value: '5.19',
            male: '58861',
            female: '56843'
          },
          {
            group: '65 years and over',
            value: '3.98',
            male: '44368',
            female: '44381'
          }
        ],
        info: {
          name: 'Gabon',
          alpha2Code: 'GA',
          alpha3Code: 'GAB',
          capital: 'Libreville',
          region: 'Africa',
          subregion: 'Middle Africa',
          latlng: [-1, 11.75],
          demonym: 'Gabonese',
          area: 267668,
          gini: 41.5,
          borders: ['CMR', 'COG', 'GNQ'],
          nativeName: 'Gabon',
          translations: {
            de: 'Gabun',
            es: 'Gabón',
            fr: 'Gabon',
            ja: 'ガボン',
            it: 'Gabon',
            br: 'Gabão',
            pt: 'Gabão',
            nl: 'Gabon',
            hr: 'Gabon',
            fa: 'گابن'
          },
          flag: 'https://restcountries.eu/data/gab.svg'
        }
      },
      Gambia: {
        name: 'Gambia, The',
        slug: 'gambia-the',
        population: 2221301,
        domain: '.gm',
        sex: {
          male: 49.37,
          female: 50.63
        },
        age: [
          {
            group: '0-14 years',
            value: '35.15',
            male: '391993',
            female: '388816'
          },
          {
            group: '15-24 years',
            value: '20.12',
            male: '221519',
            female: '225414'
          },
          {
            group: '25-54 years',
            value: '36.39',
            male: '396261',
            female: '412122'
          },
          {
            group: '55-64 years',
            value: '4.53',
            male: '48032',
            female: '52538'
          },
          {
            group: '65 years and over',
            value: '3.81',
            male: '38805',
            female: '45801'
          }
        ],
        info: {
          name: 'Gambia',
          alpha2Code: 'GM',
          alpha3Code: 'GMB',
          capital: 'Banjul',
          region: 'Africa',
          subregion: 'Western Africa',
          latlng: [13.46666666, -16.56666666],
          demonym: 'Gambian',
          area: 11295,
          gini: null,
          borders: ['SEN'],
          nativeName: 'Gambia',
          translations: {
            de: 'Gambia',
            es: 'Gambia',
            fr: 'Gambie',
            ja: 'ガンビア',
            it: 'Gambia',
            br: 'Gâmbia',
            pt: 'Gâmbia',
            nl: 'Gambia',
            hr: 'Gambija',
            fa: 'گامبیا'
          },
          flag: 'https://restcountries.eu/data/gmb.svg'
        }
      },
      'Gaza Strip': {
        name: 'Gaza Strip',
        slug: 'gaza-strip',
        population: 1957062,
        domain: '.psnote - same as the West Bank',
        sex: {
          male: 50.5,
          female: 49.5
        },
        age: [
          {
            group: '0-14 years',
            value: '42.53',
            male: '418751',
            female: '397013'
          },
          {
            group: '15-24 years',
            value: '21.67',
            male: '210240',
            female: '205385'
          },
          {
            group: '25-54 years',
            value: '29.47',
            male: '275976',
            female: '289277'
          },
          {
            group: '55-64 years',
            value: '3.66',
            male: '36409',
            female: '33731'
          },
          {
            group: '65 years and over',
            value: '2.68',
            male: '27248',
            female: '24191'
          }
        ]
      },
      Georgia: {
        name: 'Georgia',
        slug: 'georgia',
        population: 4933674,
        domain: '.ge',
        sex: {
          male: 47.85,
          female: 52.15
        },
        age: [
          {
            group: '0-14 years',
            value: '18.42',
            male: '472731',
            female: '435174'
          },
          {
            group: '15-24 years',
            value: '10.9',
            male: '286518',
            female: '250882'
          },
          {
            group: '25-54 years',
            value: '40.59',
            male: '984942',
            female: '1016353'
          },
          {
            group: '55-64 years',
            value: '13.24',
            male: '288650',
            female: '364117'
          },
          {
            group: '65 years and over',
            value: '16.85',
            male: '326219',
            female: '504444'
          }
        ],
        info: {
          name: 'Georgia',
          alpha2Code: 'GE',
          alpha3Code: 'GEO',
          capital: 'Tbilisi',
          region: 'Asia',
          subregion: 'Western Asia',
          latlng: [42, 43.5],
          demonym: 'Georgian',
          area: 69700,
          gini: 41.3,
          borders: ['ARM', 'AZE', 'RUS', 'TUR'],
          nativeName: 'საქართველო',
          translations: {
            de: 'Georgien',
            es: 'Georgia',
            fr: 'Géorgie',
            ja: 'グルジア',
            it: 'Georgia',
            br: 'Geórgia',
            pt: 'Geórgia',
            nl: 'Georgië',
            hr: 'Gruzija',
            fa: 'گرجستان'
          },
          flag: 'https://restcountries.eu/data/geo.svg'
        }
      },
      Germany: {
        name: 'Germany',
        slug: 'germany',
        population: 79903481,
        domain: '.de',
        sex: {
          male: 49.05,
          female: 50.95
        },
        age: [
          {
            group: '0-14 years',
            value: '12.89',
            male: '5302850',
            female: '5025863'
          },
          {
            group: '15-24 years',
            value: '9.81',
            male: '4012412',
            female: '3854471'
          },
          {
            group: '25-54 years',
            value: '38.58',
            male: '15553328',
            female: '15370417'
          },
          {
            group: '55-64 years',
            value: '15.74',
            male: '6297886',
            female: '6316024'
          },
          {
            group: '65 years and over',
            value: '22.99',
            male: '8148873',
            female: '10277538'
          }
        ],
        info: {
          name: 'Germany',
          alpha2Code: 'DE',
          alpha3Code: 'DEU',
          capital: 'Berlin',
          region: 'Europe',
          subregion: 'Western Europe',
          latlng: [51, 9],
          demonym: 'German',
          area: 357114,
          gini: 28.3,
          borders: [
            'AUT',
            'BEL',
            'CZE',
            'DNK',
            'FRA',
            'LUX',
            'NLD',
            'POL',
            'CHE'
          ],
          nativeName: 'Deutschland',
          translations: {
            de: 'Deutschland',
            es: 'Alemania',
            fr: 'Allemagne',
            ja: 'ドイツ',
            it: 'Germania',
            br: 'Alemanha',
            pt: 'Alemanha',
            nl: 'Duitsland',
            hr: 'Njemačka',
            fa: 'آلمان'
          },
          flag: 'https://restcountries.eu/data/deu.svg'
        }
      },
      Ghana: {
        name: 'Ghana',
        slug: 'ghana',
        population: 32372889,
        domain: '.gh',
        sex: {
          male: 49.29,
          female: 50.71
        },
        age: [
          {
            group: '0-14 years',
            value: '37.44',
            male: '5524932',
            female: '5460943'
          },
          {
            group: '15-24 years',
            value: '18.64',
            male: '2717481',
            female: '2752601'
          },
          {
            group: '25-54 years',
            value: '34.27',
            male: '4875985',
            female: '5177959'
          },
          {
            group: '55-64 years',
            value: '5.21',
            male: '743757',
            female: '784517'
          },
          {
            group: '65 years and over',
            value: '4.44',
            male: '598387',
            female: '703686'
          }
        ],
        info: {
          name: 'Ghana',
          alpha2Code: 'GH',
          alpha3Code: 'GHA',
          capital: 'Accra',
          region: 'Africa',
          subregion: 'Western Africa',
          latlng: [8, -2],
          demonym: 'Ghanaian',
          area: 238533,
          gini: 42.8,
          borders: ['BFA', 'CIV', 'TGO'],
          nativeName: 'Ghana',
          translations: {
            de: 'Ghana',
            es: 'Ghana',
            fr: 'Ghana',
            ja: 'ガーナ',
            it: 'Ghana',
            br: 'Gana',
            pt: 'Gana',
            nl: 'Ghana',
            hr: 'Gana',
            fa: 'غنا'
          },
          flag: 'https://restcountries.eu/data/gha.svg'
        }
      },
      Gibraltar: {
        name: 'Gibraltar',
        slug: 'gibraltar',
        population: 29516,
        domain: '.gi',
        sex: {
          male: 50.13,
          female: 49.87
        },
        age: [
          {
            group: '0-14 years',
            value: '20.24',
            male: '3080',
            female: '2907'
          },
          {
            group: '15-24 years',
            value: '13.07',
            male: '2000',
            female: '1866'
          },
          {
            group: '25-54 years',
            value: '41.28',
            male: '6289',
            female: '5922'
          },
          {
            group: '55-64 years',
            value: '8.71',
            male: '1082',
            female: '1495'
          },
          {
            group: '65 years and over',
            value: '16.7',
            male: '2378',
            female: '2562'
          }
        ],
        info: {
          name: 'Gibraltar',
          alpha2Code: 'GI',
          alpha3Code: 'GIB',
          capital: 'Gibraltar',
          region: 'Europe',
          subregion: 'Southern Europe',
          latlng: [36.13333333, -5.35],
          demonym: 'Gibraltar',
          area: 6,
          gini: null,
          borders: ['ESP'],
          nativeName: 'Gibraltar',
          translations: {
            de: 'Gibraltar',
            es: 'Gibraltar',
            fr: 'Gibraltar',
            ja: 'ジブラルタル',
            it: 'Gibilterra',
            br: 'Gibraltar',
            pt: 'Gibraltar',
            nl: 'Gibraltar',
            hr: 'Gibraltar',
            fa: 'جبل‌طارق'
          },
          flag: 'https://restcountries.eu/data/gib.svg'
        }
      },
      Greece: {
        name: 'Greece',
        slug: 'greece',
        population: 10569703,
        domain: '.gr',
        sex: {
          male: 48.71,
          female: 51.29
        },
        age: [
          {
            group: '0-14 years',
            value: '14.53',
            male: '794918',
            female: '745909'
          },
          {
            group: '15-24 years',
            value: '10.34',
            male: '577134',
            female: '519819'
          },
          {
            group: '25-54 years',
            value: '39.6',
            male: '2080443',
            female: '2119995'
          },
          {
            group: '55-64 years',
            value: '13.1',
            male: '656404',
            female: '732936'
          },
          {
            group: '65 years and over',
            value: '22.43',
            male: '1057317',
            female: '1322176'
          }
        ],
        info: {
          name: 'Greece',
          alpha2Code: 'GR',
          alpha3Code: 'GRC',
          capital: 'Athens',
          region: 'Europe',
          subregion: 'Southern Europe',
          latlng: [39, 22],
          demonym: 'Greek',
          area: 131990,
          gini: 34.3,
          borders: ['ALB', 'BGR', 'TUR', 'MKD'],
          nativeName: 'Ελλάδα',
          translations: {
            de: 'Griechenland',
            es: 'Grecia',
            fr: 'Grèce',
            ja: 'ギリシャ',
            it: 'Grecia',
            br: 'Grécia',
            pt: 'Grécia',
            nl: 'Griekenland',
            hr: 'Grčka',
            fa: 'یونان'
          },
          flag: 'https://restcountries.eu/data/grc.svg'
        }
      },
      Greenland: {
        name: 'Greenland',
        slug: 'greenland',
        population: 57799,
        domain: '.gl',
        sex: {
          male: 52,
          female: 48
        },
        age: [
          {
            group: '0-14 years',
            value: '20.82',
            male: '6079',
            female: '5916'
          },
          {
            group: '15-24 years',
            value: '14.45',
            male: '4186',
            female: '4137'
          },
          {
            group: '25-54 years',
            value: '39.72',
            male: '11962',
            female: '10921'
          },
          {
            group: '55-64 years',
            value: '14.66',
            male: '4561',
            female: '3886'
          },
          {
            group: '65 years and over',
            value: '10.36',
            male: '3170',
            female: '2798'
          }
        ],
        info: {
          name: 'Greenland',
          alpha2Code: 'GL',
          alpha3Code: 'GRL',
          capital: 'Nuuk',
          region: 'Americas',
          subregion: 'Northern America',
          latlng: [72, -40],
          demonym: 'Greenlandic',
          area: 2166086,
          gini: null,
          borders: [],
          nativeName: 'Kalaallit Nunaat',
          translations: {
            de: 'Grönland',
            es: 'Groenlandia',
            fr: 'Groenland',
            ja: 'グリーンランド',
            it: 'Groenlandia',
            br: 'Groelândia',
            pt: 'Gronelândia',
            nl: 'Groenland',
            hr: 'Grenland',
            fa: 'گرینلند'
          },
          flag: 'https://restcountries.eu/data/grl.svg'
        }
      },
      Grenada: {
        name: 'Grenada',
        slug: 'grenada',
        population: 113570,
        domain: '.gd',
        sex: {
          male: 50.71,
          female: 49.29
        },
        age: [
          {
            group: '0-14 years',
            value: '23.23',
            male: '13709',
            female: '12564'
          },
          {
            group: '15-24 years',
            value: '14.14',
            male: '8034',
            female: '7959'
          },
          {
            group: '25-54 years',
            value: '40.05',
            male: '23104',
            female: '22187'
          },
          {
            group: '55-64 years',
            value: '11.69',
            male: '6734',
            female: '6490'
          },
          {
            group: '65 years and over',
            value: '10.89',
            male: '5774',
            female: '6539'
          }
        ],
        info: {
          name: 'Grenada',
          alpha2Code: 'GD',
          alpha3Code: 'GRD',
          capital: "St. George's",
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [12.11666666, -61.66666666],
          demonym: 'Grenadian',
          area: 344,
          gini: null,
          borders: [],
          nativeName: 'Grenada',
          translations: {
            de: 'Grenada',
            es: 'Grenada',
            fr: 'Grenade',
            ja: 'グレナダ',
            it: 'Grenada',
            br: 'Granada',
            pt: 'Granada',
            nl: 'Grenada',
            hr: 'Grenada',
            fa: 'گرنادا'
          },
          flag: 'https://restcountries.eu/data/grd.svg'
        }
      },
      Guam: {
        name: 'Guam',
        slug: 'guam',
        population: 168801,
        domain: '.gu',
        sex: {
          male: 51.48,
          female: 48.52
        },
        age: [
          {
            group: '0-14 years',
            value: '27.22',
            male: '23748',
            female: '22122'
          },
          {
            group: '15-24 years',
            value: '16.08',
            male: '14522',
            female: '12572'
          },
          {
            group: '25-54 years',
            value: '36.65',
            male: '31880',
            female: '29871'
          },
          {
            group: '55-64 years',
            value: '10.5',
            male: '9079',
            female: '8610'
          },
          {
            group: '65 years and over',
            value: '9.54',
            male: '7504',
            female: '8577'
          }
        ],
        info: {
          name: 'Guam',
          alpha2Code: 'GU',
          alpha3Code: 'GUM',
          capital: 'Hagåtña',
          region: 'Oceania',
          subregion: 'Micronesia',
          latlng: [13.46666666, 144.78333333],
          demonym: 'Guamanian',
          area: 549,
          gini: null,
          borders: [],
          nativeName: 'Guam',
          translations: {
            de: 'Guam',
            es: 'Guam',
            fr: 'Guam',
            ja: 'グアム',
            it: 'Guam',
            br: 'Guam',
            pt: 'Guame',
            nl: 'Guam',
            hr: 'Guam',
            fa: 'گوام'
          },
          flag: 'https://restcountries.eu/data/gum.svg'
        }
      },
      Guatemala: {
        name: 'Guatemala',
        slug: 'guatemala',
        population: 17422821,
        domain: '.gt',
        sex: {
          male: 49.62,
          female: 50.38
        },
        age: [
          {
            group: '0-14 years',
            value: '33.68',
            male: '2944145',
            female: '2833432'
          },
          {
            group: '15-24 years',
            value: '19.76',
            male: '1705730',
            female: '1683546'
          },
          {
            group: '25-54 years',
            value: '36.45',
            male: '3065933',
            female: '3186816'
          },
          {
            group: '55-64 years',
            value: '5.41',
            male: '431417',
            female: '496743'
          },
          {
            group: '65 years and over',
            value: '4.7',
            male: '363460',
            female: '442066'
          }
        ],
        info: {
          name: 'Guatemala',
          alpha2Code: 'GT',
          alpha3Code: 'GTM',
          capital: 'Guatemala City',
          region: 'Americas',
          subregion: 'Central America',
          latlng: [15.5, -90.25],
          demonym: 'Guatemalan',
          area: 108889,
          gini: 55.9,
          borders: ['BLZ', 'SLV', 'HND', 'MEX'],
          nativeName: 'Guatemala',
          translations: {
            de: 'Guatemala',
            es: 'Guatemala',
            fr: 'Guatemala',
            ja: 'グアテマラ',
            it: 'Guatemala',
            br: 'Guatemala',
            pt: 'Guatemala',
            nl: 'Guatemala',
            hr: 'Gvatemala',
            fa: 'گواتمالا'
          },
          flag: 'https://restcountries.eu/data/gtm.svg'
        }
      },
      Guernsey: {
        name: 'Guernsey',
        slug: 'guernsey',
        population: 67334,
        domain: '.gg',
        sex: {
          male: 49.68,
          female: 50.32
        },
        age: [
          {
            group: '0-14 years',
            value: '14.5',
            male: '5008',
            female: '4712'
          },
          {
            group: '15-24 years',
            value: '10.58',
            male: '3616',
            female: '3476'
          },
          {
            group: '25-54 years',
            value: '40.73',
            male: '13821',
            female: '13492'
          },
          {
            group: '55-64 years',
            value: '13.96',
            male: '4635',
            female: '4728'
          },
          {
            group: '65 years and over',
            value: '20.23',
            male: '6229',
            female: '7335'
          }
        ],
        info: {
          name: 'Guernsey',
          alpha2Code: 'GG',
          alpha3Code: 'GGY',
          capital: 'St. Peter Port',
          region: 'Europe',
          subregion: 'Northern Europe',
          latlng: [49.46666666, -2.58333333],
          demonym: 'Channel Islander',
          area: 78,
          gini: null,
          borders: [],
          nativeName: 'Guernsey',
          translations: {
            de: 'Guernsey',
            es: 'Guernsey',
            fr: 'Guernesey',
            ja: 'ガーンジー',
            it: 'Guernsey',
            br: 'Guernsey',
            pt: 'Guernsey',
            nl: 'Guernsey',
            hr: 'Guernsey',
            fa: 'گرنزی'
          },
          flag: 'https://restcountries.eu/data/ggy.svg'
        }
      },
      Guinea: {
        name: 'Guinea',
        slug: 'guinea',
        population: 12877894,
        domain: '.gn',
        sex: {
          male: 49.94,
          female: 50.06
        },
        age: [
          {
            group: '0-14 years',
            value: '41.2',
            male: '2601221',
            female: '2559918'
          },
          {
            group: '15-24 years',
            value: '19.32',
            male: '1215654',
            female: '1204366'
          },
          {
            group: '25-54 years',
            value: '30.85',
            male: '1933141',
            female: '1930977'
          },
          {
            group: '55-64 years',
            value: '4.73',
            male: '287448',
            female: '305420'
          },
          {
            group: '65 years and over',
            value: '3.91',
            male: '218803',
            female: '270492'
          }
        ],
        info: {
          name: 'Guinea',
          alpha2Code: 'GN',
          alpha3Code: 'GIN',
          capital: 'Conakry',
          region: 'Africa',
          subregion: 'Western Africa',
          latlng: [11, -10],
          demonym: 'Guinean',
          area: 245857,
          gini: 39.4,
          borders: ['CIV', 'GNB', 'LBR', 'MLI', 'SEN', 'SLE'],
          nativeName: 'Guinée',
          translations: {
            de: 'Guinea',
            es: 'Guinea',
            fr: 'Guinée',
            ja: 'ギニア',
            it: 'Guinea',
            br: 'Guiné',
            pt: 'Guiné',
            nl: 'Guinee',
            hr: 'Gvineja',
            fa: 'گینه'
          },
          flag: 'https://restcountries.eu/data/gin.svg'
        }
      },
      'Guinea-Bissau': {
        name: 'Guinea-Bissau',
        slug: 'guinea-bissau',
        population: 1976187,
        domain: '.gw',
        sex: {
          male: 48.8,
          female: 51.2
        },
        age: [
          {
            group: '0-14 years',
            value: '43.17',
            male: '417810',
            female: '414105'
          },
          {
            group: '15-24 years',
            value: '20.38',
            male: '192451',
            female: '200370'
          },
          {
            group: '25-54 years',
            value: '30.24',
            male: '275416',
            female: '307387'
          },
          {
            group: '55-64 years',
            value: '3.12',
            male: '29549',
            female: '30661'
          },
          {
            group: '65 years and over',
            value: '3.08',
            male: '25291',
            female: '34064'
          }
        ],
        info: {
          name: 'Guinea-Bissau',
          alpha2Code: 'GW',
          alpha3Code: 'GNB',
          capital: 'Bissau',
          region: 'Africa',
          subregion: 'Western Africa',
          latlng: [12, -15],
          demonym: 'Guinea-Bissauan',
          area: 36125,
          gini: 35.5,
          borders: ['GIN', 'SEN'],
          nativeName: 'Guiné-Bissau',
          translations: {
            de: 'Guinea-Bissau',
            es: 'Guinea-Bisáu',
            fr: 'Guinée-Bissau',
            ja: 'ギニアビサウ',
            it: 'Guinea-Bissau',
            br: 'Guiné-Bissau',
            pt: 'Guiné-Bissau',
            nl: 'Guinee-Bissau',
            hr: 'Gvineja Bisau',
            fa: 'گینه بیسائو'
          },
          flag: 'https://restcountries.eu/data/gnb.svg'
        }
      },
      Guyana: {
        name: 'Guyana',
        slug: 'guyana',
        population: 787971,
        domain: '.gy',
        sex: {
          male: 50.41,
          female: 49.59
        },
        age: [
          {
            group: '0-14 years',
            value: '23.91',
            male: '91317',
            female: '88025'
          },
          {
            group: '15-24 years',
            value: '21.23',
            male: '81294',
            female: '77987'
          },
          {
            group: '25-54 years',
            value: '39.48',
            male: '154825',
            female: '141385'
          },
          {
            group: '55-64 years',
            value: '8.37',
            male: '29385',
            female: '33386'
          },
          {
            group: '65 years and over',
            value: '7.01',
            male: '21325',
            female: '31275'
          }
        ],
        info: {
          name: 'Guyana',
          alpha2Code: 'GY',
          alpha3Code: 'GUY',
          capital: 'Georgetown',
          region: 'Americas',
          subregion: 'South America',
          latlng: [5, -59],
          demonym: 'Guyanese',
          area: 214969,
          gini: 44.5,
          borders: ['BRA', 'SUR', 'VEN'],
          nativeName: 'Guyana',
          translations: {
            de: 'Guyana',
            es: 'Guyana',
            fr: 'Guyane',
            ja: 'ガイアナ',
            it: 'Guyana',
            br: 'Guiana',
            pt: 'Guiana',
            nl: 'Guyana',
            hr: 'Gvajana',
            fa: 'گویان'
          },
          flag: 'https://restcountries.eu/data/guy.svg'
        }
      },
      Haiti: {
        name: 'Haiti',
        slug: 'haiti',
        population: 11198240,
        domain: '.ht',
        sex: {
          male: 49.39,
          female: 50.61
        },
        age: [
          {
            group: '0-14 years',
            value: '31.21',
            male: '1719961',
            female: '1734566'
          },
          {
            group: '15-24 years',
            value: '20.71',
            male: '1145113',
            female: '1146741'
          },
          {
            group: '25-54 years',
            value: '38.45',
            male: '2110294',
            female: '2145209'
          },
          {
            group: '55-64 years',
            value: '5.3',
            male: '280630',
            female: '305584'
          },
          {
            group: '65 years and over',
            value: '4.33',
            male: '210451',
            female: '269228'
          }
        ],
        info: {
          name: 'Haiti',
          alpha2Code: 'HT',
          alpha3Code: 'HTI',
          capital: 'Port-au-Prince',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [19, -72.41666666],
          demonym: 'Haitian',
          area: 27750,
          gini: 59.2,
          borders: ['DOM'],
          nativeName: 'Haïti',
          translations: {
            de: 'Haiti',
            es: 'Haiti',
            fr: 'Haïti',
            ja: 'ハイチ',
            it: 'Haiti',
            br: 'Haiti',
            pt: 'Haiti',
            nl: 'Haïti',
            hr: 'Haiti',
            fa: 'هائیتی'
          },
          flag: 'https://restcountries.eu/data/hti.svg'
        }
      },
      'Heard Island and McDonald Islands': {
        name: 'Heard Island and McDonald Islands',
        slug: 'heard-island-and-mcdonald-islands',
        population: 0,
        domain: '.hm',
        info: {
          name: 'Heard Island and McDonald Islands',
          alpha2Code: 'HM',
          alpha3Code: 'HMD',
          capital: '',
          region: '',
          subregion: '',
          latlng: [-53.1, 72.51666666],
          demonym: 'Heard and McDonald Islander',
          area: 412,
          gini: null,
          borders: [],
          nativeName: 'Heard Island and McDonald Islands',
          translations: {
            de: 'Heard und die McDonaldinseln',
            es: 'Islas Heard y McDonald',
            fr: 'Îles Heard-et-MacDonald',
            ja: 'ハード島とマクドナルド諸島',
            it: 'Isole Heard e McDonald',
            br: 'Ilha Heard e Ilhas McDonald',
            pt: 'Ilha Heard e Ilhas McDonald',
            nl: 'Heard- en McDonaldeilanden',
            hr: 'Otok Heard i otočje McDonald',
            fa: 'جزیره هرد و جزایر مک‌دونالد'
          },
          flag: 'https://restcountries.eu/data/hmd.svg'
        }
      },
      'Holy See (Vatican City)': {
        name: 'Holy See (Vatican City)',
        slug: 'holy-see-vatican-city',
        population: 1000,
        domain: '.va',
        info: {
          name: 'Holy See',
          alpha2Code: 'VA',
          alpha3Code: 'VAT',
          capital: 'Rome',
          region: 'Europe',
          subregion: 'Southern Europe',
          latlng: [41.9, 12.45],
          demonym: '',
          area: 0.44,
          gini: null,
          borders: ['ITA'],
          nativeName: 'Sancta Sedes',
          translations: {
            de: 'Heiliger Stuhl',
            es: 'Santa Sede',
            fr: 'voir Saint',
            ja: '聖座',
            it: 'Santa Sede',
            br: 'Vaticano',
            pt: 'Vaticano',
            nl: 'Heilige Stoel',
            hr: 'Sveta Stolica',
            fa: 'سریر مقدس'
          },
          flag: 'https://restcountries.eu/data/vat.svg'
        }
      },
      Honduras: {
        name: 'Honduras',
        slug: 'honduras',
        population: 9346277,
        domain: '.hn',
        sex: {
          male: 48.66,
          female: 51.34
        },
        age: [
          {
            group: '0-14 years',
            value: '30.2',
            male: '1411537',
            female: '1377319'
          },
          {
            group: '15-24 years',
            value: '21.03',
            male: '969302',
            female: '972843'
          },
          {
            group: '25-54 years',
            value: '37.79',
            male: '1657260',
            female: '1832780'
          },
          {
            group: '55-64 years',
            value: '5.58',
            male: '233735',
            female: '281525'
          },
          {
            group: '65 years and over',
            value: '5.4',
            male: '221779',
            female: '277260'
          }
        ],
        info: {
          name: 'Honduras',
          alpha2Code: 'HN',
          alpha3Code: 'HND',
          capital: 'Tegucigalpa',
          region: 'Americas',
          subregion: 'Central America',
          latlng: [15, -86.5],
          demonym: 'Honduran',
          area: 112492,
          gini: 57,
          borders: ['GTM', 'SLV', 'NIC'],
          nativeName: 'Honduras',
          translations: {
            de: 'Honduras',
            es: 'Honduras',
            fr: 'Honduras',
            ja: 'ホンジュラス',
            it: 'Honduras',
            br: 'Honduras',
            pt: 'Honduras',
            nl: 'Honduras',
            hr: 'Honduras',
            fa: 'هندوراس'
          },
          flag: 'https://restcountries.eu/data/hnd.svg'
        }
      },
      'Hong Kong': {
        name: 'Hong Kong',
        slug: 'hong-kong',
        population: 7263234,
        domain: '.hk',
        sex: {
          male: 46.36,
          female: 53.64
        },
        age: [
          {
            group: '0-14 years',
            value: '12.81',
            male: '490477',
            female: '437971'
          },
          {
            group: '15-24 years',
            value: '8.81',
            male: '334836',
            female: '303897'
          },
          {
            group: '25-54 years',
            value: '42.66',
            male: '1328529',
            female: '1763970'
          },
          {
            group: '55-64 years',
            value: '17.24',
            male: '582047',
            female: '668051'
          },
          {
            group: '65 years and over',
            value: '18.48',
            male: '625453',
            female: '714676'
          }
        ],
        info: {
          name: 'Hong Kong',
          alpha2Code: 'HK',
          alpha3Code: 'HKG',
          capital: 'City of Victoria',
          region: 'Asia',
          subregion: 'Eastern Asia',
          latlng: [22.25, 114.16666666],
          demonym: 'Chinese',
          area: 1104,
          gini: 53.3,
          borders: ['CHN'],
          nativeName: '香港',
          translations: {
            de: 'Hong Kong',
            es: 'Hong Kong',
            fr: 'Hong Kong',
            ja: '香港',
            it: 'Hong Kong',
            br: 'Hong Kong',
            pt: 'Hong Kong',
            nl: 'Hongkong',
            hr: 'Hong Kong',
            fa: 'هنگ‌کنگ'
          },
          flag: 'https://restcountries.eu/data/hkg.svg'
        }
      },
      Hungary: {
        name: 'Hungary',
        slug: 'hungary',
        population: 9728337,
        domain: '.hu',
        sex: {
          male: 47.69,
          female: 52.31
        },
        age: [
          {
            group: '0-14 years',
            value: '14.54',
            male: '731542',
            female: '689739'
          },
          {
            group: '15-24 years',
            value: '10.43',
            male: '526933',
            female: '492388'
          },
          {
            group: '25-54 years',
            value: '42.17',
            male: '2075763',
            female: '2044664'
          },
          {
            group: '55-64 years',
            value: '12.17',
            male: '552876',
            female: '636107'
          },
          {
            group: '65 years and over',
            value: '20.69',
            male: '773157',
            female: '1248658'
          }
        ],
        info: {
          name: 'Hungary',
          alpha2Code: 'HU',
          alpha3Code: 'HUN',
          capital: 'Budapest',
          region: 'Europe',
          subregion: 'Eastern Europe',
          latlng: [47, 20],
          demonym: 'Hungarian',
          area: 93028,
          gini: 31.2,
          borders: ['AUT', 'HRV', 'ROU', 'SRB', 'SVK', 'SVN', 'UKR'],
          nativeName: 'Magyarország',
          translations: {
            de: 'Ungarn',
            es: 'Hungría',
            fr: 'Hongrie',
            ja: 'ハンガリー',
            it: 'Ungheria',
            br: 'Hungria',
            pt: 'Hungria',
            nl: 'Hongarije',
            hr: 'Mađarska',
            fa: 'مجارستان'
          },
          flag: 'https://restcountries.eu/data/hun.svg'
        }
      },
      Iceland: {
        name: 'Iceland',
        slug: 'iceland',
        population: 354234,
        domain: '.is',
        sex: {
          male: 50.09,
          female: 49.91
        },
        age: [
          {
            group: '0-14 years',
            value: '20.31',
            male: '36394',
            female: '34837'
          },
          {
            group: '15-24 years',
            value: '12.85',
            male: '22748',
            female: '22317'
          },
          {
            group: '25-54 years',
            value: '39.44',
            male: '70227',
            female: '68095'
          },
          {
            group: '55-64 years',
            value: '11.94',
            male: '20762',
            female: '21111'
          },
          {
            group: '65 years and over',
            value: '15.47',
            male: '25546',
            female: '28697'
          }
        ],
        info: {
          name: 'Iceland',
          alpha2Code: 'IS',
          alpha3Code: 'ISL',
          capital: 'Reykjavík',
          region: 'Europe',
          subregion: 'Northern Europe',
          latlng: [65, -18],
          demonym: 'Icelander',
          area: 103000,
          gini: null,
          borders: [],
          nativeName: 'Ísland',
          translations: {
            de: 'Island',
            es: 'Islandia',
            fr: 'Islande',
            ja: 'アイスランド',
            it: 'Islanda',
            br: 'Islândia',
            pt: 'Islândia',
            nl: 'IJsland',
            hr: 'Island',
            fa: 'ایسلند'
          },
          flag: 'https://restcountries.eu/data/isl.svg'
        }
      },
      India: {
        name: 'India',
        slug: 'india',
        population: 1339330514,
        domain: '.in',
        sex: {
          male: 51.9,
          female: 48.1
        },
        age: [
          {
            group: '0-14 years',
            value: '26.31',
            male: '185017089',
            female: '163844572'
          },
          {
            group: '15-24 years',
            value: '17.51',
            male: '123423531',
            female: '108739780'
          },
          {
            group: '25-54 years',
            value: '41.56',
            male: '285275667',
            female: '265842319'
          },
          {
            group: '55-64 years',
            value: '7.91',
            male: '52444817',
            female: '52447038'
          },
          {
            group: '65 years and over',
            value: '6.72',
            male: '42054459',
            female: '47003975'
          }
        ],
        info: {
          name: 'India',
          alpha2Code: 'IN',
          alpha3Code: 'IND',
          capital: 'New Delhi',
          region: 'Asia',
          subregion: 'Southern Asia',
          latlng: [20, 77],
          demonym: 'Indian',
          area: 3287590,
          gini: 33.4,
          borders: ['AFG', 'BGD', 'BTN', 'MMR', 'CHN', 'NPL', 'PAK', 'LKA'],
          nativeName: 'भारत',
          translations: {
            de: 'Indien',
            es: 'India',
            fr: 'Inde',
            ja: 'インド',
            it: 'India',
            br: 'Índia',
            pt: 'Índia',
            nl: 'India',
            hr: 'Indija',
            fa: 'هند'
          },
          flag: 'https://restcountries.eu/data/ind.svg'
        }
      },
      Indonesia: {
        name: 'Indonesia',
        slug: 'indonesia',
        population: 275122131,
        domain: '.id',
        sex: {
          male: 50.05,
          female: 49.95
        },
        age: [
          {
            group: '0-14 years',
            value: '23.87',
            male: '32473246',
            female: '31264034'
          },
          {
            group: '15-24 years',
            value: '16.76',
            male: '22786920',
            female: '21960130'
          },
          {
            group: '25-54 years',
            value: '42.56',
            male: '58249570',
            female: '55409579'
          },
          {
            group: '55-64 years',
            value: '8.99',
            male: '11033838',
            female: '12968005'
          },
          {
            group: '65 years and over',
            value: '7.82',
            male: '9099773',
            female: '11781271'
          }
        ],
        info: {
          name: 'Indonesia',
          alpha2Code: 'ID',
          alpha3Code: 'IDN',
          capital: 'Jakarta',
          region: 'Asia',
          subregion: 'South-Eastern Asia',
          latlng: [-5, 120],
          demonym: 'Indonesian',
          area: 1904569,
          gini: 34,
          borders: ['TLS', 'MYS', 'PNG'],
          nativeName: 'Indonesia',
          translations: {
            de: 'Indonesien',
            es: 'Indonesia',
            fr: 'Indonésie',
            ja: 'インドネシア',
            it: 'Indonesia',
            br: 'Indonésia',
            pt: 'Indonésia',
            nl: 'Indonesië',
            hr: 'Indonezija',
            fa: 'اندونزی'
          },
          flag: 'https://restcountries.eu/data/idn.svg'
        }
      },
      Iran: {
        name: 'Iran',
        slug: 'iran',
        population: 85888910,
        domain: '.ir',
        sex: {
          male: 50.69,
          female: 49.31
        },
        age: [
          {
            group: '0-14 years',
            value: '24.11',
            male: '10472844',
            female: '10000028'
          },
          {
            group: '15-24 years',
            value: '13.36',
            male: '5806034',
            female: '5537561'
          },
          {
            group: '25-54 years',
            value: '48.94',
            male: '21235038',
            female: '20327384'
          },
          {
            group: '55-64 years',
            value: '7.72',
            male: '3220074',
            female: '3337420'
          },
          {
            group: '65 years and over',
            value: '5.87',
            male: '2316677',
            female: '2670254'
          }
        ],
        info: {
          name: 'Iran (Islamic Republic of)',
          alpha2Code: 'IR',
          alpha3Code: 'IRN',
          capital: 'Tehran',
          region: 'Asia',
          subregion: 'Southern Asia',
          latlng: [32, 53],
          demonym: 'Iranian',
          area: 1648195,
          gini: 38.3,
          borders: ['AFG', 'ARM', 'AZE', 'IRQ', 'PAK', 'TUR', 'TKM'],
          nativeName: 'ایران',
          translations: {
            de: 'Iran',
            es: 'Iran',
            fr: 'Iran',
            ja: 'イラン・イスラム共和国',
            it: null,
            br: 'Irã',
            pt: 'Irão',
            nl: 'Iran',
            hr: 'Iran',
            fa: 'ایران'
          },
          flag: 'https://restcountries.eu/data/irn.svg'
        }
      },
      Iraq: {
        name: 'Iraq',
        slug: 'iraq',
        population: 39650145,
        domain: '.iq',
        sex: {
          male: 50.34,
          female: 49.66
        },
        age: [
          {
            group: '0-14 years',
            value: '37.02',
            male: '7349868',
            female: '7041405'
          },
          {
            group: '15-24 years',
            value: '19.83',
            male: '3918433',
            female: '3788157'
          },
          {
            group: '25-54 years',
            value: '35.59',
            male: '6919569',
            female: '6914856'
          },
          {
            group: '55-64 years',
            value: '4.23',
            male: '805397',
            female: '839137'
          },
          {
            group: '65 years and over',
            value: '3.33',
            male: '576593',
            female: '719240'
          }
        ],
        info: {
          name: 'Iraq',
          alpha2Code: 'IQ',
          alpha3Code: 'IRQ',
          capital: 'Baghdad',
          region: 'Asia',
          subregion: 'Western Asia',
          latlng: [33, 44],
          demonym: 'Iraqi',
          area: 438317,
          gini: 30.9,
          borders: ['IRN', 'JOR', 'KWT', 'SAU', 'SYR', 'TUR'],
          nativeName: 'العراق',
          translations: {
            de: 'Irak',
            es: 'Irak',
            fr: 'Irak',
            ja: 'イラク',
            it: 'Iraq',
            br: 'Iraque',
            pt: 'Iraque',
            nl: 'Irak',
            hr: 'Irak',
            fa: 'عراق'
          },
          flag: 'https://restcountries.eu/data/irq.svg'
        }
      },
      Ireland: {
        name: 'Ireland',
        slug: 'ireland',
        population: 5224884,
        domain: '.ie',
        sex: {
          male: 49.94,
          female: 50.06
        },
        age: [
          {
            group: '0-14 years',
            value: '21.15',
            male: '560338',
            female: '534570'
          },
          {
            group: '15-24 years',
            value: '12.08',
            male: '316239',
            female: '308872'
          },
          {
            group: '25-54 years',
            value: '42.19',
            male: '1098058',
            female: '1085794'
          },
          {
            group: '55-64 years',
            value: '10.77',
            male: '278836',
            female: '278498'
          },
          {
            group: '65 years and over',
            value: '13.82',
            male: '331772',
            female: '383592'
          }
        ],
        info: {
          name: 'Ireland',
          alpha2Code: 'IE',
          alpha3Code: 'IRL',
          capital: 'Dublin',
          region: 'Europe',
          subregion: 'Northern Europe',
          latlng: [53, -8],
          demonym: 'Irish',
          area: 70273,
          gini: 34.3,
          borders: ['GBR'],
          nativeName: 'Éire',
          translations: {
            de: 'Irland',
            es: 'Irlanda',
            fr: 'Irlande',
            ja: 'アイルランド',
            it: 'Irlanda',
            br: 'Irlanda',
            pt: 'Irlanda',
            nl: 'Ierland',
            hr: 'Irska',
            fa: 'ایرلند'
          },
          flag: 'https://restcountries.eu/data/irl.svg'
        }
      },
      'Isle of Man': {
        name: 'Isle of Man',
        slug: 'isle-of-man',
        population: 90895,
        domain: '.im',
        sex: {
          male: 50.17,
          female: 49.83
        },
        age: [
          {
            group: '0-14 years',
            value: '16.28',
            male: '7688',
            female: '7046'
          },
          {
            group: '15-24 years',
            value: '11.02',
            male: '5328',
            female: '4642'
          },
          {
            group: '25-54 years',
            value: '37.8',
            male: '17080',
            female: '17131'
          },
          {
            group: '55-64 years',
            value: '13.82',
            male: '6284',
            female: '6219'
          },
          {
            group: '65 years and over',
            value: '21.08',
            male: '9023',
            female: '10058'
          }
        ],
        info: {
          name: 'Isle of Man',
          alpha2Code: 'IM',
          alpha3Code: 'IMN',
          capital: 'Douglas',
          region: 'Europe',
          subregion: 'Northern Europe',
          latlng: [54.25, -4.5],
          demonym: 'Manx',
          area: 572,
          gini: null,
          borders: [],
          nativeName: 'Isle of Man',
          translations: {
            de: 'Insel Man',
            es: 'Isla de Man',
            fr: 'Île de Man',
            ja: 'マン島',
            it: 'Isola di Man',
            br: 'Ilha de Man',
            pt: 'Ilha de Man',
            nl: 'Isle of Man',
            hr: 'Otok Man',
            fa: 'جزیره من'
          },
          flag: 'https://restcountries.eu/data/imn.svg'
        }
      },
      Israel: {
        name: 'Israel',
        slug: 'israel',
        population: 8787045,
        domain: '.il',
        sex: {
          male: 50.27,
          female: 49.73
        },
        age: [
          {
            group: '0-14 years',
            value: '26.76',
            male: '1187819',
            female: '1133365'
          },
          {
            group: '15-24 years',
            value: '15.67',
            male: '694142',
            female: '665721'
          },
          {
            group: '25-54 years',
            value: '37.2',
            male: '1648262',
            female: '1579399'
          },
          {
            group: '55-64 years',
            value: '8.4',
            male: '363262',
            female: '365709'
          },
          {
            group: '65 years and over',
            value: '11.96',
            male: '467980',
            female: '569816'
          }
        ],
        info: {
          name: 'Israel',
          alpha2Code: 'IL',
          alpha3Code: 'ISR',
          capital: 'Jerusalem',
          region: 'Asia',
          subregion: 'Western Asia',
          latlng: [31.5, 34.75],
          demonym: 'Israeli',
          area: 20770,
          gini: 39.2,
          borders: ['EGY', 'JOR', 'LBN', 'SYR'],
          nativeName: 'יִשְׂרָאֵל',
          translations: {
            de: 'Israel',
            es: 'Israel',
            fr: 'Israël',
            ja: 'イスラエル',
            it: 'Israele',
            br: 'Israel',
            pt: 'Israel',
            nl: 'Israël',
            hr: 'Izrael',
            fa: 'اسرائیل'
          },
          flag: 'https://restcountries.eu/data/isr.svg'
        }
      },
      Italy: {
        name: 'Italy',
        slug: 'italy',
        population: 62390364,
        domain: '.it',
        sex: {
          male: 48.19,
          female: 51.81
        },
        age: [
          {
            group: '0-14 years',
            value: '13.45',
            male: '4292431',
            female: '4097732'
          },
          {
            group: '15-24 years',
            value: '9.61',
            male: '3005402',
            female: '2989764'
          },
          {
            group: '25-54 years',
            value: '40.86',
            male: '12577764',
            female: '12921614'
          },
          {
            group: '55-64 years',
            value: '14',
            male: '4243735',
            female: '4493581'
          },
          {
            group: '65 years and over',
            value: '22.08',
            male: '5949560',
            female: '7831076'
          }
        ],
        info: {
          name: 'Italy',
          alpha2Code: 'IT',
          alpha3Code: 'ITA',
          capital: 'Rome',
          region: 'Europe',
          subregion: 'Southern Europe',
          latlng: [42.83333333, 12.83333333],
          demonym: 'Italian',
          area: 301336,
          gini: 36,
          borders: ['AUT', 'FRA', 'SMR', 'SVN', 'CHE', 'VAT'],
          nativeName: 'Italia',
          translations: {
            de: 'Italien',
            es: 'Italia',
            fr: 'Italie',
            ja: 'イタリア',
            it: 'Italia',
            br: 'Itália',
            pt: 'Itália',
            nl: 'Italië',
            hr: 'Italija',
            fa: 'ایتالیا'
          },
          flag: 'https://restcountries.eu/data/ita.svg'
        }
      },
      Jamaica: {
        name: 'Jamaica',
        slug: 'jamaica',
        population: 2816602,
        domain: '.jm',
        sex: {
          male: 49.48,
          female: 50.52
        },
        age: [
          {
            group: '0-14 years',
            value: '25.2',
            male: '360199',
            female: '347436'
          },
          {
            group: '15-24 years',
            value: '17.95',
            male: '255102',
            female: '248927'
          },
          {
            group: '25-54 years',
            value: '38.06',
            male: '518583',
            female: '550410'
          },
          {
            group: '55-64 years',
            value: '9.63',
            male: '133890',
            female: '136442'
          },
          {
            group: '65 years and over',
            value: '9.17',
            male: '121969',
            female: '135612'
          }
        ],
        info: {
          name: 'Jamaica',
          alpha2Code: 'JM',
          alpha3Code: 'JAM',
          capital: 'Kingston',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [18.25, -77.5],
          demonym: 'Jamaican',
          area: 10991,
          gini: 45.5,
          borders: [],
          nativeName: 'Jamaica',
          translations: {
            de: 'Jamaika',
            es: 'Jamaica',
            fr: 'Jamaïque',
            ja: 'ジャマイカ',
            it: 'Giamaica',
            br: 'Jamaica',
            pt: 'Jamaica',
            nl: 'Jamaica',
            hr: 'Jamajka',
            fa: 'جامائیکا'
          },
          flag: 'https://restcountries.eu/data/jam.svg'
        }
      },
      'Jan Mayen': {
        name: 'Jan Mayen',
        slug: 'jan-mayen',
        population: 0
      },
      Japan: {
        name: 'Japan',
        slug: 'japan',
        population: 124687293,
        domain: '.jp',
        sex: {
          male: 48.42,
          female: 51.58
        },
        age: [
          {
            group: '0-14 years',
            value: '12.49',
            male: '8047183',
            female: '7623767'
          },
          {
            group: '15-24 years',
            value: '9.47',
            male: '6254352',
            female: '5635377'
          },
          {
            group: '25-54 years',
            value: '36.8',
            male: '22867385',
            female: '23317140'
          },
          {
            group: '55-64 years',
            value: '12.06',
            male: '7564067',
            female: '7570732'
          },
          {
            group: '65 years and over',
            value: '29.18',
            male: '16034973',
            female: '20592496'
          }
        ],
        info: {
          name: 'Japan',
          alpha2Code: 'JP',
          alpha3Code: 'JPN',
          capital: 'Tokyo',
          region: 'Asia',
          subregion: 'Eastern Asia',
          latlng: [36, 138],
          demonym: 'Japanese',
          area: 377930,
          gini: 38.1,
          borders: [],
          nativeName: '日本',
          translations: {
            de: 'Japan',
            es: 'Japón',
            fr: 'Japon',
            ja: '日本',
            it: 'Giappone',
            br: 'Japão',
            pt: 'Japão',
            nl: 'Japan',
            hr: 'Japan',
            fa: 'ژاپن'
          },
          flag: 'https://restcountries.eu/data/jpn.svg'
        }
      },
      Jersey: {
        name: 'Jersey',
        slug: 'jersey',
        population: 101476,
        domain: '.je',
        sex: {
          male: 49.26,
          female: 50.74
        },
        age: [
          {
            group: '0-14 years',
            value: '16.63',
            male: '8689',
            female: '8124'
          },
          {
            group: '15-24 years',
            value: '12.98',
            male: '6764',
            female: '6354'
          },
          {
            group: '25-54 years',
            value: '40.12',
            male: '20499',
            female: '20054'
          },
          {
            group: '55-64 years',
            value: '13.22',
            male: '6515',
            female: '6844'
          },
          {
            group: '65 years and over',
            value: '17.05',
            male: '7324',
            female: '9906'
          }
        ],
        info: {
          name: 'Jersey',
          alpha2Code: 'JE',
          alpha3Code: 'JEY',
          capital: 'Saint Helier',
          region: 'Europe',
          subregion: 'Northern Europe',
          latlng: [49.25, -2.16666666],
          demonym: 'Channel Islander',
          area: 116,
          gini: null,
          borders: [],
          nativeName: 'Jersey',
          translations: {
            de: 'Jersey',
            es: 'Jersey',
            fr: 'Jersey',
            ja: 'ジャージー',
            it: 'Isola di Jersey',
            br: 'Jersey',
            pt: 'Jersey',
            nl: 'Jersey',
            hr: 'Jersey',
            fa: 'جرزی'
          },
          flag: 'https://restcountries.eu/data/jey.svg'
        }
      },
      Jordan: {
        name: 'Jordan',
        slug: 'jordan',
        population: 10909567,
        domain: '.jo',
        sex: {
          male: 52.67,
          female: 47.33
        },
        age: [
          {
            group: '0-14 years',
            value: '33.05',
            male: '1837696',
            female: '1738935'
          },
          {
            group: '15-24 years',
            value: '19.77',
            male: '1126567',
            female: '1012812'
          },
          {
            group: '25-54 years',
            value: '38.39',
            male: '2250328',
            female: '1903996'
          },
          {
            group: '55-64 years',
            value: '5.11',
            male: '290633',
            female: '262827'
          },
          {
            group: '65 years and over',
            value: '3.67',
            male: '194464',
            female: '202386'
          }
        ],
        info: {
          name: 'Jordan',
          alpha2Code: 'JO',
          alpha3Code: 'JOR',
          capital: 'Amman',
          region: 'Asia',
          subregion: 'Western Asia',
          latlng: [31, 36],
          demonym: 'Jordanian',
          area: 89342,
          gini: 35.4,
          borders: ['IRQ', 'ISR', 'SAU', 'SYR'],
          nativeName: 'الأردن',
          translations: {
            de: 'Jordanien',
            es: 'Jordania',
            fr: 'Jordanie',
            ja: 'ヨルダン',
            it: 'Giordania',
            br: 'Jordânia',
            pt: 'Jordânia',
            nl: 'Jordanië',
            hr: 'Jordan',
            fa: 'اردن'
          },
          flag: 'https://restcountries.eu/data/jor.svg'
        }
      },
      Kazakhstan: {
        name: 'Kazakhstan',
        slug: 'kazakhstan',
        population: 19245793,
        domain: '.kz',
        sex: {
          male: 47.58,
          female: 52.42
        },
        age: [
          {
            group: '0-14 years',
            value: '26.13',
            male: '2438148',
            female: '2550535'
          },
          {
            group: '15-24 years',
            value: '12.97',
            male: '1262766',
            female: '1212645'
          },
          {
            group: '25-54 years',
            value: '42.23',
            male: '3960188',
            female: '4102845'
          },
          {
            group: '55-64 years',
            value: '10.25',
            male: '856180',
            female: '1099923'
          },
          {
            group: '65 years and over',
            value: '8.43',
            male: '567269',
            female: '1041450'
          }
        ],
        info: {
          name: 'Kazakhstan',
          alpha2Code: 'KZ',
          alpha3Code: 'KAZ',
          capital: 'Astana',
          region: 'Asia',
          subregion: 'Central Asia',
          latlng: [48, 68],
          demonym: 'Kazakhstani',
          area: 2724900,
          gini: 29,
          borders: ['CHN', 'KGZ', 'RUS', 'TKM', 'UZB'],
          nativeName: 'Қазақстан',
          translations: {
            de: 'Kasachstan',
            es: 'Kazajistán',
            fr: 'Kazakhstan',
            ja: 'カザフスタン',
            it: 'Kazakistan',
            br: 'Cazaquistão',
            pt: 'Cazaquistão',
            nl: 'Kazachstan',
            hr: 'Kazahstan',
            fa: 'قزاقستان'
          },
          flag: 'https://restcountries.eu/data/kaz.svg'
        }
      },
      Kenya: {
        name: 'Kenya',
        slug: 'kenya',
        population: 54685051,
        domain: '.ke',
        sex: {
          male: 49.97,
          female: 50.03
        },
        age: [
          {
            group: '0-14 years',
            value: '38.71',
            male: '10412321',
            female: '10310908'
          },
          {
            group: '15-24 years',
            value: '20.45',
            male: '5486641',
            female: '5460372'
          },
          {
            group: '25-54 years',
            value: '33.75',
            male: '9046946',
            female: '9021207'
          },
          {
            group: '55-64 years',
            value: '4.01',
            male: '1053202',
            female: '1093305'
          },
          {
            group: '65 years and over',
            value: '3.07',
            male: '750988',
            female: '892046'
          }
        ],
        info: {
          name: 'Kenya',
          alpha2Code: 'KE',
          alpha3Code: 'KEN',
          capital: 'Nairobi',
          region: 'Africa',
          subregion: 'Eastern Africa',
          latlng: [1, 38],
          demonym: 'Kenyan',
          area: 580367,
          gini: 47.7,
          borders: ['ETH', 'SOM', 'SSD', 'TZA', 'UGA'],
          nativeName: 'Kenya',
          translations: {
            de: 'Kenia',
            es: 'Kenia',
            fr: 'Kenya',
            ja: 'ケニア',
            it: 'Kenya',
            br: 'Quênia',
            pt: 'Quénia',
            nl: 'Kenia',
            hr: 'Kenija',
            fa: 'کنیا'
          },
          flag: 'https://restcountries.eu/data/ken.svg'
        }
      },
      Kiribati: {
        name: 'Kiribati',
        slug: 'kiribati',
        population: 113001,
        domain: '.ki',
        sex: {
          male: 48.55,
          female: 51.45
        },
        age: [
          {
            group: '0-14 years',
            value: '28.47',
            male: '16223',
            female: '15604'
          },
          {
            group: '15-24 years',
            value: '20.24',
            male: '11171',
            female: '11459'
          },
          {
            group: '25-54 years',
            value: '40.05',
            male: '21530',
            female: '23249'
          },
          {
            group: '55-64 years',
            value: '6.65',
            male: '3350',
            female: '4084'
          },
          {
            group: '65 years and over',
            value: '4.59',
            male: '2004',
            female: '3122'
          }
        ],
        info: {
          name: 'Kiribati',
          alpha2Code: 'KI',
          alpha3Code: 'KIR',
          capital: 'South Tarawa',
          region: 'Oceania',
          subregion: 'Micronesia',
          latlng: [1.41666666, 173],
          demonym: 'I-Kiribati',
          area: 811,
          gini: null,
          borders: [],
          nativeName: 'Kiribati',
          translations: {
            de: 'Kiribati',
            es: 'Kiribati',
            fr: 'Kiribati',
            ja: 'キリバス',
            it: 'Kiribati',
            br: 'Kiribati',
            pt: 'Quiribáti',
            nl: 'Kiribati',
            hr: 'Kiribati',
            fa: 'کیریباتی'
          },
          flag: 'https://restcountries.eu/data/kir.svg'
        }
      },
      'Korea, North': {
        name: 'Korea, North',
        slug: 'korea-north',
        population: 25831360,
        domain: '.kp',
        sex: {
          male: 48.62,
          female: 51.38
        },
        age: [
          {
            group: '0-14 years',
            value: '20.33',
            male: '2680145',
            female: '2571334'
          },
          {
            group: '15-24 years',
            value: '14.39',
            male: '1873814',
            female: '1842269'
          },
          {
            group: '25-54 years',
            value: '43.77',
            male: '5671900',
            female: '5633861'
          },
          {
            group: '55-64 years',
            value: '11.77',
            male: '1454000',
            female: '1585830'
          },
          {
            group: '65 years and over',
            value: '9.75',
            male: '878176',
            female: '1640031'
          }
        ],
        info: {
          name: "Korea (Democratic People's Republic of)",
          alpha2Code: 'KP',
          alpha3Code: 'PRK',
          capital: 'Pyongyang',
          region: 'Asia',
          subregion: 'Eastern Asia',
          latlng: [40, 127],
          demonym: 'North Korean',
          area: 120538,
          gini: null,
          borders: ['CHN', 'KOR', 'RUS'],
          nativeName: '북한',
          translations: {
            de: 'Nordkorea',
            es: 'Corea del Norte',
            fr: 'Corée du Nord',
            ja: '朝鮮民主主義人民共和国',
            it: 'Corea del Nord',
            br: 'Coreia do Norte',
            pt: 'Coreia do Norte',
            nl: 'Noord-Korea',
            hr: 'Sjeverna Koreja',
            fa: 'کره جنوبی'
          },
          flag: 'https://restcountries.eu/data/prk.svg'
        }
      },
      'South Korea': {
        name: 'Korea, South',
        slug: 'korea-south',
        population: 51715162,
        domain: '.kr',
        sex: {
          male: 50.13,
          female: 49.87
        },
        age: [
          {
            group: '0-14 years',
            value: '12.02',
            male: '3191584',
            female: '3025029'
          },
          {
            group: '15-24 years',
            value: '10.75',
            male: '2900013',
            female: '2658057'
          },
          {
            group: '25-54 years',
            value: '44.83',
            male: '12106860',
            female: '11077642'
          },
          {
            group: '55-64 years',
            value: '15.66',
            male: '3958718',
            female: '4142322'
          },
          {
            group: '65 years and over',
            value: '16.74',
            male: '3766138',
            female: '4888799'
          }
        ],
        info: {
          name: 'Korea (Republic of)',
          alpha2Code: 'KR',
          alpha3Code: 'KOR',
          capital: 'Seoul',
          region: 'Asia',
          subregion: 'Eastern Asia',
          latlng: [37, 127.5],
          demonym: 'South Korean',
          area: 100210,
          gini: 31.3,
          borders: ['PRK'],
          nativeName: '대한민국',
          translations: {
            de: 'Südkorea',
            es: 'Corea del Sur',
            fr: 'Corée du Sud',
            ja: '大韓民国',
            it: 'Corea del Sud',
            br: 'Coreia do Sul',
            pt: 'Coreia do Sul',
            nl: 'Zuid-Korea',
            hr: 'Južna Koreja',
            fa: 'کره شمالی'
          },
          flag: 'https://restcountries.eu/data/kor.svg'
        }
      },
      Kosovo: {
        name: 'Kosovo',
        slug: 'kosovo',
        population: 1935259,
        domain:
          '.xk\r\n\r\nnote: assigned as a temporary code under UN Security Council resolution 1244/99',
        sex: {
          male: 51.52,
          female: 48.48
        },
        age: [
          {
            group: '0-14 years',
            value: '24.07',
            male: '241563',
            female: '223568'
          },
          {
            group: '15-24 years',
            value: '16.95',
            male: '170566',
            female: '157063'
          },
          {
            group: '25-54 years',
            value: '42.56',
            male: '433914',
            female: '388595'
          },
          {
            group: '55-64 years',
            value: '8.67',
            male: '85840',
            female: '81782'
          },
          {
            group: '65 years and over',
            value: '7.75',
            male: '63943',
            female: '85940'
          }
        ]
      },
      Kuwait: {
        name: 'Kuwait',
        slug: 'kuwait',
        population: 3032065,
        domain: '.kw',
        sex: {
          male: 58.06,
          female: 41.94
        },
        age: [
          {
            group: '0-14 years',
            value: '24.29',
            male: '378778',
            female: '348512'
          },
          {
            group: '15-24 years',
            value: '14.96',
            male: '245354',
            female: '202642'
          },
          {
            group: '25-54 years',
            value: '52.39',
            male: '984813',
            female: '583632'
          },
          {
            group: '55-64 years',
            value: '5.43',
            male: '90583',
            female: '72026'
          },
          {
            group: '65 years and over',
            value: '2.92',
            male: '38614',
            female: '48752'
          }
        ],
        info: {
          name: 'Kuwait',
          alpha2Code: 'KW',
          alpha3Code: 'KWT',
          capital: 'Kuwait City',
          region: 'Asia',
          subregion: 'Western Asia',
          latlng: [29.5, 45.75],
          demonym: 'Kuwaiti',
          area: 17818,
          gini: null,
          borders: ['IRN', 'SAU'],
          nativeName: 'الكويت',
          translations: {
            de: 'Kuwait',
            es: 'Kuwait',
            fr: 'Koweït',
            ja: 'クウェート',
            it: 'Kuwait',
            br: 'Kuwait',
            pt: 'Kuwait',
            nl: 'Koeweit',
            hr: 'Kuvajt',
            fa: 'کویت'
          },
          flag: 'https://restcountries.eu/data/kwt.svg'
        }
      },
      Kyrgyzstan: {
        name: 'Kyrgyzstan',
        slug: 'kyrgyzstan',
        population: 6018789,
        domain: '.kg',
        sex: {
          male: 48.99,
          female: 51.01
        },
        age: [
          {
            group: '0-14 years',
            value: '30.39',
            male: '930455',
            female: '882137'
          },
          {
            group: '15-24 years',
            value: '15.7',
            male: '475915',
            female: '460604'
          },
          {
            group: '25-54 years',
            value: '40.02',
            male: '1172719',
            female: '1214624'
          },
          {
            group: '55-64 years',
            value: '8.09',
            male: '210994',
            female: '271480'
          },
          {
            group: '65 years and over',
            value: '5.8',
            male: '132134',
            female: '213835'
          }
        ],
        info: {
          name: 'Kyrgyzstan',
          alpha2Code: 'KG',
          alpha3Code: 'KGZ',
          capital: 'Bishkek',
          region: 'Asia',
          subregion: 'Central Asia',
          latlng: [41, 75],
          demonym: 'Kirghiz',
          area: 199951,
          gini: 36.2,
          borders: ['CHN', 'KAZ', 'TJK', 'UZB'],
          nativeName: 'Кыргызстан',
          translations: {
            de: 'Kirgisistan',
            es: 'Kirguizistán',
            fr: 'Kirghizistan',
            ja: 'キルギス',
            it: 'Kirghizistan',
            br: 'Quirguistão',
            pt: 'Quirguizistão',
            nl: 'Kirgizië',
            hr: 'Kirgistan',
            fa: 'قرقیزستان'
          },
          flag: 'https://restcountries.eu/data/kgz.svg'
        }
      },
      Laos: {
        name: 'Laos',
        slug: 'laos',
        population: 7574356,
        domain: '.la',
        sex: {
          male: 49.62,
          female: 50.38
        },
        age: [
          {
            group: '0-14 years',
            value: '31.25',
            male: '1177297',
            female: '1149727'
          },
          {
            group: '15-24 years',
            value: '20.6',
            male: '763757',
            female: '770497'
          },
          {
            group: '25-54 years',
            value: '38.29',
            male: '1407823',
            female: '1443774'
          },
          {
            group: '55-64 years',
            value: '5.73',
            male: '206977',
            female: '219833'
          },
          {
            group: '65 years and over',
            value: '4.13',
            male: '139665',
            female: '168046'
          }
        ],
        info: {
          name: "Lao People's Democratic Republic",
          alpha2Code: 'LA',
          alpha3Code: 'LAO',
          capital: 'Vientiane',
          region: 'Asia',
          subregion: 'South-Eastern Asia',
          latlng: [18, 105],
          demonym: 'Laotian',
          area: 236800,
          gini: 36.7,
          borders: ['MMR', 'KHM', 'CHN', 'THA', 'VNM'],
          nativeName: 'ສປປລາວ',
          translations: {
            de: 'Laos',
            es: 'Laos',
            fr: 'Laos',
            ja: 'ラオス人民民主共和国',
            it: 'Laos',
            br: 'Laos',
            pt: 'Laos',
            nl: 'Laos',
            hr: 'Laos',
            fa: 'لائوس'
          },
          flag: 'https://restcountries.eu/data/lao.svg'
        }
      },
      Latvia: {
        name: 'Latvia',
        slug: 'latvia',
        population: 1862687,
        domain: '.lv',
        sex: {
          male: 46.24,
          female: 53.76
        },
        age: [
          {
            group: '0-14 years',
            value: '15.32',
            male: '148120',
            female: '140028'
          },
          {
            group: '15-24 years',
            value: '9',
            male: '87372',
            female: '81965'
          },
          {
            group: '25-54 years',
            value: '40.41',
            male: '380817',
            female: '379359'
          },
          {
            group: '55-64 years',
            value: '14.77',
            male: '125401',
            female: '152548'
          },
          {
            group: '65 years and over',
            value: '20.5',
            male: '128151',
            female: '257471'
          }
        ],
        info: {
          name: 'Latvia',
          alpha2Code: 'LV',
          alpha3Code: 'LVA',
          capital: 'Riga',
          region: 'Europe',
          subregion: 'Northern Europe',
          latlng: [57, 25],
          demonym: 'Latvian',
          area: 64559,
          gini: 36.6,
          borders: ['BLR', 'EST', 'LTU', 'RUS'],
          nativeName: 'Latvija',
          translations: {
            de: 'Lettland',
            es: 'Letonia',
            fr: 'Lettonie',
            ja: 'ラトビア',
            it: 'Lettonia',
            br: 'Letônia',
            pt: 'Letónia',
            nl: 'Letland',
            hr: 'Latvija',
            fa: 'لتونی'
          },
          flag: 'https://restcountries.eu/data/lva.svg'
        }
      },
      Lebanon: {
        name: 'Lebanon',
        slug: 'lebanon',
        population: 5261372,
        domain: '.lb',
        sex: {
          male: 49.96,
          female: 50.04
        },
        age: [
          {
            group: '0-14 years',
            value: '20.75',
            male: '581015',
            female: '554175'
          },
          {
            group: '15-24 years',
            value: '14.98',
            male: '417739',
            female: '401357'
          },
          {
            group: '25-54 years',
            value: '46.69',
            male: '1296250',
            female: '1257273'
          },
          {
            group: '55-64 years',
            value: '9.62',
            male: '250653',
            female: '275670'
          },
          {
            group: '65 years and over',
            value: '7.96',
            male: '187001',
            female: '248479'
          }
        ],
        info: {
          name: 'Lebanon',
          alpha2Code: 'LB',
          alpha3Code: 'LBN',
          capital: 'Beirut',
          region: 'Asia',
          subregion: 'Western Asia',
          latlng: [33.83333333, 35.83333333],
          demonym: 'Lebanese',
          area: 10452,
          gini: null,
          borders: ['ISR', 'SYR'],
          nativeName: 'لبنان',
          translations: {
            de: 'Libanon',
            es: 'Líbano',
            fr: 'Liban',
            ja: 'レバノン',
            it: 'Libano',
            br: 'Líbano',
            pt: 'Líbano',
            nl: 'Libanon',
            hr: 'Libanon',
            fa: 'لبنان'
          },
          flag: 'https://restcountries.eu/data/lbn.svg'
        }
      },
      Lesotho: {
        name: 'Lesotho',
        slug: 'lesotho',
        population: 2177740,
        domain: '.ls',
        sex: {
          male: 49.49,
          female: 50.51
        },
        age: [
          {
            group: '0-14 years',
            value: '31.3',
            male: '309991',
            female: '306321'
          },
          {
            group: '15-24 years',
            value: '19.26',
            male: '181874',
            female: '197452'
          },
          {
            group: '25-54 years',
            value: '38.86',
            male: '373323',
            female: '391901'
          },
          {
            group: '55-64 years',
            value: '4.98',
            male: '52441',
            female: '45726'
          },
          {
            group: '65 years and over',
            value: '5.6',
            male: '57030',
            female: '53275'
          }
        ],
        info: {
          name: 'Lesotho',
          alpha2Code: 'LS',
          alpha3Code: 'LSO',
          capital: 'Maseru',
          region: 'Africa',
          subregion: 'Southern Africa',
          latlng: [-29.5, 28.5],
          demonym: 'Mosotho',
          area: 30355,
          gini: 52.5,
          borders: ['ZAF'],
          nativeName: 'Lesotho',
          translations: {
            de: 'Lesotho',
            es: 'Lesotho',
            fr: 'Lesotho',
            ja: 'レソト',
            it: 'Lesotho',
            br: 'Lesoto',
            pt: 'Lesoto',
            nl: 'Lesotho',
            hr: 'Lesoto',
            fa: 'لسوتو'
          },
          flag: 'https://restcountries.eu/data/lso.svg'
        }
      },
      Liberia: {
        name: 'Liberia',
        slug: 'liberia',
        population: 5214030,
        domain: '.lr',
        sex: {
          male: 49.97,
          female: 50.03
        },
        age: [
          {
            group: '0-14 years',
            value: '43.35',
            male: '1111479',
            female: '1087871'
          },
          {
            group: '15-24 years',
            value: '20.35',
            male: '516136',
            female: '516137'
          },
          {
            group: '25-54 years',
            value: '30.01',
            male: '747983',
            female: '774615'
          },
          {
            group: '55-64 years',
            value: '3.46',
            male: '89150',
            female: '86231'
          },
          {
            group: '65 years and over',
            value: '2.83',
            male: '70252',
            female: '73442'
          }
        ],
        info: {
          name: 'Liberia',
          alpha2Code: 'LR',
          alpha3Code: 'LBR',
          capital: 'Monrovia',
          region: 'Africa',
          subregion: 'Western Africa',
          latlng: [6.5, -9.5],
          demonym: 'Liberian',
          area: 111369,
          gini: 38.2,
          borders: ['GIN', 'CIV', 'SLE'],
          nativeName: 'Liberia',
          translations: {
            de: 'Liberia',
            es: 'Liberia',
            fr: 'Liberia',
            ja: 'リベリア',
            it: 'Liberia',
            br: 'Libéria',
            pt: 'Libéria',
            nl: 'Liberia',
            hr: 'Liberija',
            fa: 'لیبریا'
          },
          flag: 'https://restcountries.eu/data/lbr.svg'
        }
      },
      Libya: {
        name: 'Libya',
        slug: 'libya',
        population: 7017224,
        domain: '.ly',
        sex: {
          male: 51.18,
          female: 48.82
        },
        age: [
          {
            group: '0-14 years',
            value: '33.65',
            male: '1184755',
            female: '1134084'
          },
          {
            group: '15-24 years',
            value: '15.21',
            male: '534245',
            female: '513728'
          },
          {
            group: '25-54 years',
            value: '41.57',
            male: '1491461',
            female: '1373086'
          },
          {
            group: '55-64 years',
            value: '5.52',
            male: '186913',
            female: '193560'
          },
          {
            group: '65 years and over',
            value: '4.04',
            male: '129177',
            female: '149526'
          }
        ],
        info: {
          name: 'Libya',
          alpha2Code: 'LY',
          alpha3Code: 'LBY',
          capital: 'Tripoli',
          region: 'Africa',
          subregion: 'Northern Africa',
          latlng: [25, 17],
          demonym: 'Libyan',
          area: 1759540,
          gini: null,
          borders: ['DZA', 'TCD', 'EGY', 'NER', 'SDN', 'TUN'],
          nativeName: '‏ليبيا',
          translations: {
            de: 'Libyen',
            es: 'Libia',
            fr: 'Libye',
            ja: 'リビア',
            it: 'Libia',
            br: 'Líbia',
            pt: 'Líbia',
            nl: 'Libië',
            hr: 'Libija',
            fa: 'لیبی'
          },
          flag: 'https://restcountries.eu/data/lby.svg'
        }
      },
      Liechtenstein: {
        name: 'Liechtenstein',
        slug: 'liechtenstein',
        population: 39425,
        domain: '.li',
        sex: {
          male: 49.77,
          female: 50.23
        },
        age: [
          {
            group: '0-14 years',
            value: '15.2',
            male: '3259',
            female: '2688'
          },
          {
            group: '15-24 years',
            value: '11.29',
            male: '2238',
            female: '2181'
          },
          {
            group: '25-54 years',
            value: '40.22',
            male: '7869',
            female: '7872'
          },
          {
            group: '55-64 years',
            value: '14.41',
            male: '2711',
            female: '2930'
          },
          {
            group: '65 years and over',
            value: '18.88',
            male: '3403',
            female: '3986'
          }
        ],
        info: {
          name: 'Liechtenstein',
          alpha2Code: 'LI',
          alpha3Code: 'LIE',
          capital: 'Vaduz',
          region: 'Europe',
          subregion: 'Western Europe',
          latlng: [47.26666666, 9.53333333],
          demonym: 'Liechtensteiner',
          area: 160,
          gini: null,
          borders: ['AUT', 'CHE'],
          nativeName: 'Liechtenstein',
          translations: {
            de: 'Liechtenstein',
            es: 'Liechtenstein',
            fr: 'Liechtenstein',
            ja: 'リヒテンシュタイン',
            it: 'Liechtenstein',
            br: 'Liechtenstein',
            pt: 'Listenstaine',
            nl: 'Liechtenstein',
            hr: 'Lihtenštajn',
            fa: 'لیختن‌اشتاین'
          },
          flag: 'https://restcountries.eu/data/lie.svg'
        }
      },
      Lithuania: {
        name: 'Lithuania',
        slug: 'lithuania',
        population: 2711566,
        domain: '.lt',
        sex: {
          male: 46.17,
          female: 53.83
        },
        age: [
          {
            group: '0-14 years',
            value: '15.26',
            male: '213802',
            female: '202948'
          },
          {
            group: '15-24 years',
            value: '10.23',
            male: '144679',
            female: '134822'
          },
          {
            group: '25-54 years',
            value: '38.96',
            male: '528706',
            female: '535485'
          },
          {
            group: '55-64 years',
            value: '15.1',
            male: '183854',
            female: '228585'
          },
          {
            group: '65 years and over',
            value: '20.45',
            male: '190025',
            female: '368558'
          }
        ],
        info: {
          name: 'Lithuania',
          alpha2Code: 'LT',
          alpha3Code: 'LTU',
          capital: 'Vilnius',
          region: 'Europe',
          subregion: 'Northern Europe',
          latlng: [56, 24],
          demonym: 'Lithuanian',
          area: 65300,
          gini: 37.6,
          borders: ['BLR', 'LVA', 'POL', 'RUS'],
          nativeName: 'Lietuva',
          translations: {
            de: 'Litauen',
            es: 'Lituania',
            fr: 'Lituanie',
            ja: 'リトアニア',
            it: 'Lituania',
            br: 'Lituânia',
            pt: 'Lituânia',
            nl: 'Litouwen',
            hr: 'Litva',
            fa: 'لیتوانی'
          },
          flag: 'https://restcountries.eu/data/ltu.svg'
        }
      },
      Luxembourg: {
        name: 'Luxembourg',
        slug: 'luxembourg',
        population: 639589,
        domain: '.lu',
        sex: {
          male: 50.36,
          female: 49.64
        },
        age: [
          {
            group: '0-14 years',
            value: '16.73',
            male: '54099',
            female: '51004'
          },
          {
            group: '15-24 years',
            value: '11.78',
            male: '37946',
            female: '36061'
          },
          {
            group: '25-54 years',
            value: '43.93',
            male: '141535',
            female: '134531'
          },
          {
            group: '55-64 years',
            value: '12.19',
            male: '39289',
            female: '37337'
          },
          {
            group: '65 years and over',
            value: '15.37',
            male: '43595',
            female: '52984'
          }
        ],
        info: {
          name: 'Luxembourg',
          alpha2Code: 'LU',
          alpha3Code: 'LUX',
          capital: 'Luxembourg',
          region: 'Europe',
          subregion: 'Western Europe',
          latlng: [49.75, 6.16666666],
          demonym: 'Luxembourger',
          area: 2586,
          gini: 30.8,
          borders: ['BEL', 'FRA', 'DEU'],
          nativeName: 'Luxembourg',
          translations: {
            de: 'Luxemburg',
            es: 'Luxemburgo',
            fr: 'Luxembourg',
            ja: 'ルクセンブルク',
            it: 'Lussemburgo',
            br: 'Luxemburgo',
            pt: 'Luxemburgo',
            nl: 'Luxemburg',
            hr: 'Luksemburg',
            fa: 'لوکزامبورگ'
          },
          flag: 'https://restcountries.eu/data/lux.svg'
        }
      },
      Macau: {
        name: 'Macau',
        slug: 'macau',
        population: 630396,
        domain: '.mo',
        sex: {
          male: 47.41,
          female: 52.59
        },
        age: [
          {
            group: '0-14 years',
            value: '13.43',
            male: '42449',
            female: '40051'
          },
          {
            group: '15-24 years',
            value: '10.45',
            male: '33845',
            female: '30354'
          },
          {
            group: '25-54 years',
            value: '49',
            male: '134302',
            female: '166762'
          },
          {
            group: '55-64 years',
            value: '14.57',
            male: '44512',
            female: '45007'
          },
          {
            group: '65 years and over',
            value: '12.56',
            male: '36223',
            female: '40953'
          }
        ],
        info: {
          name: 'Macao',
          alpha2Code: 'MO',
          alpha3Code: 'MAC',
          capital: '',
          region: 'Asia',
          subregion: 'Eastern Asia',
          latlng: [22.16666666, 113.55],
          demonym: 'Chinese',
          area: 30,
          gini: null,
          borders: ['CHN'],
          nativeName: '澳門',
          translations: {
            de: 'Macao',
            es: 'Macao',
            fr: 'Macao',
            ja: 'マカオ',
            it: 'Macao',
            br: 'Macau',
            pt: 'Macau',
            nl: 'Macao',
            hr: 'Makao',
            fa: 'مکائو'
          },
          flag: 'https://restcountries.eu/data/mac.svg'
        }
      },
      Madagascar: {
        name: 'Madagascar',
        slug: 'madagascar',
        population: 27534354,
        domain: '.mg',
        sex: {
          male: 49.99,
          female: 50.01
        },
        age: [
          {
            group: '0-14 years',
            value: '38.86',
            male: '5278838',
            female: '5196036'
          },
          {
            group: '15-24 years',
            value: '20.06',
            male: '2717399',
            female: '2689874'
          },
          {
            group: '25-54 years',
            value: '33.02',
            male: '4443147',
            female: '4456691'
          },
          {
            group: '55-64 years',
            value: '4.6',
            male: '611364',
            female: '627315'
          },
          {
            group: '65 years and over',
            value: '3.47',
            male: '425122',
            female: '509951'
          }
        ],
        info: {
          name: 'Madagascar',
          alpha2Code: 'MG',
          alpha3Code: 'MDG',
          capital: 'Antananarivo',
          region: 'Africa',
          subregion: 'Eastern Africa',
          latlng: [-20, 47],
          demonym: 'Malagasy',
          area: 587041,
          gini: 44.1,
          borders: [],
          nativeName: 'Madagasikara',
          translations: {
            de: 'Madagaskar',
            es: 'Madagascar',
            fr: 'Madagascar',
            ja: 'マダガスカル',
            it: 'Madagascar',
            br: 'Madagascar',
            pt: 'Madagáscar',
            nl: 'Madagaskar',
            hr: 'Madagaskar',
            fa: 'ماداگاسکار'
          },
          flag: 'https://restcountries.eu/data/mdg.svg'
        }
      },
      Malawi: {
        name: 'Malawi',
        slug: 'malawi',
        population: 20308502,
        domain: '.mw',
        sex: {
          male: 49.5,
          female: 50.5
        },
        age: [
          {
            group: '0-14 years',
            value: '45.87',
            male: '4843107',
            female: '4878983'
          },
          {
            group: '15-24 years',
            value: '20.51',
            male: '2151417',
            female: '2195939'
          },
          {
            group: '25-54 years',
            value: '27.96',
            male: '2944936',
            female: '2982195'
          },
          {
            group: '55-64 years',
            value: '2.98',
            male: '303803',
            female: '328092'
          },
          {
            group: '65 years and over',
            value: '2.68',
            male: '249219',
            female: '318938'
          }
        ],
        info: {
          name: 'Malawi',
          alpha2Code: 'MW',
          alpha3Code: 'MWI',
          capital: 'Lilongwe',
          region: 'Africa',
          subregion: 'Eastern Africa',
          latlng: [-13.5, 34],
          demonym: 'Malawian',
          area: 118484,
          gini: 39,
          borders: ['MOZ', 'TZA', 'ZMB'],
          nativeName: 'Malawi',
          translations: {
            de: 'Malawi',
            es: 'Malawi',
            fr: 'Malawi',
            ja: 'マラウイ',
            it: 'Malawi',
            br: 'Malawi',
            pt: 'Malávi',
            nl: 'Malawi',
            hr: 'Malavi',
            fa: 'مالاوی'
          },
          flag: 'https://restcountries.eu/data/mwi.svg'
        }
      },
      Malaysia: {
        name: 'Malaysia',
        slug: 'malaysia',
        population: 33519406,
        domain: '.my',
        sex: {
          male: 50.62,
          female: 49.38
        },
        age: [
          {
            group: '0-14 years',
            value: '26.8',
            male: '4504562',
            female: '4246681'
          },
          {
            group: '15-24 years',
            value: '16.63',
            male: '2760244',
            female: '2670186'
          },
          {
            group: '25-54 years',
            value: '40.86',
            male: '6737826',
            female: '6604776'
          },
          {
            group: '55-64 years',
            value: '8.81',
            male: '1458038',
            female: '1418280'
          },
          {
            group: '65 years and over',
            value: '6.9',
            male: '1066627',
            female: '1184863'
          }
        ],
        info: {
          name: 'Malaysia',
          alpha2Code: 'MY',
          alpha3Code: 'MYS',
          capital: 'Kuala Lumpur',
          region: 'Asia',
          subregion: 'South-Eastern Asia',
          latlng: [2.5, 112.5],
          demonym: 'Malaysian',
          area: 330803,
          gini: 46.2,
          borders: ['BRN', 'IDN', 'THA'],
          nativeName: 'Malaysia',
          translations: {
            de: 'Malaysia',
            es: 'Malasia',
            fr: 'Malaisie',
            ja: 'マレーシア',
            it: 'Malesia',
            br: 'Malásia',
            pt: 'Malásia',
            nl: 'Maleisië',
            hr: 'Malezija',
            fa: 'مالزی'
          },
          flag: 'https://restcountries.eu/data/mys.svg'
        }
      },
      Maldives: {
        name: 'Maldives',
        slug: 'maldives',
        population: 390669,
        domain: '.mv',
        sex: {
          male: 52.99,
          female: 47.01
        },
        age: [
          {
            group: '0-14 years',
            value: '22.13',
            male: '44260',
            female: '42477'
          },
          {
            group: '15-24 years',
            value: '17.24',
            male: '37826',
            female: '29745'
          },
          {
            group: '25-54 years',
            value: '48.91',
            male: '104217',
            female: '87465'
          },
          {
            group: '55-64 years',
            value: '6.91',
            male: '12942',
            female: '14123'
          },
          {
            group: '65 years and over',
            value: '4.81',
            male: '8417',
            female: '10432'
          }
        ],
        info: {
          name: 'Maldives',
          alpha2Code: 'MV',
          alpha3Code: 'MDV',
          capital: 'Malé',
          region: 'Asia',
          subregion: 'Southern Asia',
          latlng: [3.25, 73],
          demonym: 'Maldivan',
          area: 300,
          gini: 37.4,
          borders: [],
          nativeName: 'Maldives',
          translations: {
            de: 'Malediven',
            es: 'Maldivas',
            fr: 'Maldives',
            ja: 'モルディブ',
            it: 'Maldive',
            br: 'Maldivas',
            pt: 'Maldivas',
            nl: 'Maldiven',
            hr: 'Maldivi',
            fa: 'مالدیو'
          },
          flag: 'https://restcountries.eu/data/mdv.svg'
        }
      },
      Mali: {
        name: 'Mali',
        slug: 'mali',
        population: 20137527,
        domain: '.ml',
        sex: {
          male: 48.66,
          female: 51.34
        },
        age: [
          {
            group: '0-14 years',
            value: '47.69',
            male: '4689121',
            female: '4636685'
          },
          {
            group: '15-24 years',
            value: '19',
            male: '1768772',
            female: '1945582'
          },
          {
            group: '25-54 years',
            value: '26.61',
            male: '2395566',
            female: '2806830'
          },
          {
            group: '55-64 years',
            value: '3.68',
            male: '367710',
            female: '352170'
          },
          {
            group: '65 years and over',
            value: '3.02',
            male: '293560',
            female: '297401'
          }
        ],
        info: {
          name: 'Mali',
          alpha2Code: 'ML',
          alpha3Code: 'MLI',
          capital: 'Bamako',
          region: 'Africa',
          subregion: 'Western Africa',
          latlng: [17, -4],
          demonym: 'Malian',
          area: 1240192,
          gini: 33,
          borders: ['DZA', 'BFA', 'GIN', 'CIV', 'MRT', 'NER', 'SEN'],
          nativeName: 'Mali',
          translations: {
            de: 'Mali',
            es: 'Mali',
            fr: 'Mali',
            ja: 'マリ',
            it: 'Mali',
            br: 'Mali',
            pt: 'Mali',
            nl: 'Mali',
            hr: 'Mali',
            fa: 'مالی'
          },
          flag: 'https://restcountries.eu/data/mli.svg'
        }
      },
      Malta: {
        name: 'Malta',
        slug: 'malta',
        population: 460891,
        domain: '.mt',
        sex: {
          male: 50.35,
          female: 49.65
        },
        age: [
          {
            group: '0-14 years',
            value: '14.38',
            male: '33934',
            female: '31823'
          },
          {
            group: '15-24 years',
            value: '10.33',
            male: '24445',
            female: '22811'
          },
          {
            group: '25-54 years',
            value: '41.1',
            male: '97685',
            female: '90264'
          },
          {
            group: '55-64 years',
            value: '12.88',
            male: '29533',
            female: '29353'
          },
          {
            group: '65 years and over',
            value: '21.3',
            male: '44644',
            female: '52775'
          }
        ],
        info: {
          name: 'Malta',
          alpha2Code: 'MT',
          alpha3Code: 'MLT',
          capital: 'Valletta',
          region: 'Europe',
          subregion: 'Southern Europe',
          latlng: [35.83333333, 14.58333333],
          demonym: 'Maltese',
          area: 316,
          gini: null,
          borders: [],
          nativeName: 'Malta',
          translations: {
            de: 'Malta',
            es: 'Malta',
            fr: 'Malte',
            ja: 'マルタ',
            it: 'Malta',
            br: 'Malta',
            pt: 'Malta',
            nl: 'Malta',
            hr: 'Malta',
            fa: 'مالت'
          },
          flag: 'https://restcountries.eu/data/mlt.svg'
        }
      },
      'Marshall Islands': {
        name: 'Marshall Islands',
        slug: 'marshall-islands',
        population: 78831,
        domain: '.mh',
        sex: {
          male: 50.78,
          female: 49.22
        },
        age: [
          {
            group: '0-14 years',
            value: '32.94',
            male: '13090',
            female: '12575'
          },
          {
            group: '15-24 years',
            value: '19.09',
            male: '7568',
            female: '7308'
          },
          {
            group: '25-54 years',
            value: '37.35',
            male: '14834',
            female: '14270'
          },
          {
            group: '55-64 years',
            value: '5.92',
            male: '2269',
            female: '2341'
          },
          {
            group: '65 years and over',
            value: '4.7',
            male: '1805',
            female: '1857'
          }
        ],
        info: {
          name: 'Marshall Islands',
          alpha2Code: 'MH',
          alpha3Code: 'MHL',
          capital: 'Majuro',
          region: 'Oceania',
          subregion: 'Micronesia',
          latlng: [9, 168],
          demonym: 'Marshallese',
          area: 181,
          gini: null,
          borders: [],
          nativeName: 'M̧ajeļ',
          translations: {
            de: 'Marshallinseln',
            es: 'Islas Marshall',
            fr: 'Îles Marshall',
            ja: 'マーシャル諸島',
            it: 'Isole Marshall',
            br: 'Ilhas Marshall',
            pt: 'Ilhas Marshall',
            nl: 'Marshalleilanden',
            hr: 'Maršalovi Otoci',
            fa: 'جزایر مارشال'
          },
          flag: 'https://restcountries.eu/data/mhl.svg'
        }
      },
      Mauritania: {
        name: 'Mauritania',
        slug: 'mauritania',
        population: 4079284,
        domain: '.mr',
        sex: {
          male: 48.16,
          female: 51.84
        },
        age: [
          {
            group: '0-14 years',
            value: '37.56',
            male: '755788',
            female: '748671'
          },
          {
            group: '15-24 years',
            value: '19.71',
            male: '387140',
            female: '402462'
          },
          {
            group: '25-54 years',
            value: '33.91',
            male: '630693',
            female: '727518'
          },
          {
            group: '55-64 years',
            value: '4.9',
            male: '88888',
            female: '107201'
          },
          {
            group: '65 years and over',
            value: '3.92',
            male: '66407',
            female: '90707'
          }
        ],
        info: {
          name: 'Mauritania',
          alpha2Code: 'MR',
          alpha3Code: 'MRT',
          capital: 'Nouakchott',
          region: 'Africa',
          subregion: 'Western Africa',
          latlng: [20, -12],
          demonym: 'Mauritanian',
          area: 1030700,
          gini: 40.5,
          borders: ['DZA', 'MLI', 'SEN', 'ESH'],
          nativeName: 'موريتانيا',
          translations: {
            de: 'Mauretanien',
            es: 'Mauritania',
            fr: 'Mauritanie',
            ja: 'モーリタニア',
            it: 'Mauritania',
            br: 'Mauritânia',
            pt: 'Mauritânia',
            nl: 'Mauritanië',
            hr: 'Mauritanija',
            fa: 'موریتانی'
          },
          flag: 'https://restcountries.eu/data/mrt.svg'
        }
      },
      Mauritius: {
        name: 'Mauritius',
        slug: 'mauritius',
        population: 1386129,
        domain: '.mu',
        sex: {
          male: 49.09,
          female: 50.91
        },
        age: [
          {
            group: '0-14 years',
            value: '19.44',
            male: '137010',
            female: '131113'
          },
          {
            group: '15-24 years',
            value: '14.06',
            male: '98480',
            female: '95472'
          },
          {
            group: '25-54 years',
            value: '43.11',
            male: '297527',
            female: '297158'
          },
          {
            group: '55-64 years',
            value: '12.31',
            male: '80952',
            female: '88785'
          },
          {
            group: '65 years and over',
            value: '11.08',
            male: '63230',
            female: '89638'
          }
        ],
        info: {
          name: 'Mauritius',
          alpha2Code: 'MU',
          alpha3Code: 'MUS',
          capital: 'Port Louis',
          region: 'Africa',
          subregion: 'Eastern Africa',
          latlng: [-20.28333333, 57.55],
          demonym: 'Mauritian',
          area: 2040,
          gini: null,
          borders: [],
          nativeName: 'Maurice',
          translations: {
            de: 'Mauritius',
            es: 'Mauricio',
            fr: 'Île Maurice',
            ja: 'モーリシャス',
            it: 'Mauritius',
            br: 'Maurício',
            pt: 'Maurícia',
            nl: 'Mauritius',
            hr: 'Mauricijus',
            fa: 'موریس'
          },
          flag: 'https://restcountries.eu/data/mus.svg'
        }
      },
      Mexico: {
        name: 'Mexico',
        slug: 'mexico',
        population: 130207371,
        domain: '.mx',
        sex: {
          male: 49,
          female: 51
        },
        age: [
          {
            group: '0-14 years',
            value: '26.01',
            male: '17111199',
            female: '16349767'
          },
          {
            group: '15-24 years',
            value: '16.97',
            male: '11069260',
            female: '10762784'
          },
          {
            group: '25-54 years',
            value: '41.06',
            male: '25604223',
            female: '27223720'
          },
          {
            group: '55-64 years',
            value: '8.29',
            male: '4879048',
            female: '5784176'
          },
          {
            group: '65 years and over',
            value: '7.67',
            male: '4373807',
            female: '5491581'
          }
        ],
        info: {
          name: 'Mexico',
          alpha2Code: 'MX',
          alpha3Code: 'MEX',
          capital: 'Mexico City',
          region: 'Americas',
          subregion: 'Central America',
          latlng: [23, -102],
          demonym: 'Mexican',
          area: 1964375,
          gini: 47,
          borders: ['BLZ', 'GTM', 'USA'],
          nativeName: 'México',
          translations: {
            de: 'Mexiko',
            es: 'México',
            fr: 'Mexique',
            ja: 'メキシコ',
            it: 'Messico',
            br: 'México',
            pt: 'México',
            nl: 'Mexico',
            hr: 'Meksiko',
            fa: 'مکزیک'
          },
          flag: 'https://restcountries.eu/data/mex.svg'
        }
      },
      'Micronesia, Federated States of': {
        name: 'Micronesia, Federated States of',
        slug: 'micronesia-federated-states-of',
        population: 101675,
        domain: '.fm',
        sex: {
          male: 49.1,
          female: 50.9
        },
        age: [
          {
            group: '0-14 years',
            value: '28.24',
            male: '14585',
            female: '14129'
          },
          {
            group: '15-24 years',
            value: '18.62',
            male: '9473',
            female: '9461'
          },
          {
            group: '25-54 years',
            value: '40.81',
            male: '19998',
            female: '21493'
          },
          {
            group: '55-64 years',
            value: '7.38',
            male: '3602',
            female: '3898'
          },
          {
            group: '65 years and over',
            value: '4.95',
            male: '2260',
            female: '2776'
          }
        ],
        info: {
          name: 'Micronesia (Federated States of)',
          alpha2Code: 'FM',
          alpha3Code: 'FSM',
          capital: 'Palikir',
          region: 'Oceania',
          subregion: 'Micronesia',
          latlng: [6.91666666, 158.25],
          demonym: 'Micronesian',
          area: 702,
          gini: null,
          borders: [],
          nativeName: 'Micronesia',
          translations: {
            de: 'Mikronesien',
            es: 'Micronesia',
            fr: 'Micronésie',
            ja: 'ミクロネシア連邦',
            it: 'Micronesia',
            br: 'Micronésia',
            pt: 'Micronésia',
            nl: 'Micronesië',
            hr: 'Mikronezija',
            fa: 'ایالات فدرال میکرونزی'
          },
          flag: 'https://restcountries.eu/data/fsm.svg'
        }
      },
      Moldova: {
        name: 'Moldova',
        slug: 'moldova',
        population: 3323875,
        domain: '.md',
        sex: {
          male: 48.89,
          female: 51.11
        },
        age: [
          {
            group: '0-14 years',
            value: '18.31',
            male: '317243',
            female: '298673'
          },
          {
            group: '15-24 years',
            value: '11.27',
            male: '196874',
            female: '182456'
          },
          {
            group: '25-54 years',
            value: '43.13',
            male: '738103',
            female: '712892'
          },
          {
            group: '55-64 years',
            value: '13.26',
            male: '205693',
            female: '240555'
          },
          {
            group: '65 years and over',
            value: '14.03',
            male: '186949',
            female: '285058'
          }
        ],
        info: {
          name: 'Moldova (Republic of)',
          alpha2Code: 'MD',
          alpha3Code: 'MDA',
          capital: 'Chișinău',
          region: 'Europe',
          subregion: 'Eastern Europe',
          latlng: [47, 29],
          demonym: 'Moldovan',
          area: 33846,
          gini: 33,
          borders: ['ROU', 'UKR'],
          nativeName: 'Moldova',
          translations: {
            de: 'Moldawie',
            es: 'Moldavia',
            fr: 'Moldavie',
            ja: 'モルドバ共和国',
            it: 'Moldavia',
            br: 'Moldávia',
            pt: 'Moldávia',
            nl: 'Moldavië',
            hr: 'Moldova',
            fa: 'مولداوی'
          },
          flag: 'https://restcountries.eu/data/mda.svg'
        }
      },
      Monaco: {
        name: 'Monaco',
        slug: 'monaco',
        population: 31223,
        domain: '.mc',
        sex: {
          male: 48.48,
          female: 51.52
        },
        age: [
          {
            group: '0-14 years',
            value: '9.41',
            male: '1497',
            female: '1415'
          },
          {
            group: '15-24 years',
            value: '9.52',
            male: '1538',
            female: '1406'
          },
          {
            group: '25-54 years',
            value: '30.46',
            male: '4779',
            female: '4644'
          },
          {
            group: '55-64 years',
            value: '15.47',
            male: '2370',
            female: '2417'
          },
          {
            group: '65 years and over',
            value: '35.15',
            male: '4817',
            female: '6057'
          }
        ],
        info: {
          name: 'Monaco',
          alpha2Code: 'MC',
          alpha3Code: 'MCO',
          capital: 'Monaco',
          region: 'Europe',
          subregion: 'Western Europe',
          latlng: [43.73333333, 7.4],
          demonym: 'Monegasque',
          area: 2.02,
          gini: null,
          borders: ['FRA'],
          nativeName: 'Monaco',
          translations: {
            de: 'Monaco',
            es: 'Mónaco',
            fr: 'Monaco',
            ja: 'モナコ',
            it: 'Principato di Monaco',
            br: 'Mônaco',
            pt: 'Mónaco',
            nl: 'Monaco',
            hr: 'Monako',
            fa: 'موناکو'
          },
          flag: 'https://restcountries.eu/data/mco.svg'
        }
      },
      Mongolia: {
        name: 'Mongolia',
        slug: 'mongolia',
        population: 3198913,
        domain: '.mn',
        sex: {
          male: 48.8,
          female: 51.2
        },
        age: [
          {
            group: '0-14 years',
            value: '26.96',
            male: '435596',
            female: '418524'
          },
          {
            group: '15-24 years',
            value: '14.93',
            male: '239495',
            female: '233459'
          },
          {
            group: '25-54 years',
            value: '45.29',
            male: '694481',
            female: '740334'
          },
          {
            group: '55-64 years',
            value: '8.04',
            male: '115560',
            female: '139129'
          },
          {
            group: '65 years and over',
            value: '4.78',
            male: '60966',
            female: '90482'
          }
        ],
        info: {
          name: 'Mongolia',
          alpha2Code: 'MN',
          alpha3Code: 'MNG',
          capital: 'Ulan Bator',
          region: 'Asia',
          subregion: 'Eastern Asia',
          latlng: [46, 105],
          demonym: 'Mongolian',
          area: 1564110,
          gini: 36.5,
          borders: ['CHN', 'RUS'],
          nativeName: 'Монгол улс',
          translations: {
            de: 'Mongolei',
            es: 'Mongolia',
            fr: 'Mongolie',
            ja: 'モンゴル',
            it: 'Mongolia',
            br: 'Mongólia',
            pt: 'Mongólia',
            nl: 'Mongolië',
            hr: 'Mongolija',
            fa: 'مغولستان'
          },
          flag: 'https://restcountries.eu/data/mng.svg'
        }
      },
      Montenegro: {
        name: 'Montenegro',
        slug: 'montenegro',
        population: 607414,
        domain: '.me',
        sex: {
          male: 49.26,
          female: 50.74
        },
        age: [
          {
            group: '0-14 years',
            value: '18.14',
            male: '57402',
            female: '53217'
          },
          {
            group: '15-24 years',
            value: '12.78',
            male: '40220',
            female: '37720'
          },
          {
            group: '25-54 years',
            value: '39.65',
            male: '120374',
            female: '121461'
          },
          {
            group: '55-64 years',
            value: '13.41',
            male: '40099',
            female: '41670'
          },
          {
            group: '65 years and over',
            value: '16.02',
            male: '42345',
            female: '55351'
          }
        ],
        info: {
          name: 'Montenegro',
          alpha2Code: 'ME',
          alpha3Code: 'MNE',
          capital: 'Podgorica',
          region: 'Europe',
          subregion: 'Southern Europe',
          latlng: [42.5, 19.3],
          demonym: 'Montenegrin',
          area: 13812,
          gini: 30,
          borders: ['ALB', 'BIH', 'HRV', 'KOS', 'SRB'],
          nativeName: 'Црна Гора',
          translations: {
            de: 'Montenegro',
            es: 'Montenegro',
            fr: 'Monténégro',
            ja: 'モンテネグロ',
            it: 'Montenegro',
            br: 'Montenegro',
            pt: 'Montenegro',
            nl: 'Montenegro',
            hr: 'Crna Gora',
            fa: 'مونته‌نگرو'
          },
          flag: 'https://restcountries.eu/data/mne.svg'
        }
      },
      Montserrat: {
        name: 'Montserrat',
        slug: 'montserrat',
        population: 5387,
        domain: '.ms',
        sex: {
          male: 49.9,
          female: 50.1
        },
        age: [
          {
            group: '0-14 years',
            value: '16.02',
            male: '443',
            female: '418'
          },
          {
            group: '15-24 years',
            value: '20.55',
            male: '579',
            female: '525'
          },
          {
            group: '25-54 years',
            value: '47.09',
            male: '1217',
            female: '1313'
          },
          {
            group: '55-64 years',
            value: '9.79',
            male: '246',
            female: '280'
          },
          {
            group: '65 years and over',
            value: '6.55',
            male: '196',
            female: '156'
          }
        ],
        info: {
          name: 'Montserrat',
          alpha2Code: 'MS',
          alpha3Code: 'MSR',
          capital: 'Plymouth',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [16.75, -62.2],
          demonym: 'Montserratian',
          area: 102,
          gini: null,
          borders: [],
          nativeName: 'Montserrat',
          translations: {
            de: 'Montserrat',
            es: 'Montserrat',
            fr: 'Montserrat',
            ja: 'モントセラト',
            it: 'Montserrat',
            br: 'Montserrat',
            pt: 'Monserrate',
            nl: 'Montserrat',
            hr: 'Montserrat',
            fa: 'مایوت'
          },
          flag: 'https://restcountries.eu/data/msr.svg'
        }
      },
      Morocco: {
        name: 'Morocco',
        slug: 'morocco',
        population: 36561813,
        domain: '.ma',
        sex: {
          male: 49.9,
          female: 50.1
        },
        age: [
          {
            group: '0-14 years',
            value: '27.04',
            male: '4905626',
            female: '4709333'
          },
          {
            group: '15-24 years',
            value: '16.55',
            male: '2953523',
            female: '2930708'
          },
          {
            group: '25-54 years',
            value: '40.64',
            male: '7126781',
            female: '7325709'
          },
          {
            group: '55-64 years',
            value: '8.67',
            male: '1533771',
            female: '1548315'
          },
          {
            group: '65 years and over',
            value: '7.11',
            male: '1225307',
            female: '1302581'
          },
          'note: does not include data from the former Western Sahara'
        ],
        info: {
          name: 'Morocco',
          alpha2Code: 'MA',
          alpha3Code: 'MAR',
          capital: 'Rabat',
          region: 'Africa',
          subregion: 'Northern Africa',
          latlng: [32, -5],
          demonym: 'Moroccan',
          area: 446550,
          gini: 40.9,
          borders: ['DZA', 'ESH', 'ESP'],
          nativeName: 'المغرب',
          translations: {
            de: 'Marokko',
            es: 'Marruecos',
            fr: 'Maroc',
            ja: 'モロッコ',
            it: 'Marocco',
            br: 'Marrocos',
            pt: 'Marrocos',
            nl: 'Marokko',
            hr: 'Maroko',
            fa: 'مراکش'
          },
          flag: 'https://restcountries.eu/data/mar.svg'
        }
      },
      Mozambique: {
        name: 'Mozambique',
        slug: 'mozambique',
        population: 30888034,
        domain: '.mz',
        sex: {
          male: 49.22,
          female: 50.78
        },
        age: [
          {
            group: '0-14 years',
            value: '45.57',
            male: '6950800',
            female: '6766373'
          },
          {
            group: '15-24 years',
            value: '19.91',
            male: '2997529',
            female: '2994927'
          },
          {
            group: '25-54 years',
            value: '28.28',
            male: '3949085',
            female: '4564031'
          },
          {
            group: '55-64 years',
            value: '3.31',
            male: '485454',
            female: '509430'
          },
          {
            group: '65 years and over',
            value: '2.93',
            male: '430797',
            female: '449771'
          }
        ],
        info: {
          name: 'Mozambique',
          alpha2Code: 'MZ',
          alpha3Code: 'MOZ',
          capital: 'Maputo',
          region: 'Africa',
          subregion: 'Eastern Africa',
          latlng: [-18.25, 35],
          demonym: 'Mozambican',
          area: 801590,
          gini: 45.7,
          borders: ['MWI', 'ZAF', 'SWZ', 'TZA', 'ZMB', 'ZWE'],
          nativeName: 'Moçambique',
          translations: {
            de: 'Mosambik',
            es: 'Mozambique',
            fr: 'Mozambique',
            ja: 'モザンビーク',
            it: 'Mozambico',
            br: 'Moçambique',
            pt: 'Moçambique',
            nl: 'Mozambique',
            hr: 'Mozambik',
            fa: 'موزامبیک'
          },
          flag: 'https://restcountries.eu/data/moz.svg'
        }
      },
      Namibia: {
        name: 'Namibia',
        slug: 'namibia',
        population: 2678191,
        domain: '.na',
        sex: {
          male: 48.99,
          female: 51.01
        },
        age: [
          {
            group: '0-14 years',
            value: '35.68',
            male: '473937',
            female: '464453'
          },
          {
            group: '15-24 years',
            value: '20.27',
            male: '267106',
            female: '265882'
          },
          {
            group: '25-54 years',
            value: '35.47',
            male: '449132',
            female: '483811'
          },
          {
            group: '55-64 years',
            value: '4.68',
            male: '54589',
            female: '68619'
          },
          {
            group: '65 years and over',
            value: '3.9',
            male: '43596',
            female: '58948'
          }
        ],
        info: {
          name: 'Namibia',
          alpha2Code: 'NA',
          alpha3Code: 'NAM',
          capital: 'Windhoek',
          region: 'Africa',
          subregion: 'Southern Africa',
          latlng: [-22, 17],
          demonym: 'Namibian',
          area: 825615,
          gini: 63.9,
          borders: ['AGO', 'BWA', 'ZAF', 'ZMB'],
          nativeName: 'Namibia',
          translations: {
            de: 'Namibia',
            es: 'Namibia',
            fr: 'Namibie',
            ja: 'ナミビア',
            it: 'Namibia',
            br: 'Namíbia',
            pt: 'Namíbia',
            nl: 'Namibië',
            hr: 'Namibija',
            fa: 'نامیبیا'
          },
          flag: 'https://restcountries.eu/data/nam.svg'
        }
      },
      Nauru: {
        name: 'Nauru',
        slug: 'nauru',
        population: 9770,
        domain: '.nr',
        sex: {
          male: 46.7,
          female: 53.3
        },
        age: [
          {
            group: '0-14 years',
            value: '30.87',
            male: '1337',
            female: '1684'
          },
          {
            group: '15-24 years',
            value: '16.35',
            male: '734',
            female: '866'
          },
          {
            group: '25-54 years',
            value: '42.57',
            male: '2115',
            female: '2050'
          },
          {
            group: '55-64 years',
            value: '6.72',
            male: '262',
            female: '396'
          },
          {
            group: '65 years and over',
            value: '3.48',
            male: '122',
            female: '219'
          }
        ],
        info: {
          name: 'Nauru',
          alpha2Code: 'NR',
          alpha3Code: 'NRU',
          capital: 'Yaren',
          region: 'Oceania',
          subregion: 'Micronesia',
          latlng: [-0.53333333, 166.91666666],
          demonym: 'Nauruan',
          area: 21,
          gini: null,
          borders: [],
          nativeName: 'Nauru',
          translations: {
            de: 'Nauru',
            es: 'Nauru',
            fr: 'Nauru',
            ja: 'ナウル',
            it: 'Nauru',
            br: 'Nauru',
            pt: 'Nauru',
            nl: 'Nauru',
            hr: 'Nauru',
            fa: 'نائورو'
          },
          flag: 'https://restcountries.eu/data/nru.svg'
        }
      },
      'Navassa Island': {
        name: 'Navassa Island',
        slug: 'navassa-island',
        population: 0
      },
      Nepal: {
        name: 'Nepal',
        slug: 'nepal',
        population: 30424878,
        domain: '.np',
        sex: {
          male: 49.01,
          female: 50.99
        },
        age: [
          {
            group: '0-14 years',
            value: '28.36',
            male: '4526786',
            female: '4073642'
          },
          {
            group: '15-24 years',
            value: '20.93',
            male: '3276431',
            female: '3070843'
          },
          {
            group: '25-54 years',
            value: '38.38',
            male: '5251553',
            female: '6387365'
          },
          {
            group: '55-64 years',
            value: '6.64',
            male: '954836',
            female: '1059360'
          },
          {
            group: '65 years and over',
            value: '5.69',
            male: '852969',
            female: '874092'
          }
        ],
        info: {
          name: 'Nepal',
          alpha2Code: 'NP',
          alpha3Code: 'NPL',
          capital: 'Kathmandu',
          region: 'Asia',
          subregion: 'Southern Asia',
          latlng: [28, 84],
          demonym: 'Nepalese',
          area: 147181,
          gini: 32.8,
          borders: ['CHN', 'IND'],
          nativeName: 'नेपाल',
          translations: {
            de: 'Népal',
            es: 'Nepal',
            fr: 'Népal',
            ja: 'ネパール',
            it: 'Nepal',
            br: 'Nepal',
            pt: 'Nepal',
            nl: 'Nepal',
            hr: 'Nepal',
            fa: 'نپال'
          },
          flag: 'https://restcountries.eu/data/npl.svg'
        }
      },
      Netherlands: {
        name: 'Netherlands',
        slug: 'netherlands',
        population: 17337403,
        domain: '.nl',
        sex: {
          male: 49.45,
          female: 50.55
        },
        age: [
          {
            group: '0-14 years',
            value: '16.11',
            male: '1425547',
            female: '1358894'
          },
          {
            group: '15-24 years',
            value: '11.91',
            male: '1049000',
            female: '1008763'
          },
          {
            group: '25-54 years',
            value: '38.47',
            male: '3334064',
            female: '3313238'
          },
          {
            group: '55-64 years',
            value: '13.69',
            male: '1177657',
            female: '1188613'
          },
          {
            group: '65 years and over',
            value: '19.82',
            male: '1558241',
            female: '1866380'
          }
        ],
        info: {
          name: 'Netherlands',
          alpha2Code: 'NL',
          alpha3Code: 'NLD',
          capital: 'Amsterdam',
          region: 'Europe',
          subregion: 'Western Europe',
          latlng: [52.5, 5.75],
          demonym: 'Dutch',
          area: 41850,
          gini: 30.9,
          borders: ['BEL', 'DEU'],
          nativeName: 'Nederland',
          translations: {
            de: 'Niederlande',
            es: 'Países Bajos',
            fr: 'Pays-Bas',
            ja: 'オランダ',
            it: 'Paesi Bassi',
            br: 'Holanda',
            pt: 'Países Baixos',
            nl: 'Nederland',
            hr: 'Nizozemska',
            fa: 'پادشاهی هلند'
          },
          flag: 'https://restcountries.eu/data/nld.svg'
        }
      },
      'New Caledonia': {
        name: 'New Caledonia',
        slug: 'new-caledonia',
        population: 293608,
        domain: '.nc',
        sex: {
          male: 49.86,
          female: 50.14
        },
        age: [
          {
            group: '0-14 years',
            value: '21.74',
            male: '32227',
            female: '30819'
          },
          {
            group: '15-24 years',
            value: '15.63',
            male: '23164',
            female: '22163'
          },
          {
            group: '25-54 years',
            value: '43.73',
            male: '63968',
            female: '62856'
          },
          {
            group: '55-64 years',
            value: '9.06',
            male: '12700',
            female: '13568'
          },
          {
            group: '65 years and over',
            value: '9.84',
            male: '12552',
            female: '15992'
          }
        ],
        info: {
          name: 'New Caledonia',
          alpha2Code: 'NC',
          alpha3Code: 'NCL',
          capital: 'Nouméa',
          region: 'Oceania',
          subregion: 'Melanesia',
          latlng: [-21.5, 165.5],
          demonym: 'New Caledonian',
          area: 18575,
          gini: null,
          borders: [],
          nativeName: 'Nouvelle-Calédonie',
          translations: {
            de: 'Neukaledonien',
            es: 'Nueva Caledonia',
            fr: 'Nouvelle-Calédonie',
            ja: 'ニューカレドニア',
            it: 'Nuova Caledonia',
            br: 'Nova Caledônia',
            pt: 'Nova Caledónia',
            nl: 'Nieuw-Caledonië',
            hr: 'Nova Kaledonija',
            fa: 'کالدونیای جدید'
          },
          flag: 'https://restcountries.eu/data/ncl.svg'
        }
      },
      'New Zealand': {
        name: 'New Zealand',
        slug: 'new-zealand',
        population: 4991442,
        domain: '.nz',
        sex: {
          male: 50.07,
          female: 49.93
        },
        age: [
          {
            group: '0-14 years',
            value: '19.63',
            male: '496802',
            female: '469853'
          },
          {
            group: '15-24 years',
            value: '12.92',
            male: '328327',
            female: '308132'
          },
          {
            group: '25-54 years',
            value: '39.98',
            male: '996857',
            female: '972566'
          },
          {
            group: '55-64 years',
            value: '11.93',
            male: '285989',
            female: '301692'
          },
          {
            group: '65 years and over',
            value: '15.54',
            male: '358228',
            female: '407031'
          }
        ],
        info: {
          name: 'New Zealand',
          alpha2Code: 'NZ',
          alpha3Code: 'NZL',
          capital: 'Wellington',
          region: 'Oceania',
          subregion: 'Australia and New Zealand',
          latlng: [-41, 174],
          demonym: 'New Zealander',
          area: 270467,
          gini: 36.2,
          borders: [],
          nativeName: 'New Zealand',
          translations: {
            de: 'Neuseeland',
            es: 'Nueva Zelanda',
            fr: 'Nouvelle-Zélande',
            ja: 'ニュージーランド',
            it: 'Nuova Zelanda',
            br: 'Nova Zelândia',
            pt: 'Nova Zelândia',
            nl: 'Nieuw-Zeeland',
            hr: 'Novi Zeland',
            fa: 'نیوزیلند'
          },
          flag: 'https://restcountries.eu/data/nzl.svg'
        }
      },
      Nicaragua: {
        name: 'Nicaragua',
        slug: 'nicaragua',
        population: 6243931,
        domain: '.ni',
        sex: {
          male: 48.75,
          female: 51.25
        },
        age: [
          {
            group: '0-14 years',
            value: '25.63',
            male: '811731',
            female: '777984'
          },
          {
            group: '15-24 years',
            value: '19.51',
            male: '609962',
            female: '600567'
          },
          {
            group: '25-54 years',
            value: '42.41',
            male: '1254683',
            female: '1376052'
          },
          {
            group: '55-64 years',
            value: '6.63',
            male: '188591',
            female: '222766'
          },
          {
            group: '65 years and over',
            value: '5.82',
            male: '159140',
            female: '201965'
          }
        ],
        info: {
          name: 'Nicaragua',
          alpha2Code: 'NI',
          alpha3Code: 'NIC',
          capital: 'Managua',
          region: 'Americas',
          subregion: 'Central America',
          latlng: [13, -85],
          demonym: 'Nicaraguan',
          area: 130373,
          gini: 40.5,
          borders: ['CRI', 'HND'],
          nativeName: 'Nicaragua',
          translations: {
            de: 'Nicaragua',
            es: 'Nicaragua',
            fr: 'Nicaragua',
            ja: 'ニカラグア',
            it: 'Nicaragua',
            br: 'Nicarágua',
            pt: 'Nicarágua',
            nl: 'Nicaragua',
            hr: 'Nikaragva',
            fa: 'نیکاراگوئه'
          },
          flag: 'https://restcountries.eu/data/nic.svg'
        }
      },
      Niger: {
        name: 'Niger',
        slug: 'niger',
        population: 23605767,
        domain: '.ne',
        sex: {
          male: 49.56,
          female: 50.44
        },
        age: [
          {
            group: '0-14 years',
            value: '50.58',
            male: '5805102',
            female: '5713815'
          },
          {
            group: '15-24 years',
            value: '19.99',
            male: '2246670',
            female: '2306285'
          },
          {
            group: '25-54 years',
            value: '23.57',
            male: '2582123',
            female: '2784464'
          },
          {
            group: '55-64 years',
            value: '3.17',
            male: '357832',
            female: '364774'
          },
          {
            group: '65 years and over',
            value: '2.68',
            male: '293430',
            female: '317866'
          }
        ],
        info: {
          name: 'Niger',
          alpha2Code: 'NE',
          alpha3Code: 'NER',
          capital: 'Niamey',
          region: 'Africa',
          subregion: 'Western Africa',
          latlng: [16, 8],
          demonym: 'Nigerien',
          area: 1267000,
          gini: 34.6,
          borders: ['DZA', 'BEN', 'BFA', 'TCD', 'LBY', 'MLI', 'NGA'],
          nativeName: 'Niger',
          translations: {
            de: 'Niger',
            es: 'Níger',
            fr: 'Niger',
            ja: 'ニジェール',
            it: 'Niger',
            br: 'Níger',
            pt: 'Níger',
            nl: 'Niger',
            hr: 'Niger',
            fa: 'نیجر'
          },
          flag: 'https://restcountries.eu/data/ner.svg'
        }
      },
      Nigeria: {
        name: 'Nigeria',
        slug: 'nigeria',
        population: 219463862,
        domain: '.ng',
        sex: {
          male: 50.49,
          female: 49.51
        },
        age: [
          {
            group: '0-14 years',
            value: '41.7',
            male: '45571738',
            female: '43674769'
          },
          {
            group: '15-24 years',
            value: '20.27',
            male: '22022660',
            female: '21358753'
          },
          {
            group: '25-54 years',
            value: '30.6',
            male: '32808913',
            female: '32686474'
          },
          {
            group: '55-64 years',
            value: '4.13',
            male: '4327847',
            female: '4514264'
          },
          {
            group: '65 years and over',
            value: '3.3',
            male: '3329083',
            female: '3733801'
          }
        ],
        info: {
          name: 'Nigeria',
          alpha2Code: 'NG',
          alpha3Code: 'NGA',
          capital: 'Abuja',
          region: 'Africa',
          subregion: 'Western Africa',
          latlng: [10, 8],
          demonym: 'Nigerian',
          area: 923768,
          gini: 48.8,
          borders: ['BEN', 'CMR', 'TCD', 'NER'],
          nativeName: 'Nigeria',
          translations: {
            de: 'Nigeria',
            es: 'Nigeria',
            fr: 'Nigéria',
            ja: 'ナイジェリア',
            it: 'Nigeria',
            br: 'Nigéria',
            pt: 'Nigéria',
            nl: 'Nigeria',
            hr: 'Nigerija',
            fa: 'نیجریه'
          },
          flag: 'https://restcountries.eu/data/nga.svg'
        }
      },
      Niue: {
        name: 'Niue',
        slug: 'niue',
        population: 2000,
        domain: '.nu',
        info: {
          name: 'Niue',
          alpha2Code: 'NU',
          alpha3Code: 'NIU',
          capital: 'Alofi',
          region: 'Oceania',
          subregion: 'Polynesia',
          latlng: [-19.03333333, -169.86666666],
          demonym: 'Niuean',
          area: 260,
          gini: null,
          borders: [],
          nativeName: 'Niuē',
          translations: {
            de: 'Niue',
            es: 'Niue',
            fr: 'Niue',
            ja: 'ニウエ',
            it: 'Niue',
            br: 'Niue',
            pt: 'Niue',
            nl: 'Niue',
            hr: 'Niue',
            fa: 'نیووی'
          },
          flag: 'https://restcountries.eu/data/niu.svg'
        }
      },
      'Nordic Countries': {
        name: 'Nordic Countries',
        slug: 'nordic-countries',
        population: 27253487
      },
      'Norfolk Island': {
        name: 'Norfolk Island',
        slug: 'norfolk-island',
        population: 1748,
        domain: '.nf',
        info: {
          name: 'Norfolk Island',
          alpha2Code: 'NF',
          alpha3Code: 'NFK',
          capital: 'Kingston',
          region: 'Oceania',
          subregion: 'Australia and New Zealand',
          latlng: [-29.03333333, 167.95],
          demonym: 'Norfolk Islander',
          area: 36,
          gini: null,
          borders: [],
          nativeName: 'Norfolk Island',
          translations: {
            de: 'Norfolkinsel',
            es: 'Isla de Norfolk',
            fr: 'Île de Norfolk',
            ja: 'ノーフォーク島',
            it: 'Isola Norfolk',
            br: 'Ilha Norfolk',
            pt: 'Ilha Norfolk',
            nl: 'Norfolkeiland',
            hr: 'Otok Norfolk',
            fa: 'جزیره نورفک'
          },
          flag: 'https://restcountries.eu/data/nfk.svg'
        }
      },
      'North Macedonia': {
        name: 'North Macedonia',
        slug: 'north-macedonia',
        population: 2128262,
        domain: '.mk',
        sex: {
          male: 49.86,
          female: 50.14
        },
        age: [
          {
            group: '0-14 years',
            value: '16.16',
            male: '177553',
            female: '165992'
          },
          {
            group: '15-24 years',
            value: '12.65',
            male: '139250',
            female: '129770'
          },
          {
            group: '25-54 years',
            value: '44.47',
            male: '480191',
            female: '465145'
          },
          {
            group: '55-64 years',
            value: '12.55',
            male: '131380',
            female: '135407'
          },
          {
            group: '65 years and over',
            value: '14.17',
            male: '131674',
            female: '169609'
          }
        ],
        info: {
          name: 'Macedonia (the former Yugoslav Republic of)',
          alpha2Code: 'MK',
          alpha3Code: 'MKD',
          capital: 'Skopje',
          region: 'Europe',
          subregion: 'Southern Europe',
          latlng: [41.83333333, 22],
          demonym: 'Macedonian',
          area: 25713,
          gini: 43.2,
          borders: ['ALB', 'BGR', 'GRC', 'KOS', 'SRB'],
          nativeName: 'Македонија',
          translations: {
            de: 'Mazedonien',
            es: 'Macedonia',
            fr: 'Macédoine',
            ja: 'マケドニア旧ユーゴスラビア共和国',
            it: 'Macedonia',
            br: 'Macedônia',
            pt: 'Macedónia',
            nl: 'Macedonië',
            hr: 'Makedonija',
            fa: ''
          },
          flag: 'https://restcountries.eu/data/mkd.svg'
        }
      },
      'Northern Mariana Islands': {
        name: 'Northern Mariana Islands',
        slug: 'northern-mariana-islands',
        population: 51659,
        domain: '.mp',
        sex: {
          male: 53.07,
          female: 46.93
        },
        age: [
          {
            group: '0-14 years',
            value: '25.02',
            male: '6937',
            female: '5934'
          },
          {
            group: '15-24 years',
            value: '16.28',
            male: '4518',
            female: '3857'
          },
          {
            group: '25-54 years',
            value: '37.44',
            male: '9934',
            female: '9325'
          },
          {
            group: '55-64 years',
            value: '14.01',
            male: '3921',
            female: '3286'
          },
          {
            group: '65 years and over',
            value: '7.23',
            male: '1988',
            female: '1733'
          }
        ],
        info: {
          name: 'Northern Mariana Islands',
          alpha2Code: 'MP',
          alpha3Code: 'MNP',
          capital: 'Saipan',
          region: 'Oceania',
          subregion: 'Micronesia',
          latlng: [15.2, 145.75],
          demonym: 'American',
          area: 464,
          gini: null,
          borders: [],
          nativeName: 'Northern Mariana Islands',
          translations: {
            de: 'Nördliche Marianen',
            es: 'Islas Marianas del Norte',
            fr: 'Îles Mariannes du Nord',
            ja: '北マリアナ諸島',
            it: 'Isole Marianne Settentrionali',
            br: 'Ilhas Marianas',
            pt: 'Ilhas Marianas',
            nl: 'Noordelijke Marianeneilanden',
            hr: 'Sjevernomarijanski otoci',
            fa: 'جزایر ماریانای شمالی'
          },
          flag: 'https://restcountries.eu/data/mnp.svg'
        }
      },
      Norway: {
        name: 'Norway',
        slug: 'norway',
        population: 5509591,
        domain: '.no',
        sex: {
          male: 50.51,
          female: 49.49
        },
        age: [
          {
            group: '0-14 years',
            value: '17.96',
            male: '503013',
            female: '478901'
          },
          {
            group: '15-24 years',
            value: '12.02',
            male: '336597',
            female: '320720'
          },
          {
            group: '25-54 years',
            value: '40.75',
            male: '1150762',
            female: '1077357'
          },
          {
            group: '55-64 years',
            value: '11.84',
            male: '328865',
            female: '318398'
          },
          {
            group: '65 years and over',
            value: '17.43',
            male: '442232',
            female: '510594'
          }
        ],
        info: {
          name: 'Norway',
          alpha2Code: 'NO',
          alpha3Code: 'NOR',
          capital: 'Oslo',
          region: 'Europe',
          subregion: 'Northern Europe',
          latlng: [62, 10],
          demonym: 'Norwegian',
          area: 323802,
          gini: 25.8,
          borders: ['FIN', 'SWE', 'RUS'],
          nativeName: 'Norge',
          translations: {
            de: 'Norwegen',
            es: 'Noruega',
            fr: 'Norvège',
            ja: 'ノルウェー',
            it: 'Norvegia',
            br: 'Noruega',
            pt: 'Noruega',
            nl: 'Noorwegen',
            hr: 'Norveška',
            fa: 'نروژ'
          },
          flag: 'https://restcountries.eu/data/nor.svg'
        }
      },
      Oman: {
        name: 'Oman',
        slug: 'oman',
        population: 3694755,
        domain: '.om',
        sex: {
          male: 54.02,
          female: 45.98
        },
        age: [
          {
            group: '0-14 years',
            value: '30.15',
            male: '561791',
            female: '533949'
          },
          {
            group: '15-24 years',
            value: '17.35',
            male: '331000',
            female: '299516'
          },
          {
            group: '25-54 years',
            value: '44.81',
            male: '928812',
            female: '699821'
          },
          {
            group: '55-64 years',
            value: '4.02',
            male: '77558',
            female: '68427'
          },
          {
            group: '65 years and over',
            value: '3.68',
            male: '64152',
            female: '69663'
          }
        ],
        info: {
          name: 'Oman',
          alpha2Code: 'OM',
          alpha3Code: 'OMN',
          capital: 'Muscat',
          region: 'Asia',
          subregion: 'Western Asia',
          latlng: [21, 57],
          demonym: 'Omani',
          area: 309500,
          gini: null,
          borders: ['SAU', 'ARE', 'YEM'],
          nativeName: 'عمان',
          translations: {
            de: 'Oman',
            es: 'Omán',
            fr: 'Oman',
            ja: 'オマーン',
            it: 'oman',
            br: 'Omã',
            pt: 'Omã',
            nl: 'Oman',
            hr: 'Oman',
            fa: 'عمان'
          },
          flag: 'https://restcountries.eu/data/omn.svg'
        }
      },
      Pakistan: {
        name: 'Pakistan',
        slug: 'pakistan',
        population: 238181034,
        domain: '.pk',
        sex: {
          male: 50.95,
          female: 49.05
        },
        age: [
          {
            group: '0-14 years',
            value: '36.01',
            male: '42923925',
            female: '41149694'
          },
          {
            group: '15-24 years',
            value: '19.3',
            male: '23119205',
            female: '21952976'
          },
          {
            group: '25-54 years',
            value: '34.7',
            male: '41589381',
            female: '39442046'
          },
          {
            group: '55-64 years',
            value: '5.55',
            male: '6526656',
            female: '6423993'
          },
          {
            group: '65 years and over',
            value: '4.44',
            male: '4802165',
            female: '5570595'
          }
        ],
        info: {
          name: 'Pakistan',
          alpha2Code: 'PK',
          alpha3Code: 'PAK',
          capital: 'Islamabad',
          region: 'Asia',
          subregion: 'Southern Asia',
          latlng: [30, 70],
          demonym: 'Pakistani',
          area: 881912,
          gini: 30,
          borders: ['AFG', 'CHN', 'IND', 'IRN'],
          nativeName: 'Pakistan',
          translations: {
            de: 'Pakistan',
            es: 'Pakistán',
            fr: 'Pakistan',
            ja: 'パキスタン',
            it: 'Pakistan',
            br: 'Paquistão',
            pt: 'Paquistão',
            nl: 'Pakistan',
            hr: 'Pakistan',
            fa: 'پاکستان'
          },
          flag: 'https://restcountries.eu/data/pak.svg'
        }
      },
      Palau: {
        name: 'Palau',
        slug: 'palau',
        population: 21613,
        domain: '.pw',
        sex: {
          male: 51.62,
          female: 48.38
        },
        age: [
          {
            group: '0-14 years',
            value: '18.68',
            male: '2090',
            female: '1961'
          },
          {
            group: '15-24 years',
            value: '15.86',
            male: '1723',
            female: '1716'
          },
          {
            group: '25-54 years',
            value: '45.33',
            male: '6026',
            female: '3804'
          },
          {
            group: '55-64 years',
            value: '10.68',
            male: '853',
            female: '1463'
          },
          {
            group: '65 years and over',
            value: '9.45',
            male: '501',
            female: '1548'
          }
        ],
        info: {
          name: 'Palau',
          alpha2Code: 'PW',
          alpha3Code: 'PLW',
          capital: 'Ngerulmud',
          region: 'Oceania',
          subregion: 'Micronesia',
          latlng: [7.5, 134.5],
          demonym: 'Palauan',
          area: 459,
          gini: null,
          borders: [],
          nativeName: 'Palau',
          translations: {
            de: 'Palau',
            es: 'Palau',
            fr: 'Palaos',
            ja: 'パラオ',
            it: 'Palau',
            br: 'Palau',
            pt: 'Palau',
            nl: 'Palau',
            hr: 'Palau',
            fa: 'پالائو'
          },
          flag: 'https://restcountries.eu/data/plw.svg'
        }
      },
      Panama: {
        name: 'Panama',
        slug: 'panama',
        population: 3928646,
        domain: '.pa',
        sex: {
          male: 50.27,
          female: 49.73
        },
        age: [
          {
            group: '0-14 years',
            value: '25.56',
            male: '508131',
            female: '487205'
          },
          {
            group: '15-24 years',
            value: '16.59',
            male: '329250',
            female: '316796'
          },
          {
            group: '25-54 years',
            value: '40.31',
            male: '794662',
            female: '774905'
          },
          {
            group: '55-64 years',
            value: '8.54',
            male: '165129',
            female: '167317'
          },
          {
            group: '65 years and over',
            value: '9.01',
            male: '160516',
            female: '190171'
          }
        ],
        info: {
          name: 'Panama',
          alpha2Code: 'PA',
          alpha3Code: 'PAN',
          capital: 'Panama City',
          region: 'Americas',
          subregion: 'Central America',
          latlng: [9, -80],
          demonym: 'Panamanian',
          area: 75417,
          gini: 51.9,
          borders: ['COL', 'CRI'],
          nativeName: 'Panamá',
          translations: {
            de: 'Panama',
            es: 'Panamá',
            fr: 'Panama',
            ja: 'パナマ',
            it: 'Panama',
            br: 'Panamá',
            pt: 'Panamá',
            nl: 'Panama',
            hr: 'Panama',
            fa: 'پاناما'
          },
          flag: 'https://restcountries.eu/data/pan.svg'
        }
      },
      'Papua New Guinea': {
        name: 'Papua New Guinea',
        slug: 'papua-new-guinea',
        population: 7399757,
        domain: '.pg',
        sex: {
          male: 50.9,
          female: 49.1
        },
        age: [
          {
            group: '0-14 years',
            value: '31.98',
            male: '1182539',
            female: '1139358'
          },
          {
            group: '15-24 years',
            value: '19.87',
            male: '731453',
            female: '711164'
          },
          {
            group: '25-54 years',
            value: '37.68',
            male: '1397903',
            female: '1337143'
          },
          {
            group: '55-64 years',
            value: '5.83',
            male: '218529',
            female: '204717'
          },
          {
            group: '65 years and over',
            value: '4.64',
            male: '164734',
            female: '171916'
          }
        ],
        info: {
          name: 'Papua New Guinea',
          alpha2Code: 'PG',
          alpha3Code: 'PNG',
          capital: 'Port Moresby',
          region: 'Oceania',
          subregion: 'Melanesia',
          latlng: [-6, 147],
          demonym: 'Papua New Guinean',
          area: 462840,
          gini: 50.9,
          borders: ['IDN'],
          nativeName: 'Papua Niugini',
          translations: {
            de: 'Papua-Neuguinea',
            es: 'Papúa Nueva Guinea',
            fr: 'Papouasie-Nouvelle-Guinée',
            ja: 'パプアニューギニア',
            it: 'Papua Nuova Guinea',
            br: 'Papua Nova Guiné',
            pt: 'Papua Nova Guiné',
            nl: 'Papoea-Nieuw-Guinea',
            hr: 'Papua Nova Gvineja',
            fa: 'پاپوآ گینه نو'
          },
          flag: 'https://restcountries.eu/data/png.svg'
        }
      },
      'Paracel Islands': {
        name: 'Paracel Islands',
        slug: 'paracel-islands',
        population: 1440
      },
      Paraguay: {
        name: 'Paraguay',
        slug: 'paraguay',
        population: 7272639,
        domain: '.py',
        sex: {
          male: 50.11,
          female: 49.89
        },
        age: [
          {
            group: '0-14 years',
            value: '23.41',
            male: '857303',
            female: '826470'
          },
          {
            group: '15-24 years',
            value: '17.71',
            male: '640400',
            female: '633525'
          },
          {
            group: '25-54 years',
            value: '42.63',
            male: '1532692',
            female: '1532851'
          },
          {
            group: '55-64 years',
            value: '8.37',
            male: '306100',
            female: '295890'
          },
          {
            group: '65 years and over',
            value: '7.88',
            male: '267351',
            female: '299103'
          }
        ],
        info: {
          name: 'Paraguay',
          alpha2Code: 'PY',
          alpha3Code: 'PRY',
          capital: 'Asunción',
          region: 'Americas',
          subregion: 'South America',
          latlng: [-23, -58],
          demonym: 'Paraguayan',
          area: 406752,
          gini: 52.4,
          borders: ['ARG', 'BOL', 'BRA'],
          nativeName: 'Paraguay',
          translations: {
            de: 'Paraguay',
            es: 'Paraguay',
            fr: 'Paraguay',
            ja: 'パラグアイ',
            it: 'Paraguay',
            br: 'Paraguai',
            pt: 'Paraguai',
            nl: 'Paraguay',
            hr: 'Paragvaj',
            fa: 'پاراگوئه'
          },
          flag: 'https://restcountries.eu/data/pry.svg'
        }
      },
      Peru: {
        name: 'Peru',
        slug: 'peru',
        population: 32201224,
        domain: '.pe',
        sex: {
          male: 49.01,
          female: 50.99
        },
        age: [
          {
            group: '0-14 years',
            value: '25.43',
            male: '4131985',
            female: '3984546'
          },
          {
            group: '15-24 years',
            value: '17.21',
            male: '2756024',
            female: '2736394'
          },
          {
            group: '25-54 years',
            value: '41.03',
            male: '6279595',
            female: '6815159'
          },
          {
            group: '55-64 years',
            value: '8.28',
            male: '1266595',
            female: '1375708'
          },
          {
            group: '65 years and over',
            value: '8.05',
            male: '1207707',
            female: '1361276'
          }
        ],
        info: {
          name: 'Peru',
          alpha2Code: 'PE',
          alpha3Code: 'PER',
          capital: 'Lima',
          region: 'Americas',
          subregion: 'South America',
          latlng: [-10, -76],
          demonym: 'Peruvian',
          area: 1285216,
          gini: 48.1,
          borders: ['BOL', 'BRA', 'CHL', 'COL', 'ECU'],
          nativeName: 'Perú',
          translations: {
            de: 'Peru',
            es: 'Perú',
            fr: 'Pérou',
            ja: 'ペルー',
            it: 'Perù',
            br: 'Peru',
            pt: 'Peru',
            nl: 'Peru',
            hr: 'Peru',
            fa: 'پرو'
          },
          flag: 'https://restcountries.eu/data/per.svg'
        }
      },
      Philippines: {
        name: 'Philippines',
        slug: 'philippines',
        population: 110818325,
        domain: '.ph',
        sex: {
          male: 50.18,
          female: 49.82
        },
        age: [
          {
            group: '0-14 years',
            value: '32.42',
            male: '18060976',
            female: '17331781'
          },
          {
            group: '15-24 years',
            value: '19.16',
            male: '10680325',
            female: '10243047'
          },
          {
            group: '25-54 years',
            value: '37.37',
            male: '20777741',
            female: '20027153'
          },
          {
            group: '55-64 years',
            value: '6.18',
            male: '3116485',
            female: '3633301'
          },
          {
            group: '65 years and over',
            value: '4.86',
            male: '2155840',
            female: '3154166'
          }
        ],
        info: {
          name: 'Philippines',
          alpha2Code: 'PH',
          alpha3Code: 'PHL',
          capital: 'Manila',
          region: 'Asia',
          subregion: 'South-Eastern Asia',
          latlng: [13, 122],
          demonym: 'Filipino',
          area: 342353,
          gini: 43,
          borders: [],
          nativeName: 'Pilipinas',
          translations: {
            de: 'Philippinen',
            es: 'Filipinas',
            fr: 'Philippines',
            ja: 'フィリピン',
            it: 'Filippine',
            br: 'Filipinas',
            pt: 'Filipinas',
            nl: 'Filipijnen',
            hr: 'Filipini',
            fa: 'جزایر الندفیلیپین'
          },
          flag: 'https://restcountries.eu/data/phl.svg'
        }
      },
      'Pitcairn Islands': {
        name: 'Pitcairn Islands',
        slug: 'pitcairn-islands',
        population: 50,
        domain: '.pn',
        info: {
          name: 'Pitcairn',
          alpha2Code: 'PN',
          alpha3Code: 'PCN',
          capital: 'Adamstown',
          region: 'Oceania',
          subregion: 'Polynesia',
          latlng: [-25.06666666, -130.1],
          demonym: 'Pitcairn Islander',
          area: 47,
          gini: null,
          borders: [],
          nativeName: 'Pitcairn Islands',
          translations: {
            de: 'Pitcairn',
            es: 'Islas Pitcairn',
            fr: 'Îles Pitcairn',
            ja: 'ピトケアン',
            it: 'Isole Pitcairn',
            br: 'Ilhas Pitcairn',
            pt: 'Ilhas Picárnia',
            nl: 'Pitcairneilanden',
            hr: 'Pitcairnovo otočje',
            fa: 'پیتکرن'
          },
          flag: 'https://restcountries.eu/data/pcn.svg'
        }
      },
      Poland: {
        name: 'Poland',
        slug: 'poland',
        population: 38185913,
        domain: '.pl',
        sex: {
          male: 48.39,
          female: 51.61
        },
        age: [
          {
            group: '0-14 years',
            value: '14.83',
            male: '2918518',
            female: '2756968'
          },
          {
            group: '15-24 years',
            value: '9.8',
            male: '1928637',
            female: '1823894'
          },
          {
            group: '25-54 years',
            value: '43.33',
            male: '8384017',
            female: '8203646'
          },
          {
            group: '55-64 years',
            value: '13.32',
            male: '2424638',
            female: '2675351'
          },
          {
            group: '65 years and over',
            value: '18.72',
            male: '2867315',
            female: '4299341'
          }
        ],
        info: {
          name: 'Poland',
          alpha2Code: 'PL',
          alpha3Code: 'POL',
          capital: 'Warsaw',
          region: 'Europe',
          subregion: 'Eastern Europe',
          latlng: [52, 20],
          demonym: 'Polish',
          area: 312679,
          gini: 34.1,
          borders: ['BLR', 'CZE', 'DEU', 'LTU', 'RUS', 'SVK', 'UKR'],
          nativeName: 'Polska',
          translations: {
            de: 'Polen',
            es: 'Polonia',
            fr: 'Pologne',
            ja: 'ポーランド',
            it: 'Polonia',
            br: 'Polônia',
            pt: 'Polónia',
            nl: 'Polen',
            hr: 'Poljska',
            fa: 'لهستان'
          },
          flag: 'https://restcountries.eu/data/pol.svg'
        }
      },
      Portugal: {
        name: 'Portugal',
        slug: 'portugal',
        population: 10263850,
        domain: '.pt',
        sex: {
          male: 47.39,
          female: 52.61
        },
        age: [
          {
            group: '0-14 years',
            value: '13.58',
            male: '716102',
            female: '682582'
          },
          {
            group: '15-24 years',
            value: '10.94',
            male: '580074',
            female: '547122'
          },
          {
            group: '25-54 years',
            value: '41.49',
            male: '2109693',
            female: '2164745'
          },
          {
            group: '55-64 years',
            value: '13.08',
            male: '615925',
            female: '731334'
          },
          {
            group: '65 years and over',
            value: '20.92',
            male: '860198',
            female: '1294899'
          }
        ],
        info: {
          name: 'Portugal',
          alpha2Code: 'PT',
          alpha3Code: 'PRT',
          capital: 'Lisbon',
          region: 'Europe',
          subregion: 'Southern Europe',
          latlng: [39.5, -8],
          demonym: 'Portuguese',
          area: 92090,
          gini: 38.5,
          borders: ['ESP'],
          nativeName: 'Portugal',
          translations: {
            de: 'Portugal',
            es: 'Portugal',
            fr: 'Portugal',
            ja: 'ポルトガル',
            it: 'Portogallo',
            br: 'Portugal',
            pt: 'Portugal',
            nl: 'Portugal',
            hr: 'Portugal',
            fa: 'پرتغال'
          },
          flag: 'https://restcountries.eu/data/prt.svg'
        }
      },
      'Puerto Rico': {
        name: 'Puerto Rico',
        slug: 'puerto-rico',
        population: 3142779,
        domain: '.pr',
        sex: {
          male: 47.25,
          female: 52.75
        },
        age: [
          {
            group: '0-14 years',
            value: '14.22',
            male: '231406',
            female: '222061'
          },
          {
            group: '15-24 years',
            value: '12.78',
            male: '207169',
            female: '200373'
          },
          {
            group: '25-54 years',
            value: '37.73',
            male: '573114',
            female: '630276'
          },
          {
            group: '55-64 years',
            value: '13.5',
            male: '197438',
            female: '232931'
          },
          {
            group: '65 years and over',
            value: '21.77',
            male: '297749',
            female: '396551'
          }
        ],
        info: {
          name: 'Puerto Rico',
          alpha2Code: 'PR',
          alpha3Code: 'PRI',
          capital: 'San Juan',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [18.25, -66.5],
          demonym: 'Puerto Rican',
          area: 8870,
          gini: null,
          borders: [],
          nativeName: 'Puerto Rico',
          translations: {
            de: 'Puerto Rico',
            es: 'Puerto Rico',
            fr: 'Porto Rico',
            ja: 'プエルトリコ',
            it: 'Porto Rico',
            br: 'Porto Rico',
            pt: 'Porto Rico',
            nl: 'Puerto Rico',
            hr: 'Portoriko',
            fa: 'پورتو ریکو'
          },
          flag: 'https://restcountries.eu/data/pri.svg'
        }
      },
      Qatar: {
        name: 'Qatar',
        slug: 'qatar',
        population: 2479995,
        domain: '.qa',
        sex: {
          male: 77.22,
          female: 22.78
        },
        age: [
          {
            group: '0-14 years',
            value: '12.84',
            male: '158702',
            female: '155211'
          },
          {
            group: '15-24 years',
            value: '11.78',
            male: '203703',
            female: '84323'
          },
          {
            group: '25-54 years',
            value: '70.66',
            male: '1439364',
            female: '287575'
          },
          {
            group: '55-64 years',
            value: '3.53',
            male: '66561',
            female: '19600'
          },
          {
            group: '65 years and over',
            value: '1.19',
            male: '19067',
            female: '10068'
          }
        ],
        info: {
          name: 'Qatar',
          alpha2Code: 'QA',
          alpha3Code: 'QAT',
          capital: 'Doha',
          region: 'Asia',
          subregion: 'Western Asia',
          latlng: [25.5, 51.25],
          demonym: 'Qatari',
          area: 11586,
          gini: 41.1,
          borders: ['SAU'],
          nativeName: 'قطر',
          translations: {
            de: 'Katar',
            es: 'Catar',
            fr: 'Qatar',
            ja: 'カタール',
            it: 'Qatar',
            br: 'Catar',
            pt: 'Catar',
            nl: 'Qatar',
            hr: 'Katar',
            fa: 'قطر'
          },
          flag: 'https://restcountries.eu/data/qat.svg'
        }
      },
      Romania: {
        name: 'Romania',
        slug: 'romania',
        population: 21230362,
        domain: '.ro',
        sex: {
          male: 48.63,
          female: 51.37
        },
        age: [
          {
            group: '0-14 years',
            value: '14.12',
            male: '1545196',
            female: '1463700'
          },
          {
            group: '15-24 years',
            value: '10.31',
            male: '1126997',
            female: '1068817'
          },
          {
            group: '25-54 years',
            value: '46.26',
            male: '4993886',
            female: '4860408'
          },
          {
            group: '55-64 years',
            value: '11.73',
            male: '1176814',
            female: '1322048'
          },
          {
            group: '65 years and over',
            value: '17.58',
            male: '1516472',
            female: '2228555'
          }
        ],
        info: {
          name: 'Romania',
          alpha2Code: 'RO',
          alpha3Code: 'ROU',
          capital: 'Bucharest',
          region: 'Europe',
          subregion: 'Eastern Europe',
          latlng: [46, 25],
          demonym: 'Romanian',
          area: 238391,
          gini: 30,
          borders: ['BGR', 'HUN', 'MDA', 'SRB', 'UKR'],
          nativeName: 'România',
          translations: {
            de: 'Rumänien',
            es: 'Rumania',
            fr: 'Roumanie',
            ja: 'ルーマニア',
            it: 'Romania',
            br: 'Romênia',
            pt: 'Roménia',
            nl: 'Roemenië',
            hr: 'Rumunjska',
            fa: 'رومانی'
          },
          flag: 'https://restcountries.eu/data/rou.svg'
        }
      },
      Russia: {
        name: 'Russia',
        slug: 'russia',
        population: 142320790,
        domain: '.ru',
        sex: {
          male: 46.26,
          female: 53.74
        },
        age: [
          {
            group: '0-14 years',
            value: '17.24',
            male: '12551611',
            female: '11881297'
          },
          {
            group: '15-24 years',
            value: '9.54',
            male: '6920070',
            female: '6602776'
          },
          {
            group: '25-54 years',
            value: '43.38',
            male: '30240260',
            female: '31245104'
          },
          {
            group: '55-64 years',
            value: '14.31',
            male: '8808330',
            female: '11467697'
          },
          {
            group: '65 years and over',
            value: '15.53',
            male: '7033381',
            female: '14971679'
          }
        ],
        info: {
          name: 'Russian Federation',
          alpha2Code: 'RU',
          alpha3Code: 'RUS',
          capital: 'Moscow',
          region: 'Europe',
          subregion: 'Eastern Europe',
          latlng: [60, 100],
          demonym: 'Russian',
          area: 17124442,
          gini: 40.1,
          borders: [
            'AZE',
            'BLR',
            'CHN',
            'EST',
            'FIN',
            'GEO',
            'KAZ',
            'PRK',
            'LVA',
            'LTU',
            'MNG',
            'NOR',
            'POL',
            'UKR'
          ],
          nativeName: 'Россия',
          translations: {
            de: 'Russland',
            es: 'Rusia',
            fr: 'Russie',
            ja: 'ロシア連邦',
            it: 'Russia',
            br: 'Rússia',
            pt: 'Rússia',
            nl: 'Rusland',
            hr: 'Rusija',
            fa: 'روسیه'
          },
          flag: 'https://restcountries.eu/data/rus.svg'
        }
      },
      Rwanda: {
        name: 'Rwanda',
        slug: 'rwanda',
        population: 12943132,
        domain: '.rw',
        sex: {
          male: 48.96,
          female: 51.04
        },
        age: [
          {
            group: '0-14 years',
            value: '39.95',
            male: '2564893',
            female: '2513993'
          },
          {
            group: '15-24 years',
            value: '20.1',
            male: '1280948',
            female: '1273853'
          },
          {
            group: '25-54 years',
            value: '33.06',
            male: '2001629',
            female: '2201132'
          },
          {
            group: '55-64 years',
            value: '4.24',
            male: '241462',
            female: '298163'
          },
          {
            group: '65 years and over',
            value: '2.65',
            male: '134648',
            female: '201710'
          }
        ],
        info: {
          name: 'Rwanda',
          alpha2Code: 'RW',
          alpha3Code: 'RWA',
          capital: 'Kigali',
          region: 'Africa',
          subregion: 'Eastern Africa',
          latlng: [-2, 30],
          demonym: 'Rwandan',
          area: 26338,
          gini: 50.8,
          borders: ['BDI', 'COD', 'TZA', 'UGA'],
          nativeName: 'Rwanda',
          translations: {
            de: 'Ruanda',
            es: 'Ruanda',
            fr: 'Rwanda',
            ja: 'ルワンダ',
            it: 'Ruanda',
            br: 'Ruanda',
            pt: 'Ruanda',
            nl: 'Rwanda',
            hr: 'Ruanda',
            fa: 'رواندا'
          },
          flag: 'https://restcountries.eu/data/rwa.svg'
        }
      },
      'Saint Barthelemy': {
        name: 'Saint Barthelemy',
        slug: 'saint-barthelemy',
        population: 7116,
        domain: '.bl',
        sex: {
          male: 52.91,
          female: 47.09
        },
        age: [
          {
            group: '0-14 years',
            value: '15.16',
            male: '555',
            female: '525'
          },
          {
            group: '15-24 years',
            value: '7.34',
            male: '275',
            female: '248'
          },
          {
            group: '25-54 years',
            value: '41.86',
            male: '1618',
            female: '1363'
          },
          {
            group: '55-64 years',
            value: '16.29',
            male: '630',
            female: '530'
          },
          {
            group: '65 years and over',
            value: '19.35',
            male: '690',
            female: '688'
          }
        ],
        info: {
          name: 'Saint Barthélemy',
          alpha2Code: 'BL',
          alpha3Code: 'BLM',
          capital: 'Gustavia',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [18.5, -63.41666666],
          demonym: 'Saint Barthélemy Islander',
          area: 21,
          gini: null,
          borders: [],
          nativeName: 'Saint-Barthélemy',
          translations: {
            de: 'Saint-Barthélemy',
            es: 'San Bartolomé',
            fr: 'Saint-Barthélemy',
            ja: 'サン・バルテルミー',
            it: 'Antille Francesi',
            br: 'São Bartolomeu',
            pt: 'São Bartolomeu',
            nl: 'Saint Barthélemy',
            hr: 'Saint Barthélemy',
            fa: 'سن-بارتلمی'
          },
          flag: 'https://restcountries.eu/data/blm.svg'
        }
      },
      'Saint Helena, Ascension, and Tristan da Cunha': {
        name: 'Saint Helena, Ascension, and Tristan da Cunha',
        slug: 'saint-helena-ascension-and-tristan-da-cunha',
        population: 7915,
        domain: '.sh',
        sex: {
          male: 50.27,
          female: 49.73
        },
        age: [
          {
            group: '0-14 years',
            value: '14.86',
            male: '599',
            female: '577'
          },
          {
            group: '15-24 years',
            value: '11.84',
            male: '477',
            female: '460'
          },
          {
            group: '25-54 years',
            value: '42.59',
            male: '1679',
            female: '1692'
          },
          {
            group: '55-64 years',
            value: '13.18',
            male: '514',
            female: '529'
          },
          {
            group: '65 years and over',
            value: '17.54',
            male: '710',
            female: '678'
          }
        ],
        info: {
          name: 'Saint Helena, Ascension and Tristan da Cunha',
          alpha2Code: 'SH',
          alpha3Code: 'SHN',
          capital: 'Jamestown',
          region: 'Africa',
          subregion: 'Western Africa',
          latlng: [-15.95, -5.7],
          demonym: 'Saint Helenian',
          area: null,
          gini: null,
          borders: [],
          nativeName: 'Saint Helena',
          translations: {
            de: 'Sankt Helena',
            es: 'Santa Helena',
            fr: 'Sainte-Hélène',
            ja: 'セントヘレナ・アセンションおよびトリスタンダクーニャ',
            it: "Sant'Elena",
            br: 'Santa Helena',
            pt: 'Santa Helena',
            nl: 'Sint-Helena',
            hr: 'Sveta Helena',
            fa: 'سنت هلنا، اسنشن و تریستان دا کونا'
          },
          flag: 'https://restcountries.eu/data/shn.svg'
        }
      },
      'Saint Kitts and Nevis': {
        name: 'Saint Kitts and Nevis',
        slug: 'saint-kitts-and-nevis',
        population: 54149,
        domain: '.kn',
        sex: {
          male: 50.05,
          female: 49.95
        },
        age: [
          {
            group: '0-14 years',
            value: '19.87',
            male: '5357',
            female: '5336'
          },
          {
            group: '15-24 years',
            value: '13.46',
            male: '3504',
            female: '3741'
          },
          {
            group: '25-54 years',
            value: '43.64',
            male: '12010',
            female: '11477'
          },
          {
            group: '55-64 years',
            value: '13.03',
            male: '3527',
            female: '3485'
          },
          {
            group: '65 years and over',
            value: '10',
            male: '2540',
            female: '2844'
          }
        ],
        info: {
          name: 'Saint Kitts and Nevis',
          alpha2Code: 'KN',
          alpha3Code: 'KNA',
          capital: 'Basseterre',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [17.33333333, -62.75],
          demonym: 'Kittian and Nevisian',
          area: 261,
          gini: null,
          borders: [],
          nativeName: 'Saint Kitts and Nevis',
          translations: {
            de: 'St. Kitts und Nevis',
            es: 'San Cristóbal y Nieves',
            fr: 'Saint-Christophe-et-Niévès',
            ja: 'セントクリストファー・ネイビス',
            it: 'Saint Kitts e Nevis',
            br: 'São Cristóvão e Neves',
            pt: 'São Cristóvão e Neves',
            nl: 'Saint Kitts en Nevis',
            hr: 'Sveti Kristof i Nevis',
            fa: 'سنت کیتس و نویس'
          },
          flag: 'https://restcountries.eu/data/kna.svg'
        }
      },
      'Saint Lucia': {
        name: 'Saint Lucia',
        slug: 'saint-lucia',
        population: 166637,
        domain: '.lc',
        sex: {
          male: 48.6,
          female: 51.4
        },
        age: [
          {
            group: '0-14 years',
            value: '19.24',
            male: '16484',
            female: '15546'
          },
          {
            group: '15-24 years',
            value: '13.6',
            male: '11475',
            female: '11165'
          },
          {
            group: '25-54 years',
            value: '42.83',
            male: '34436',
            female: '36868'
          },
          {
            group: '55-64 years',
            value: '11.23',
            male: '8624',
            female: '10075'
          },
          {
            group: '65 years and over',
            value: '13.1',
            male: '9894',
            female: '11920'
          }
        ],
        info: {
          name: 'Saint Lucia',
          alpha2Code: 'LC',
          alpha3Code: 'LCA',
          capital: 'Castries',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [13.88333333, -60.96666666],
          demonym: 'Saint Lucian',
          area: 616,
          gini: 42.6,
          borders: [],
          nativeName: 'Saint Lucia',
          translations: {
            de: 'Saint Lucia',
            es: 'Santa Lucía',
            fr: 'Saint-Lucie',
            ja: 'セントルシア',
            it: 'Santa Lucia',
            br: 'Santa Lúcia',
            pt: 'Santa Lúcia',
            nl: 'Saint Lucia',
            hr: 'Sveta Lucija',
            fa: 'سنت لوسیا'
          },
          flag: 'https://restcountries.eu/data/lca.svg'
        }
      },
      'Saint Martin': {
        name: 'Saint Martin',
        slug: 'saint-martin',
        population: 32680,
        domain: '.mf',
        sex: {
          male: 48.01,
          female: 51.99
        },
        age: [
          {
            group: '0-14 years',
            value: '25.63',
            male: '4148',
            female: '4197'
          },
          {
            group: '15-24 years',
            value: '10.28',
            male: '1647',
            female: '1701'
          },
          {
            group: '25-54 years',
            value: '46.2',
            male: '7201',
            female: '7841'
          },
          {
            group: '55-64 years',
            value: '8.71',
            male: '1328',
            female: '1508'
          },
          {
            group: '65 years and over',
            value: '9.17',
            male: '1305',
            female: '1680'
          }
        ],
        info: {
          name: 'Saint Martin (French part)',
          alpha2Code: 'MF',
          alpha3Code: 'MAF',
          capital: 'Marigot',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [18.08333333, -63.95],
          demonym: 'Saint Martin Islander',
          area: 53,
          gini: null,
          borders: ['SXM', 'NLD'],
          nativeName: 'Saint-Martin',
          translations: {
            de: 'Saint Martin',
            es: 'Saint Martin',
            fr: 'Saint-Martin',
            ja: 'サン・マルタン（フランス領）',
            it: 'Saint Martin',
            br: 'Saint Martin',
            pt: 'Ilha São Martinho',
            nl: 'Saint-Martin',
            hr: 'Sveti Martin',
            fa: 'سینت مارتن'
          },
          flag: 'https://restcountries.eu/data/maf.svg'
        }
      },
      'Saint Pierre and Miquelon': {
        name: 'Saint Pierre and Miquelon',
        slug: 'saint-pierre-and-miquelon',
        population: 5321,
        domain: '.pm',
        sex: {
          male: 48.48,
          female: 51.52
        },
        age: [
          {
            group: '0-14 years',
            value: '14.31',
            male: '395',
            female: '370'
          },
          {
            group: '15-24 years',
            value: '8.83',
            male: '245',
            female: '227'
          },
          {
            group: '25-54 years',
            value: '40',
            male: '1039',
            female: '1100'
          },
          {
            group: '55-64 years',
            value: '14.49',
            male: '400',
            female: '375'
          },
          {
            group: '65 years and over',
            value: '22.37',
            male: '513',
            female: '683'
          }
        ],
        info: {
          name: 'Saint Pierre and Miquelon',
          alpha2Code: 'PM',
          alpha3Code: 'SPM',
          capital: 'Saint-Pierre',
          region: 'Americas',
          subregion: 'Northern America',
          latlng: [46.83333333, -56.33333333],
          demonym: 'French',
          area: 242,
          gini: null,
          borders: [],
          nativeName: 'Saint-Pierre-et-Miquelon',
          translations: {
            de: 'Saint-Pierre und Miquelon',
            es: 'San Pedro y Miquelón',
            fr: 'Saint-Pierre-et-Miquelon',
            ja: 'サンピエール島・ミクロン島',
            it: 'Saint-Pierre e Miquelon',
            br: 'Saint-Pierre e Miquelon',
            pt: 'São Pedro e Miquelon',
            nl: 'Saint Pierre en Miquelon',
            hr: 'Sveti Petar i Mikelon',
            fa: 'سن پیر و میکلن'
          },
          flag: 'https://restcountries.eu/data/spm.svg'
        }
      },
      'Saint Vincent and the Grenadines': {
        name: 'Saint Vincent and the Grenadines',
        slug: 'saint-vincent-and-the-grenadines',
        population: 101145,
        domain: '.vc',
        sex: {
          male: 50.88,
          female: 49.12
        },
        age: [
          {
            group: '0-14 years',
            value: '20.15',
            male: '10309',
            female: '10121'
          },
          {
            group: '15-24 years',
            value: '14.83',
            male: '7582',
            female: '7451'
          },
          {
            group: '25-54 years',
            value: '42.63',
            male: '22395',
            female: '20824'
          },
          {
            group: '55-64 years',
            value: '11.68',
            male: '6136',
            female: '5703'
          },
          {
            group: '65 years and over',
            value: '10.72',
            male: '5167',
            female: '5702'
          }
        ],
        info: {
          name: 'Saint Vincent and the Grenadines',
          alpha2Code: 'VC',
          alpha3Code: 'VCT',
          capital: 'Kingstown',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [13.25, -61.2],
          demonym: 'Saint Vincentian',
          area: 389,
          gini: null,
          borders: [],
          nativeName: 'Saint Vincent and the Grenadines',
          translations: {
            de: 'Saint Vincent und die Grenadinen',
            es: 'San Vicente y Granadinas',
            fr: 'Saint-Vincent-et-les-Grenadines',
            ja: 'セントビンセントおよびグレナディーン諸島',
            it: 'Saint Vincent e Grenadine',
            br: 'São Vicente e Granadinas',
            pt: 'São Vicente e Granadinas',
            nl: 'Saint Vincent en de Grenadines',
            hr: 'Sveti Vincent i Grenadini',
            fa: 'سنت وینسنت و گرنادین‌ها'
          },
          flag: 'https://restcountries.eu/data/vct.svg'
        }
      },
      Samoa: {
        name: 'Samoa',
        slug: 'samoa',
        population: 204898,
        domain: '.ws',
        sex: {
          male: 50.86,
          female: 49.14
        },
        age: [
          {
            group: '0-14 years',
            value: '29.31',
            male: '30825',
            female: '28900'
          },
          {
            group: '15-24 years',
            value: '19.61',
            male: '20519',
            female: '19439'
          },
          {
            group: '25-54 years',
            value: '37.4',
            male: '39011',
            female: '37200'
          },
          {
            group: '55-64 years',
            value: '7.5',
            male: '7780',
            female: '7505'
          },
          {
            group: '65 years and over',
            value: '6.18',
            male: '5513',
            female: '7082'
          }
        ],
        info: {
          name: 'Samoa',
          alpha2Code: 'WS',
          alpha3Code: 'WSM',
          capital: 'Apia',
          region: 'Oceania',
          subregion: 'Polynesia',
          latlng: [-13.58333333, -172.33333333],
          demonym: 'Samoan',
          area: 2842,
          gini: null,
          borders: [],
          nativeName: 'Samoa',
          translations: {
            de: 'Samoa',
            es: 'Samoa',
            fr: 'Samoa',
            ja: 'サモア',
            it: 'Samoa',
            br: 'Samoa',
            pt: 'Samoa',
            nl: 'Samoa',
            hr: 'Samoa',
            fa: 'ساموآ'
          },
          flag: 'https://restcountries.eu/data/wsm.svg'
        }
      },
      'San Marino': {
        name: 'San Marino',
        slug: 'san-marino',
        population: 34467,
        domain: '.sm',
        sex: {
          male: 48.36,
          female: 51.64
        },
        age: [
          {
            group: '0-14 years',
            value: '14.73',
            male: '2662',
            female: '2379'
          },
          {
            group: '15-24 years',
            value: '11.64',
            male: '2091',
            female: '1894'
          },
          {
            group: '25-54 years',
            value: '39.12',
            male: '6310',
            female: '7081'
          },
          {
            group: '55-64 years',
            value: '14.28',
            male: '2367',
            female: '2520'
          },
          {
            group: '65 years and over',
            value: '20.24',
            male: '3123',
            female: '3805'
          }
        ],
        info: {
          name: 'San Marino',
          alpha2Code: 'SM',
          alpha3Code: 'SMR',
          capital: 'City of San Marino',
          region: 'Europe',
          subregion: 'Southern Europe',
          latlng: [43.76666666, 12.41666666],
          demonym: 'Sammarinese',
          area: 61,
          gini: null,
          borders: ['ITA'],
          nativeName: 'San Marino',
          translations: {
            de: 'San Marino',
            es: 'San Marino',
            fr: 'Saint-Marin',
            ja: 'サンマリノ',
            it: 'San Marino',
            br: 'San Marino',
            pt: 'São Marinho',
            nl: 'San Marino',
            hr: 'San Marino',
            fa: 'سان مارینو'
          },
          flag: 'https://restcountries.eu/data/smr.svg'
        }
      },
      'Sao Tome and Principe': {
        name: 'Sao Tome and Principe',
        slug: 'sao-tome-and-principe',
        population: 213948,
        domain: '.st',
        sex: {
          male: 49.93,
          female: 50.07
        },
        age: [
          {
            group: '0-14 years',
            value: '39.77',
            male: '42690',
            female: '41277'
          },
          {
            group: '15-24 years',
            value: '21.59',
            male: '23088',
            female: '22487'
          },
          {
            group: '25-54 years',
            value: '31.61',
            male: '32900',
            female: '33834'
          },
          {
            group: '55-64 years',
            value: '4.17',
            male: '4095',
            female: '4700'
          },
          {
            group: '65 years and over',
            value: '2.87',
            male: '2631',
            female: '3420'
          }
        ],
        info: {
          name: 'Sao Tome and Principe',
          alpha2Code: 'ST',
          alpha3Code: 'STP',
          capital: 'São Tomé',
          region: 'Africa',
          subregion: 'Middle Africa',
          latlng: [1, 7],
          demonym: 'Sao Tomean',
          area: 964,
          gini: 50.8,
          borders: [],
          nativeName: 'São Tomé e Príncipe',
          translations: {
            de: 'São Tomé und Príncipe',
            es: 'Santo Tomé y Príncipe',
            fr: 'Sao Tomé-et-Principe',
            ja: 'サントメ・プリンシペ',
            it: 'São Tomé e Príncipe',
            br: 'São Tomé e Príncipe',
            pt: 'São Tomé e Príncipe',
            nl: 'Sao Tomé en Principe',
            hr: 'Sveti Toma i Princip',
            fa: 'کواترو دو فرویرو'
          },
          flag: 'https://restcountries.eu/data/stp.svg'
        }
      },
      'Saudi Arabia': {
        name: 'Saudi Arabia',
        slug: 'saudi-arabia',
        population: 34783757,
        domain: '.sa',
        sex: {
          male: 56.57,
          female: 43.43
        },
        age: [
          {
            group: '0-14 years',
            value: '24.84',
            male: '4327830',
            female: '4159242'
          },
          {
            group: '15-24 years',
            value: '15.38',
            male: '2741371',
            female: '2515188'
          },
          {
            group: '25-54 years',
            value: '50.2',
            male: '10350028',
            female: '6804479'
          },
          {
            group: '55-64 years',
            value: '5.95',
            male: '1254921',
            female: '778467'
          },
          {
            group: '65 years and over',
            value: '3.63',
            male: '657395',
            female: '584577'
          }
        ],
        info: {
          name: 'Saudi Arabia',
          alpha2Code: 'SA',
          alpha3Code: 'SAU',
          capital: 'Riyadh',
          region: 'Asia',
          subregion: 'Western Asia',
          latlng: [25, 45],
          demonym: 'Saudi Arabian',
          area: 2149690,
          gini: null,
          borders: ['IRQ', 'JOR', 'KWT', 'OMN', 'QAT', 'ARE', 'YEM'],
          nativeName: 'العربية السعودية',
          translations: {
            de: 'Saudi-Arabien',
            es: 'Arabia Saudí',
            fr: 'Arabie Saoudite',
            ja: 'サウジアラビア',
            it: 'Arabia Saudita',
            br: 'Arábia Saudita',
            pt: 'Arábia Saudita',
            nl: 'Saoedi-Arabië',
            hr: 'Saudijska Arabija',
            fa: 'عربستان سعودی'
          },
          flag: 'https://restcountries.eu/data/sau.svg'
        }
      },
      Senegal: {
        name: 'Senegal',
        slug: 'senegal',
        population: 16082442,
        domain: '.sn',
        sex: {
          male: 48.39,
          female: 51.61
        },
        age: [
          {
            group: '0-14 years',
            value: '40.38',
            male: '3194454',
            female: '3160111'
          },
          {
            group: '15-24 years',
            value: '20.35',
            male: '1596896',
            female: '1606084'
          },
          {
            group: '25-54 years',
            value: '31.95',
            male: '2327424',
            female: '2700698'
          },
          {
            group: '55-64 years',
            value: '4.21',
            male: '283480',
            female: '378932'
          },
          {
            group: '65 years and over',
            value: '3.1',
            male: '212332',
            female: '275957'
          }
        ],
        info: {
          name: 'Senegal',
          alpha2Code: 'SN',
          alpha3Code: 'SEN',
          capital: 'Dakar',
          region: 'Africa',
          subregion: 'Western Africa',
          latlng: [14, -14],
          demonym: 'Senegalese',
          area: 196722,
          gini: 39.2,
          borders: ['GMB', 'GIN', 'GNB', 'MLI', 'MRT'],
          nativeName: 'Sénégal',
          translations: {
            de: 'Senegal',
            es: 'Senegal',
            fr: 'Sénégal',
            ja: 'セネガル',
            it: 'Senegal',
            br: 'Senegal',
            pt: 'Senegal',
            nl: 'Senegal',
            hr: 'Senegal',
            fa: 'سنگال'
          },
          flag: 'https://restcountries.eu/data/sen.svg'
        }
      },
      Serbia: {
        name: 'Serbia',
        slug: 'serbia',
        population: 6974289,
        domain: '.rs',
        sex: {
          male: 48.74,
          female: 51.26
        },
        age: [
          {
            group: '0-14 years',
            value: '14.07',
            male: '508242',
            female: '478247'
          },
          {
            group: '15-24 years',
            value: '11.04',
            male: '399435',
            female: '374718'
          },
          {
            group: '25-54 years',
            value: '41.19',
            male: '1459413',
            female: '1429176'
          },
          {
            group: '55-64 years',
            value: '13.7',
            male: '464881',
            female: '495663'
          },
          {
            group: '65 years and over',
            value: '20',
            male: '585705',
            female: '816685'
          }
        ],
        info: {
          name: 'Serbia',
          alpha2Code: 'RS',
          alpha3Code: 'SRB',
          capital: 'Belgrade',
          region: 'Europe',
          subregion: 'Southern Europe',
          latlng: [44, 21],
          demonym: 'Serbian',
          area: 88361,
          gini: 27.8,
          borders: ['BIH', 'BGR', 'HRV', 'HUN', 'KOS', 'MKD', 'MNE', 'ROU'],
          nativeName: 'Србија',
          translations: {
            de: 'Serbien',
            es: 'Serbia',
            fr: 'Serbie',
            ja: 'セルビア',
            it: 'Serbia',
            br: 'Sérvia',
            pt: 'Sérvia',
            nl: 'Servië',
            hr: 'Srbija',
            fa: 'صربستان'
          },
          flag: 'https://restcountries.eu/data/srb.svg'
        }
      },
      Seychelles: {
        name: 'Seychelles',
        slug: 'seychelles',
        population: 96387,
        domain: '.sc',
        sex: {
          male: 51.68,
          female: 48.32
        },
        age: [
          {
            group: '0-14 years',
            value: '18.85',
            male: '9297',
            female: '8798'
          },
          {
            group: '15-24 years',
            value: '12.39',
            male: '6283',
            female: '5607'
          },
          {
            group: '25-54 years',
            value: '49.03',
            male: '25209',
            female: '21851'
          },
          {
            group: '55-64 years',
            value: '11.46',
            male: '5545',
            female: '5455'
          },
          {
            group: '65 years and over',
            value: '8.27',
            male: '3272',
            female: '4664'
          }
        ],
        info: {
          name: 'Seychelles',
          alpha2Code: 'SC',
          alpha3Code: 'SYC',
          capital: 'Victoria',
          region: 'Africa',
          subregion: 'Eastern Africa',
          latlng: [-4.58333333, 55.66666666],
          demonym: 'Seychellois',
          area: 452,
          gini: 65.8,
          borders: [],
          nativeName: 'Seychelles',
          translations: {
            de: 'Seychellen',
            es: 'Seychelles',
            fr: 'Seychelles',
            ja: 'セーシェル',
            it: 'Seychelles',
            br: 'Seicheles',
            pt: 'Seicheles',
            nl: 'Seychellen',
            hr: 'Sejšeli',
            fa: 'سیشل'
          },
          flag: 'https://restcountries.eu/data/syc.svg'
        }
      },
      'Sierra Leone': {
        name: 'Sierra Leone',
        slug: 'sierra-leone',
        population: 6807277,
        domain: '.sl',
        sex: {
          male: 48.66,
          female: 51.34
        },
        age: [
          {
            group: '0-14 years',
            value: '41.38',
            male: '1369942',
            female: '1371537'
          },
          {
            group: '15-24 years',
            value: '18.83',
            male: '610396',
            female: '636880'
          },
          {
            group: '25-54 years',
            value: '32.21',
            male: '1020741',
            female: '1112946'
          },
          {
            group: '55-64 years',
            value: '3.89',
            male: '121733',
            female: '135664'
          },
          {
            group: '65 years and over',
            value: '3.7',
            male: '100712',
            female: '144382'
          }
        ],
        info: {
          name: 'Sierra Leone',
          alpha2Code: 'SL',
          alpha3Code: 'SLE',
          capital: 'Freetown',
          region: 'Africa',
          subregion: 'Western Africa',
          latlng: [8.5, -11.5],
          demonym: 'Sierra Leonean',
          area: 71740,
          gini: 42.5,
          borders: ['GIN', 'LBR'],
          nativeName: 'Sierra Leone',
          translations: {
            de: 'Sierra Leone',
            es: 'Sierra Leone',
            fr: 'Sierra Leone',
            ja: 'シエラレオネ',
            it: 'Sierra Leone',
            br: 'Serra Leoa',
            pt: 'Serra Leoa',
            nl: 'Sierra Leone',
            hr: 'Sijera Leone',
            fa: 'سیرالئون'
          },
          flag: 'https://restcountries.eu/data/sle.svg'
        }
      },
      Singapore: {
        name: 'Singapore',
        slug: 'singapore',
        population: 5866139,
        domain: '.sg',
        sex: {
          male: 48.85,
          female: 51.15
        },
        age: [
          {
            group: '0-14 years',
            value: '12.8',
            male: '406983',
            female: '387665'
          },
          {
            group: '15-24 years',
            value: '15.01',
            male: '457190',
            female: '474676'
          },
          {
            group: '25-54 years',
            value: '50.73',
            male: '1531088',
            female: '1618844'
          },
          {
            group: '55-64 years',
            value: '10.58',
            male: '328024',
            female: '328808'
          },
          {
            group: '65 years and over',
            value: '10.89',
            male: '310123',
            female: '366259'
          }
        ],
        info: {
          name: 'Singapore',
          alpha2Code: 'SG',
          alpha3Code: 'SGP',
          capital: 'Singapore',
          region: 'Asia',
          subregion: 'South-Eastern Asia',
          latlng: [1.36666666, 103.8],
          demonym: 'Singaporean',
          area: 710,
          gini: 48.1,
          borders: [],
          nativeName: 'Singapore',
          translations: {
            de: 'Singapur',
            es: 'Singapur',
            fr: 'Singapour',
            ja: 'シンガポール',
            it: 'Singapore',
            br: 'Singapura',
            pt: 'Singapura',
            nl: 'Singapore',
            hr: 'Singapur',
            fa: 'سنگاپور'
          },
          flag: 'https://restcountries.eu/data/sgp.svg'
        }
      },
      'Sint Maarten': {
        name: 'Sint Maarten',
        slug: 'sint-maarten',
        population: 44564,
        domain: '.sx',
        sex: {
          male: 49.37,
          female: 50.63
        },
        age: [
          {
            group: '0-14 years',
            value: '18.64',
            male: '4242',
            female: '3932'
          },
          {
            group: '15-24 years',
            value: '13.26',
            male: '2967',
            female: '2849'
          },
          {
            group: '25-54 years',
            value: '39.08',
            male: '8417',
            female: '8717'
          },
          {
            group: '55-64 years',
            value: '17.47',
            male: '3638',
            female: '4020'
          },
          {
            group: '65 years and over',
            value: '11.55',
            male: '2385',
            female: '2680'
          }
        ],
        info: {
          name: 'Sint Maarten (Dutch part)',
          alpha2Code: 'SX',
          alpha3Code: 'SXM',
          capital: 'Philipsburg',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [18.033333, -63.05],
          demonym: 'Dutch',
          area: 34,
          gini: null,
          borders: ['MAF'],
          nativeName: 'Sint Maarten',
          translations: {
            de: 'Sint Maarten (niederl. Teil)',
            es: null,
            fr: 'Saint Martin (partie néerlandaise)',
            ja: null,
            it: 'Saint Martin (parte olandese)',
            br: 'Sint Maarten',
            pt: 'São Martinho',
            nl: 'Sint Maarten',
            hr: null,
            fa: 'سینت مارتن'
          },
          flag: 'https://restcountries.eu/data/sxm.svg'
        }
      },
      Slovakia: {
        name: 'Slovakia',
        slug: 'slovakia',
        population: 5436066,
        domain: '.sk',
        sex: {
          male: 48.53,
          female: 51.47
        },
        age: [
          {
            group: '0-14 years',
            value: '15.13',
            male: '423180',
            female: '400128'
          },
          {
            group: '15-24 years',
            value: '10.06',
            male: '280284',
            female: '266838'
          },
          {
            group: '25-54 years',
            value: '44.61',
            male: '1228462',
            female: '1198747'
          },
          {
            group: '55-64 years',
            value: '13.15',
            male: '342124',
            female: '373452'
          },
          {
            group: '65 years and over',
            value: '17.05',
            male: '366267',
            female: '561120'
          }
        ],
        info: {
          name: 'Slovakia',
          alpha2Code: 'SK',
          alpha3Code: 'SVK',
          capital: 'Bratislava',
          region: 'Europe',
          subregion: 'Eastern Europe',
          latlng: [48.66666666, 19.5],
          demonym: 'Slovak',
          area: 49037,
          gini: 26,
          borders: ['AUT', 'CZE', 'HUN', 'POL', 'UKR'],
          nativeName: 'Slovensko',
          translations: {
            de: 'Slowakei',
            es: 'República Eslovaca',
            fr: 'Slovaquie',
            ja: 'スロバキア',
            it: 'Slovacchia',
            br: 'Eslováquia',
            pt: 'Eslováquia',
            nl: 'Slowakije',
            hr: 'Slovačka',
            fa: 'اسلواکی'
          },
          flag: 'https://restcountries.eu/data/svk.svg'
        }
      },
      Slovenia: {
        name: 'Slovenia',
        slug: 'slovenia',
        population: 2102106,
        domain: '.si',
        sex: {
          male: 49.91,
          female: 50.09
        },
        age: [
          {
            group: '0-14 years',
            value: '14.84',
            male: '160134',
            female: '151960'
          },
          {
            group: '15-24 years',
            value: '9.01',
            male: '98205',
            female: '91318'
          },
          {
            group: '25-54 years',
            value: '40.73',
            male: '449930',
            female: '406395'
          },
          {
            group: '55-64 years',
            value: '14.19',
            male: '148785',
            female: '149635'
          },
          {
            group: '65 years and over',
            value: '21.23',
            male: '192420',
            female: '253896'
          }
        ],
        info: {
          name: 'Slovenia',
          alpha2Code: 'SI',
          alpha3Code: 'SVN',
          capital: 'Ljubljana',
          region: 'Europe',
          subregion: 'Southern Europe',
          latlng: [46.11666666, 14.81666666],
          demonym: 'Slovene',
          area: 20273,
          gini: 31.2,
          borders: ['AUT', 'HRV', 'ITA', 'HUN'],
          nativeName: 'Slovenija',
          translations: {
            de: 'Slowenien',
            es: 'Eslovenia',
            fr: 'Slovénie',
            ja: 'スロベニア',
            it: 'Slovenia',
            br: 'Eslovênia',
            pt: 'Eslovénia',
            nl: 'Slovenië',
            hr: 'Slovenija',
            fa: 'اسلوونی'
          },
          flag: 'https://restcountries.eu/data/svn.svg'
        }
      },
      'Solomon Islands': {
        name: 'Solomon Islands',
        slug: 'solomon-islands',
        population: 690598,
        domain: '.sb',
        sex: {
          male: 51.06,
          female: 48.94
        },
        age: [
          {
            group: '0-14 years',
            value: '32.99',
            male: '116397',
            female: '109604'
          },
          {
            group: '15-24 years',
            value: '19.82',
            male: '69914',
            female: '65874'
          },
          {
            group: '25-54 years',
            value: '37.64',
            male: '131201',
            female: '126681'
          },
          {
            group: '55-64 years',
            value: '5.04',
            male: '17844',
            female: '16704'
          },
          {
            group: '65 years and over',
            value: '4.51',
            male: '14461',
            female: '16417'
          }
        ],
        info: {
          name: 'Solomon Islands',
          alpha2Code: 'SB',
          alpha3Code: 'SLB',
          capital: 'Honiara',
          region: 'Oceania',
          subregion: 'Melanesia',
          latlng: [-8, 159],
          demonym: 'Solomon Islander',
          area: 28896,
          gini: null,
          borders: [],
          nativeName: 'Solomon Islands',
          translations: {
            de: 'Salomonen',
            es: 'Islas Salomón',
            fr: 'Îles Salomon',
            ja: 'ソロモン諸島',
            it: 'Isole Salomone',
            br: 'Ilhas Salomão',
            pt: 'Ilhas Salomão',
            nl: 'Salomonseilanden',
            hr: 'Solomonski Otoci',
            fa: 'جزایر سلیمان'
          },
          flag: 'https://restcountries.eu/data/slb.svg'
        }
      },
      Somalia: {
        name: 'Somalia',
        slug: 'somalia',
        population: 12094640,
        domain: '.so',
        sex: {
          male: 50.37,
          female: 49.63
        },
        age: [
          {
            group: '0-14 years',
            value: '42.38',
            male: '2488604',
            female: '2493527'
          },
          {
            group: '15-24 years',
            value: '19.81',
            male: '1167807',
            female: '1161040'
          },
          {
            group: '25-54 years',
            value: '30.93',
            male: '1881094',
            female: '1755166'
          },
          {
            group: '55-64 years',
            value: '4.61',
            male: '278132',
            female: '264325'
          },
          {
            group: '65 years and over',
            value: '2.27',
            male: '106187',
            female: '161242'
          }
        ],
        info: {
          name: 'Somalia',
          alpha2Code: 'SO',
          alpha3Code: 'SOM',
          capital: 'Mogadishu',
          region: 'Africa',
          subregion: 'Eastern Africa',
          latlng: [10, 49],
          demonym: 'Somali',
          area: 637657,
          gini: null,
          borders: ['DJI', 'ETH', 'KEN'],
          nativeName: 'Soomaaliya',
          translations: {
            de: 'Somalia',
            es: 'Somalia',
            fr: 'Somalie',
            ja: 'ソマリア',
            it: 'Somalia',
            br: 'Somália',
            pt: 'Somália',
            nl: 'Somalië',
            hr: 'Somalija',
            fa: 'سومالی'
          },
          flag: 'https://restcountries.eu/data/som.svg'
        }
      },
      'South Africa': {
        name: 'South Africa',
        slug: 'south-africa',
        population: 56978635,
        domain: '.za',
        sex: {
          male: 49.42,
          female: 50.58
        },
        age: [
          {
            group: '0-14 years',
            value: '27.94',
            male: '7894742',
            female: '7883266'
          },
          {
            group: '15-24 years',
            value: '16.8',
            male: '4680587',
            female: '4804337'
          },
          {
            group: '25-54 years',
            value: '42.37',
            male: '12099441',
            female: '11825193'
          },
          {
            group: '55-64 years',
            value: '6.8',
            male: '1782902',
            female: '2056988'
          },
          {
            group: '65 years and over',
            value: '6.09',
            male: '1443956',
            female: '1992205'
          }
        ],
        info: {
          name: 'South Africa',
          alpha2Code: 'ZA',
          alpha3Code: 'ZAF',
          capital: 'Pretoria',
          region: 'Africa',
          subregion: 'Southern Africa',
          latlng: [-29, 24],
          demonym: 'South African',
          area: 1221037,
          gini: 63.1,
          borders: ['BWA', 'LSO', 'MOZ', 'NAM', 'SWZ', 'ZWE'],
          nativeName: 'South Africa',
          translations: {
            de: 'Republik Südafrika',
            es: 'República de Sudáfrica',
            fr: 'Afrique du Sud',
            ja: '南アフリカ',
            it: 'Sud Africa',
            br: 'República Sul-Africana',
            pt: 'República Sul-Africana',
            nl: 'Zuid-Afrika',
            hr: 'Južnoafrička Republika',
            fa: 'آفریقای جنوبی'
          },
          flag: 'https://restcountries.eu/data/zaf.svg'
        }
      },
      'South Georgia and South Sandwich Islands': {
        name: 'South Georgia and South Sandwich Islands',
        slug: 'south-georgia-and-south-sandwich-islands',
        population: 0
      },
      'South Sudan': {
        name: 'South Sudan',
        slug: 'south-sudan',
        population: 10984074,
        domain: '.ss',
        sex: {
          male: 51.48,
          female: 48.52
        },
        age: [
          {
            group: '0-14 years',
            value: '41.58',
            male: '2238534',
            female: '2152685'
          },
          {
            group: '15-24 years',
            value: '21.28',
            male: '1153108',
            female: '1094568'
          },
          {
            group: '25-54 years',
            value: '30.67',
            male: '1662409',
            female: '1577062'
          },
          {
            group: '55-64 years',
            value: '3.93',
            male: '228875',
            female: '186571'
          },
          {
            group: '65 years and over',
            value: '2.53',
            male: '153502',
            female: '113930'
          }
        ],
        info: {
          name: 'South Sudan',
          alpha2Code: 'SS',
          alpha3Code: 'SSD',
          capital: 'Juba',
          region: 'Africa',
          subregion: 'Middle Africa',
          latlng: [7, 30],
          demonym: 'South Sudanese',
          area: 619745,
          gini: 45.5,
          borders: ['CAF', 'COD', 'ETH', 'KEN', 'SDN', 'UGA'],
          nativeName: 'South Sudan',
          translations: {
            de: 'Südsudan',
            es: 'Sudán del Sur',
            fr: 'Soudan du Sud',
            ja: '南スーダン',
            it: 'Sudan del sud',
            br: 'Sudão do Sul',
            pt: 'Sudão do Sul',
            nl: 'Zuid-Soedan',
            hr: 'Južni Sudan',
            fa: 'سودان جنوبی'
          },
          flag: 'https://restcountries.eu/data/ssd.svg'
        }
      },
      Spain: {
        name: 'Spain',
        slug: 'spain',
        population: 47260584,
        domain: '.es',
        sex: {
          male: 49.39,
          female: 50.61
        },
        age: [
          {
            group: '0-14 years',
            value: '15.02',
            male: '3861522',
            female: '3650085'
          },
          {
            group: '15-24 years',
            value: '9.9',
            male: '2557504',
            female: '2392498'
          },
          {
            group: '25-54 years',
            value: '43.61',
            male: '11134006',
            female: '10675873'
          },
          {
            group: '55-64 years',
            value: '12.99',
            male: '3177080',
            female: '3319823'
          },
          {
            group: '65 years and over',
            value: '18.49',
            male: '3970417',
            female: '5276984'
          }
        ],
        info: {
          name: 'Spain',
          alpha2Code: 'ES',
          alpha3Code: 'ESP',
          capital: 'Madrid',
          region: 'Europe',
          subregion: 'Southern Europe',
          latlng: [40, -4],
          demonym: 'Spanish',
          area: 505992,
          gini: 34.7,
          borders: ['AND', 'FRA', 'GIB', 'PRT', 'MAR'],
          nativeName: 'España',
          translations: {
            de: 'Spanien',
            es: 'España',
            fr: 'Espagne',
            ja: 'スペイン',
            it: 'Spagna',
            br: 'Espanha',
            pt: 'Espanha',
            nl: 'Spanje',
            hr: 'Španjolska',
            fa: 'اسپانیا'
          },
          flag: 'https://restcountries.eu/data/esp.svg'
        }
      },
      'Spratly Islands': {
        name: 'Spratly Islands',
        slug: 'spratly-islands',
        population: 0
      },
      'Sri Lanka': {
        name: 'Sri Lanka',
        slug: 'sri-lanka',
        population: 23044123,
        domain: '.lk',
        sex: {
          male: 48.81,
          female: 51.19
        },
        age: [
          {
            group: '0-14 years',
            value: '23.11',
            male: '2696379',
            female: '2592450'
          },
          {
            group: '15-24 years',
            value: '14.58',
            male: '1700442',
            female: '1636401'
          },
          {
            group: '25-54 years',
            value: '41.2',
            male: '4641842',
            female: '4789101'
          },
          {
            group: '55-64 years',
            value: '10.48',
            male: '1110481',
            female: '1288056'
          },
          {
            group: '65 years and over',
            value: '10.63',
            male: '1023315',
            female: '1410734'
          }
        ],
        info: {
          name: 'Sri Lanka',
          alpha2Code: 'LK',
          alpha3Code: 'LKA',
          capital: 'Colombo',
          region: 'Asia',
          subregion: 'Southern Asia',
          latlng: [7, 81],
          demonym: 'Sri Lankan',
          area: 65610,
          gini: 40.3,
          borders: ['IND'],
          nativeName: 'śrī laṃkāva',
          translations: {
            de: 'Sri Lanka',
            es: 'Sri Lanka',
            fr: 'Sri Lanka',
            ja: 'スリランカ',
            it: 'Sri Lanka',
            br: 'Sri Lanka',
            pt: 'Sri Lanka',
            nl: 'Sri Lanka',
            hr: 'Šri Lanka',
            fa: 'سری‌لانکا'
          },
          flag: 'https://restcountries.eu/data/lka.svg'
        }
      },
      Sudan: {
        name: 'Sudan',
        slug: 'sudan',
        population: 46751152,
        domain: '.sd',
        sex: {
          male: 50.26,
          female: 49.74
        },
        age: [
          {
            group: '0-14 years',
            value: '42.01',
            male: '9726937',
            female: '9414988'
          },
          {
            group: '15-24 years',
            value: '20.94',
            male: '4852903',
            female: '4687664'
          },
          {
            group: '25-54 years',
            value: '29.89',
            male: '6633567',
            female: '6986241'
          },
          {
            group: '55-64 years',
            value: '4.13',
            male: '956633',
            female: '923688'
          },
          {
            group: '65 years and over',
            value: '3.03',
            male: '729214',
            female: '649721'
          }
        ],
        info: {
          name: 'Sudan',
          alpha2Code: 'SD',
          alpha3Code: 'SDN',
          capital: 'Khartoum',
          region: 'Africa',
          subregion: 'Northern Africa',
          latlng: [15, 30],
          demonym: 'Sudanese',
          area: 1886068,
          gini: 35.3,
          borders: ['CAF', 'TCD', 'EGY', 'ERI', 'ETH', 'LBY', 'SSD'],
          nativeName: 'السودان',
          translations: {
            de: 'Sudan',
            es: 'Sudán',
            fr: 'Soudan',
            ja: 'スーダン',
            it: 'Sudan',
            br: 'Sudão',
            pt: 'Sudão',
            nl: 'Soedan',
            hr: 'Sudan',
            fa: 'سودان'
          },
          flag: 'https://restcountries.eu/data/sdn.svg'
        }
      },
      Suriname: {
        name: 'Suriname',
        slug: 'suriname',
        population: 614749,
        domain: '.sr',
        sex: {
          male: 50.34,
          female: 49.66
        },
        age: [
          {
            group: '0-14 years',
            value: '23.38',
            male: '72642',
            female: '69899'
          },
          {
            group: '15-24 years',
            value: '17.2',
            male: '53427',
            female: '51438'
          },
          {
            group: '25-54 years',
            value: '44.09',
            male: '136889',
            female: '131868'
          },
          {
            group: '55-64 years',
            value: '8.78',
            male: '26435',
            female: '27066'
          },
          {
            group: '65 years and over',
            value: '6.55',
            male: '17437',
            female: '22468'
          }
        ],
        info: {
          name: 'Suriname',
          alpha2Code: 'SR',
          alpha3Code: 'SUR',
          capital: 'Paramaribo',
          region: 'Americas',
          subregion: 'South America',
          latlng: [4, -56],
          demonym: 'Surinamer',
          area: 163820,
          gini: 52.9,
          borders: ['BRA', 'GUF', 'FRA', 'GUY'],
          nativeName: 'Suriname',
          translations: {
            de: 'Suriname',
            es: 'Surinam',
            fr: 'Surinam',
            ja: 'スリナム',
            it: 'Suriname',
            br: 'Suriname',
            pt: 'Suriname',
            nl: 'Suriname',
            hr: 'Surinam',
            fa: 'سورینام'
          },
          flag: 'https://restcountries.eu/data/sur.svg'
        }
      },
      Svalbard: {
        name: 'Svalbard',
        slug: 'svalbard',
        population: 2926,
        domain: '.sj',
        info: {
          name: 'Svalbard and Jan Mayen',
          alpha2Code: 'SJ',
          alpha3Code: 'SJM',
          capital: 'Longyearbyen',
          region: 'Europe',
          subregion: 'Northern Europe',
          latlng: [78, 20],
          demonym: 'Norwegian',
          area: null,
          gini: null,
          borders: [],
          nativeName: 'Svalbard og Jan Mayen',
          translations: {
            de: 'Svalbard und Jan Mayen',
            es: 'Islas Svalbard y Jan Mayen',
            fr: 'Svalbard et Jan Mayen',
            ja: 'スヴァールバル諸島およびヤンマイエン島',
            it: 'Svalbard e Jan Mayen',
            br: 'Svalbard',
            pt: 'Svalbard',
            nl: 'Svalbard en Jan Mayen',
            hr: 'Svalbard i Jan Mayen',
            fa: 'سوالبارد و یان ماین'
          },
          flag: 'https://restcountries.eu/data/sjm.svg'
        }
      },
      Sweden: {
        name: 'Sweden',
        slug: 'sweden',
        population: 10261767,
        domain: '.se',
        sex: {
          male: 49.98,
          female: 50.02
        },
        age: [
          {
            group: '0-14 years',
            value: '17.71',
            male: '928413',
            female: '878028'
          },
          {
            group: '15-24 years',
            value: '10.8',
            male: '569082',
            female: '532492'
          },
          {
            group: '25-54 years',
            value: '39.01',
            male: '2016991',
            female: '1962617'
          },
          {
            group: '55-64 years',
            value: '11.9',
            male: '610521',
            female: '603795'
          },
          {
            group: '65 years and over',
            value: '20.59',
            male: '974410',
            female: '1126142'
          }
        ],
        info: {
          name: 'Sweden',
          alpha2Code: 'SE',
          alpha3Code: 'SWE',
          capital: 'Stockholm',
          region: 'Europe',
          subregion: 'Northern Europe',
          latlng: [62, 15],
          demonym: 'Swedish',
          area: 450295,
          gini: 25,
          borders: ['FIN', 'NOR'],
          nativeName: 'Sverige',
          translations: {
            de: 'Schweden',
            es: 'Suecia',
            fr: 'Suède',
            ja: 'スウェーデン',
            it: 'Svezia',
            br: 'Suécia',
            pt: 'Suécia',
            nl: 'Zweden',
            hr: 'Švedska',
            fa: 'سوئد'
          },
          flag: 'https://restcountries.eu/data/swe.svg'
        }
      },
      Switzerland: {
        name: 'Switzerland',
        slug: 'switzerland',
        population: 8453550,
        domain: '.ch',
        sex: {
          male: 49.36,
          female: 50.64
        },
        age: [
          {
            group: '0-14 years',
            value: '15.34',
            male: '664255',
            female: '625252'
          },
          {
            group: '15-24 years',
            value: '10.39',
            male: '446196',
            female: '426708'
          },
          {
            group: '25-54 years',
            value: '42.05',
            male: '1768245',
            female: '1765941'
          },
          {
            group: '55-64 years',
            value: '13.48',
            male: '569717',
            female: '563482'
          },
          {
            group: '65 years and over',
            value: '18.73',
            male: '699750',
            female: '874448'
          }
        ],
        info: {
          name: 'Switzerland',
          alpha2Code: 'CH',
          alpha3Code: 'CHE',
          capital: 'Bern',
          region: 'Europe',
          subregion: 'Western Europe',
          latlng: [47, 8],
          demonym: 'Swiss',
          area: 41284,
          gini: 33.7,
          borders: ['AUT', 'FRA', 'ITA', 'LIE', 'DEU'],
          nativeName: 'Schweiz',
          translations: {
            de: 'Schweiz',
            es: 'Suiza',
            fr: 'Suisse',
            ja: 'スイス',
            it: 'Svizzera',
            br: 'Suíça',
            pt: 'Suíça',
            nl: 'Zwitserland',
            hr: 'Švicarska',
            fa: 'سوئیس'
          },
          flag: 'https://restcountries.eu/data/che.svg'
        }
      },
      Syria: {
        name: 'Syria',
        slug: 'syria',
        population: 20384316,
        domain: '.sy',
        sex: {
          male: 49.88,
          female: 50.12
        },
        age: [
          {
            group: '0-14 years',
            value: '33.47',
            male: '3323072',
            female: '3170444'
          },
          {
            group: '15-24 years',
            value: '19.34',
            male: '1872903',
            female: '1879564'
          },
          {
            group: '25-54 years',
            value: '37.31',
            male: '3558241',
            female: '3679596'
          },
          {
            group: '55-64 years',
            value: '5.41',
            male: '516209',
            female: '534189'
          },
          {
            group: '65 years and over',
            value: '4.46',
            male: '404813',
            female: '459417'
          }
        ],
        info: {
          name: 'Syrian Arab Republic',
          alpha2Code: 'SY',
          alpha3Code: 'SYR',
          capital: 'Damascus',
          region: 'Asia',
          subregion: 'Western Asia',
          latlng: [35, 38],
          demonym: 'Syrian',
          area: 185180,
          gini: 35.8,
          borders: ['IRQ', 'ISR', 'JOR', 'LBN', 'TUR'],
          nativeName: 'سوريا',
          translations: {
            de: 'Syrien',
            es: 'Siria',
            fr: 'Syrie',
            ja: 'シリア・アラブ共和国',
            it: 'Siria',
            br: 'Síria',
            pt: 'Síria',
            nl: 'Syrië',
            hr: 'Sirija',
            fa: 'سوریه'
          },
          flag: 'https://restcountries.eu/data/syr.svg'
        }
      },
      Taiwan: {
        name: 'Taiwan',
        slug: 'taiwan',
        population: 23572052,
        domain: '.tw',
        sex: {
          male: 49.31,
          female: 50.69
        },
        age: [
          {
            group: '0-14 years',
            value: '12.42',
            male: '1504704',
            female: '1426494'
          },
          {
            group: '15-24 years',
            value: '11.62',
            male: '1403117',
            female: '1339535'
          },
          {
            group: '25-54 years',
            value: '45.51',
            male: '5351951',
            female: '5389112'
          },
          {
            group: '55-64 years',
            value: '14.73',
            male: '1698555',
            female: '1778529'
          },
          {
            group: '65 years and over',
            value: '15.72',
            male: '1681476',
            female: '2029576'
          }
        ],
        info: {
          name: 'Taiwan',
          alpha2Code: 'TW',
          alpha3Code: 'TWN',
          capital: 'Taipei',
          region: 'Asia',
          subregion: 'Eastern Asia',
          latlng: [23.5, 121],
          demonym: 'Taiwanese',
          area: 36193,
          gini: null,
          borders: [],
          nativeName: '臺灣',
          translations: {
            de: 'Taiwan',
            es: 'Taiwán',
            fr: 'Taïwan',
            ja: '台湾（中華民国）',
            it: 'Taiwan',
            br: 'Taiwan',
            pt: 'Taiwan',
            nl: 'Taiwan',
            hr: 'Tajvan',
            fa: 'تایوان'
          },
          flag: 'https://restcountries.eu/data/twn.svg'
        }
      },
      Tajikistan: {
        name: 'Tajikistan',
        slug: 'tajikistan',
        population: 8990874,
        domain: '.tj',
        sex: {
          male: 49.73,
          female: 50.27
        },
        age: [
          {
            group: '0-14 years',
            value: '31.43',
            male: '1420271',
            female: '1368445'
          },
          {
            group: '15-24 years',
            value: '18.13',
            male: '816658',
            female: '792231'
          },
          {
            group: '25-54 years',
            value: '40.58',
            male: '1789271',
            female: '1811566'
          },
          {
            group: '55-64 years',
            value: '6.23',
            male: '253862',
            female: '299378'
          },
          {
            group: '65 years and over',
            value: '3.63',
            male: '132831',
            female: '189156'
          }
        ],
        info: {
          name: 'Tajikistan',
          alpha2Code: 'TJ',
          alpha3Code: 'TJK',
          capital: 'Dushanbe',
          region: 'Asia',
          subregion: 'Central Asia',
          latlng: [39, 71],
          demonym: 'Tadzhik',
          area: 143100,
          gini: 30.8,
          borders: ['AFG', 'CHN', 'KGZ', 'UZB'],
          nativeName: 'Тоҷикистон',
          translations: {
            de: 'Tadschikistan',
            es: 'Tayikistán',
            fr: 'Tadjikistan',
            ja: 'タジキスタン',
            it: 'Tagikistan',
            br: 'Tajiquistão',
            pt: 'Tajiquistão',
            nl: 'Tadzjikistan',
            hr: 'Tađikistan',
            fa: 'تاجیکستان'
          },
          flag: 'https://restcountries.eu/data/tjk.svg'
        }
      },
      Tanzania: {
        name: 'Tanzania',
        slug: 'tanzania',
        population: 62092761,
        domain: '.tz',
        sex: {
          male: 49.92,
          female: 50.08
        },
        age: [
          {
            group: '0-14 years',
            value: '42.7',
            male: '12632772',
            female: '12369115'
          },
          {
            group: '15-24 years',
            value: '20.39',
            male: '5988208',
            female: '5948134'
          },
          {
            group: '25-54 years',
            value: '30.31',
            male: '8903629',
            female: '8844180'
          },
          {
            group: '55-64 years',
            value: '3.52',
            male: '954251',
            female: '1107717'
          },
          {
            group: '65 years and over',
            value: '3.08',
            male: '747934',
            female: '1056905'
          }
        ],
        info: {
          name: 'Tanzania, United Republic of',
          alpha2Code: 'TZ',
          alpha3Code: 'TZA',
          capital: 'Dodoma',
          region: 'Africa',
          subregion: 'Eastern Africa',
          latlng: [-6, 35],
          demonym: 'Tanzanian',
          area: 945087,
          gini: 37.6,
          borders: ['BDI', 'COD', 'KEN', 'MWI', 'MOZ', 'RWA', 'UGA', 'ZMB'],
          nativeName: 'Tanzania',
          translations: {
            de: 'Tansania',
            es: 'Tanzania',
            fr: 'Tanzanie',
            ja: 'タンザニア',
            it: 'Tanzania',
            br: 'Tanzânia',
            pt: 'Tanzânia',
            nl: 'Tanzania',
            hr: 'Tanzanija',
            fa: 'تانزانیا'
          },
          flag: 'https://restcountries.eu/data/tza.svg'
        }
      },
      Thailand: {
        name: 'Thailand',
        slug: 'thailand',
        population: 69480520,
        domain: '.th',
        sex: {
          male: 48.99,
          female: 51.01
        },
        age: [
          {
            group: '0-14 years',
            value: '16.45',
            male: '5812803',
            female: '5533772'
          },
          {
            group: '15-24 years',
            value: '13.02',
            male: '4581622',
            female: '4400997'
          },
          {
            group: '25-54 years',
            value: '45.69',
            male: '15643583',
            female: '15875353'
          },
          {
            group: '55-64 years',
            value: '13.01',
            male: '4200077',
            female: '4774801'
          },
          {
            group: '65 years and over',
            value: '11.82',
            male: '3553273',
            female: '4601119'
          }
        ],
        info: {
          name: 'Thailand',
          alpha2Code: 'TH',
          alpha3Code: 'THA',
          capital: 'Bangkok',
          region: 'Asia',
          subregion: 'South-Eastern Asia',
          latlng: [15, 100],
          demonym: 'Thai',
          area: 513120,
          gini: 40,
          borders: ['MMR', 'KHM', 'LAO', 'MYS'],
          nativeName: 'ประเทศไทย',
          translations: {
            de: 'Thailand',
            es: 'Tailandia',
            fr: 'Thaïlande',
            ja: 'タイ',
            it: 'Tailandia',
            br: 'Tailândia',
            pt: 'Tailândia',
            nl: 'Thailand',
            hr: 'Tajland',
            fa: 'تایلند'
          },
          flag: 'https://restcountries.eu/data/tha.svg'
        }
      },
      'Timor-Leste': {
        name: 'Timor-Leste',
        slug: 'timor-leste',
        population: 1413958,
        domain: '.tl',
        sex: {
          male: 49.97,
          female: 50.03
        },
        age: [
          {
            group: '0-14 years',
            value: '39.96',
            male: '284353',
            female: '268562'
          },
          {
            group: '15-24 years',
            value: '20.32',
            male: '142693',
            female: '138508'
          },
          {
            group: '25-54 years',
            value: '30.44',
            male: '202331',
            female: '218914'
          },
          {
            group: '55-64 years',
            value: '5.22',
            male: '34956',
            female: '37229'
          },
          {
            group: '65 years and over',
            value: '4.06',
            male: '27153',
            female: '29024'
          }
        ],
        info: {
          name: 'Timor-Leste',
          alpha2Code: 'TL',
          alpha3Code: 'TLS',
          capital: 'Dili',
          region: 'Asia',
          subregion: 'South-Eastern Asia',
          latlng: [-8.83333333, 125.91666666],
          demonym: 'East Timorese',
          area: 14874,
          gini: 31.9,
          borders: ['IDN'],
          nativeName: 'Timor-Leste',
          translations: {
            de: 'Timor-Leste',
            es: 'Timor Oriental',
            fr: 'Timor oriental',
            ja: '東ティモール',
            it: 'Timor Est',
            br: 'Timor Leste',
            pt: 'Timor Leste',
            nl: 'Oost-Timor',
            hr: 'Istočni Timor',
            fa: 'تیمور شرقی'
          },
          flag: 'https://restcountries.eu/data/tls.svg'
        }
      },
      Togo: {
        name: 'Togo',
        slug: 'togo',
        population: 8283189,
        domain: '.tg',
        sex: {
          male: 49.6,
          female: 50.4
        },
        age: [
          {
            group: '0-14 years',
            value: '39.73',
            male: '1716667',
            female: '1703230'
          },
          {
            group: '15-24 years',
            value: '19.03',
            male: '817093',
            female: '820971'
          },
          {
            group: '25-54 years',
            value: '33.26',
            male: '1423554',
            female: '1439380'
          },
          {
            group: '55-64 years',
            value: '4.42',
            male: '179779',
            female: '200392'
          },
          {
            group: '65 years and over',
            value: '3.57',
            male: '132304',
            female: '175074'
          }
        ],
        info: {
          name: 'Togo',
          alpha2Code: 'TG',
          alpha3Code: 'TGO',
          capital: 'Lomé',
          region: 'Africa',
          subregion: 'Western Africa',
          latlng: [8, 1.16666666],
          demonym: 'Togolese',
          area: 56785,
          gini: 34.4,
          borders: ['BEN', 'BFA', 'GHA'],
          nativeName: 'Togo',
          translations: {
            de: 'Togo',
            es: 'Togo',
            fr: 'Togo',
            ja: 'トーゴ',
            it: 'Togo',
            br: 'Togo',
            pt: 'Togo',
            nl: 'Togo',
            hr: 'Togo',
            fa: 'توگو'
          },
          flag: 'https://restcountries.eu/data/tgo.svg'
        }
      },
      Tokelau: {
        name: 'Tokelau',
        slug: 'tokelau',
        population: 1647,
        domain: '.tk',
        info: {
          name: 'Tokelau',
          alpha2Code: 'TK',
          alpha3Code: 'TKL',
          capital: 'Fakaofo',
          region: 'Oceania',
          subregion: 'Polynesia',
          latlng: [-9, -172],
          demonym: 'Tokelauan',
          area: 12,
          gini: null,
          borders: [],
          nativeName: 'Tokelau',
          translations: {
            de: 'Tokelau',
            es: 'Islas Tokelau',
            fr: 'Tokelau',
            ja: 'トケラウ',
            it: 'Isole Tokelau',
            br: 'Tokelau',
            pt: 'Toquelau',
            nl: 'Tokelau',
            hr: 'Tokelau',
            fa: 'توکلائو'
          },
          flag: 'https://restcountries.eu/data/tkl.svg'
        }
      },
      Tonga: {
        name: 'Tonga',
        slug: 'tonga',
        population: 105780,
        domain: '.to',
        sex: {
          male: 50.17,
          female: 49.83
        },
        age: [
          {
            group: '0-14 years',
            value: '32',
            male: '17250',
            female: '16698'
          },
          {
            group: '15-24 years',
            value: '19.66',
            male: '10679',
            female: '10175'
          },
          {
            group: '25-54 years',
            value: '35.35',
            male: '18701',
            female: '18802'
          },
          {
            group: '55-64 years',
            value: '6.17',
            male: '3345',
            female: '3202'
          },
          {
            group: '65 years and over',
            value: '6.83',
            male: '3249',
            female: '3994'
          }
        ],
        info: {
          name: 'Tonga',
          alpha2Code: 'TO',
          alpha3Code: 'TON',
          capital: "Nuku'alofa",
          region: 'Oceania',
          subregion: 'Polynesia',
          latlng: [-20, -175],
          demonym: 'Tongan',
          area: 747,
          gini: null,
          borders: [],
          nativeName: 'Tonga',
          translations: {
            de: 'Tonga',
            es: 'Tonga',
            fr: 'Tonga',
            ja: 'トンガ',
            it: 'Tonga',
            br: 'Tonga',
            pt: 'Tonga',
            nl: 'Tonga',
            hr: 'Tonga',
            fa: 'تونگا'
          },
          flag: 'https://restcountries.eu/data/ton.svg'
        }
      },
      'Trinidad and Tobago': {
        name: 'Trinidad and Tobago',
        slug: 'trinidad-and-tobago',
        population: 1221047,
        domain: '.tt',
        sex: {
          male: 50.68,
          female: 49.32
        },
        age: [
          {
            group: '0-14 years',
            value: '19.01',
            male: '116953',
            female: '112805'
          },
          {
            group: '15-24 years',
            value: '11.28',
            male: '70986',
            female: '65389'
          },
          {
            group: '25-54 years',
            value: '43.77',
            male: '276970',
            female: '252108'
          },
          {
            group: '55-64 years',
            value: '13.83',
            male: '83650',
            female: '83585'
          },
          {
            group: '65 years and over',
            value: '12.11',
            male: '64092',
            female: '82251'
          }
        ],
        info: {
          name: 'Trinidad and Tobago',
          alpha2Code: 'TT',
          alpha3Code: 'TTO',
          capital: 'Port of Spain',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [11, -61],
          demonym: 'Trinidadian',
          area: 5130,
          gini: 40.3,
          borders: [],
          nativeName: 'Trinidad and Tobago',
          translations: {
            de: 'Trinidad und Tobago',
            es: 'Trinidad y Tobago',
            fr: 'Trinité et Tobago',
            ja: 'トリニダード・トバゴ',
            it: 'Trinidad e Tobago',
            br: 'Trinidad e Tobago',
            pt: 'Trindade e Tobago',
            nl: 'Trinidad en Tobago',
            hr: 'Trinidad i Tobago',
            fa: 'ترینیداد و توباگو'
          },
          flag: 'https://restcountries.eu/data/tto.svg'
        }
      },
      Tunisia: {
        name: 'Tunisia',
        slug: 'tunisia',
        population: 11811335,
        domain: '.tn',
        sex: {
          male: 49.66,
          female: 50.34
        },
        age: [
          {
            group: '0-14 years',
            value: '25.28',
            male: '1529834',
            female: '1433357'
          },
          {
            group: '15-24 years',
            value: '12.9',
            male: '766331',
            female: '745888'
          },
          {
            group: '25-54 years',
            value: '42.85',
            male: '2445751',
            female: '2576335'
          },
          {
            group: '55-64 years',
            value: '10.12',
            male: '587481',
            female: '598140'
          },
          {
            group: '65 years and over',
            value: '8.86',
            male: '491602',
            female: '546458'
          }
        ],
        info: {
          name: 'Tunisia',
          alpha2Code: 'TN',
          alpha3Code: 'TUN',
          capital: 'Tunis',
          region: 'Africa',
          subregion: 'Northern Africa',
          latlng: [34, 9],
          demonym: 'Tunisian',
          area: 163610,
          gini: 41.4,
          borders: ['DZA', 'LBY'],
          nativeName: 'تونس',
          translations: {
            de: 'Tunesien',
            es: 'Túnez',
            fr: 'Tunisie',
            ja: 'チュニジア',
            it: 'Tunisia',
            br: 'Tunísia',
            pt: 'Tunísia',
            nl: 'Tunesië',
            hr: 'Tunis',
            fa: 'تونس'
          },
          flag: 'https://restcountries.eu/data/tun.svg'
        }
      },
      Turkey: {
        name: 'Turkey',
        slug: 'turkey',
        population: 82482383,
        domain: '.tr',
        sex: {
          male: 50.25,
          female: 49.75
        },
        age: [
          {
            group: '0-14 years',
            value: '23.41',
            male: '9823553',
            female: '9378767'
          },
          {
            group: '15-24 years',
            value: '15.67',
            male: '6564263',
            female: '6286615'
          },
          {
            group: '25-54 years',
            value: '43.31',
            male: '17987103',
            female: '17536957'
          },
          {
            group: '55-64 years',
            value: '9.25',
            male: '3764878',
            female: '3822946'
          },
          {
            group: '65 years and over',
            value: '8.35',
            male: '3070258',
            female: '3782174'
          }
        ],
        info: {
          name: 'Turkey',
          alpha2Code: 'TR',
          alpha3Code: 'TUR',
          capital: 'Ankara',
          region: 'Asia',
          subregion: 'Western Asia',
          latlng: [39, 35],
          demonym: 'Turkish',
          area: 783562,
          gini: 39,
          borders: ['ARM', 'AZE', 'BGR', 'GEO', 'GRC', 'IRN', 'IRQ', 'SYR'],
          nativeName: 'Türkiye',
          translations: {
            de: 'Türkei',
            es: 'Turquía',
            fr: 'Turquie',
            ja: 'トルコ',
            it: 'Turchia',
            br: 'Turquia',
            pt: 'Turquia',
            nl: 'Turkije',
            hr: 'Turska',
            fa: 'ترکیه'
          },
          flag: 'https://restcountries.eu/data/tur.svg'
        }
      },
      Turkmenistan: {
        name: 'Turkmenistan',
        slug: 'turkmenistan',
        population: 5579889,
        domain: '.tm',
        sex: {
          male: 49.52,
          female: 50.48
        },
        age: [
          {
            group: '0-14 years',
            value: '25.44',
            male: '713441',
            female: '693042'
          },
          {
            group: '15-24 years',
            value: '16.48',
            male: '458566',
            female: '452469'
          },
          {
            group: '25-54 years',
            value: '44.14',
            male: '1214581',
            female: '1226027'
          },
          {
            group: '55-64 years',
            value: '8.56',
            male: '221935',
            female: '251238'
          },
          {
            group: '65 years and over',
            value: '5.38',
            male: '129332',
            female: '167996'
          }
        ],
        info: {
          name: 'Turkmenistan',
          alpha2Code: 'TM',
          alpha3Code: 'TKM',
          capital: 'Ashgabat',
          region: 'Asia',
          subregion: 'Central Asia',
          latlng: [40, 60],
          demonym: 'Turkmen',
          area: 488100,
          gini: 40.8,
          borders: ['AFG', 'IRN', 'KAZ', 'UZB'],
          nativeName: 'Türkmenistan',
          translations: {
            de: 'Turkmenistan',
            es: 'Turkmenistán',
            fr: 'Turkménistan',
            ja: 'トルクメニスタン',
            it: 'Turkmenistan',
            br: 'Turcomenistão',
            pt: 'Turquemenistão',
            nl: 'Turkmenistan',
            hr: 'Turkmenistan',
            fa: 'ترکمنستان'
          },
          flag: 'https://restcountries.eu/data/tkm.svg'
        }
      },
      'Turks and Caicos Islands': {
        name: 'Turks and Caicos Islands',
        slug: 'turks-and-caicos-islands',
        population: 57196,
        domain: '.tc',
        sex: {
          male: 50.35,
          female: 49.65
        },
        age: [
          {
            group: '0-14 years',
            value: '21.33',
            male: '6077',
            female: '5852'
          },
          {
            group: '15-24 years',
            value: '13.19',
            male: '3689',
            female: '3687'
          },
          {
            group: '25-54 years',
            value: '52.51',
            male: '14729',
            female: '14637'
          },
          {
            group: '55-64 years',
            value: '7.81',
            male: '2297',
            female: '2069'
          },
          {
            group: '65 years and over',
            value: '5.17',
            male: '1364',
            female: '1525'
          }
        ],
        info: {
          name: 'Turks and Caicos Islands',
          alpha2Code: 'TC',
          alpha3Code: 'TCA',
          capital: 'Cockburn Town',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [21.75, -71.58333333],
          demonym: 'Turks and Caicos Islander',
          area: 948,
          gini: null,
          borders: [],
          nativeName: 'Turks and Caicos Islands',
          translations: {
            de: 'Turks- und Caicosinseln',
            es: 'Islas Turks y Caicos',
            fr: 'Îles Turques-et-Caïques',
            ja: 'タークス・カイコス諸島',
            it: 'Isole Turks e Caicos',
            br: 'Ilhas Turcas e Caicos',
            pt: 'Ilhas Turcas e Caicos',
            nl: 'Turks- en Caicoseilanden',
            hr: 'Otoci Turks i Caicos',
            fa: 'جزایر تورکس و کایکوس'
          },
          flag: 'https://restcountries.eu/data/tca.svg'
        }
      },
      Tuvalu: {
        name: 'Tuvalu',
        slug: 'tuvalu',
        population: 11448,
        domain: '.tv',
        sex: {
          male: 49.51,
          female: 50.49
        },
        age: [
          {
            group: '0-14 years',
            value: '29.42',
            male: '1711',
            female: '1626'
          },
          {
            group: '15-24 years',
            value: '17.61',
            male: '1031',
            female: '966'
          },
          {
            group: '25-54 years',
            value: '37.17',
            male: '2157',
            female: '2059'
          },
          {
            group: '55-64 years',
            value: '9.12',
            male: '427',
            female: '607'
          },
          {
            group: '65 years and over',
            value: '6.68',
            male: '289',
            female: '469'
          }
        ],
        info: {
          name: 'Tuvalu',
          alpha2Code: 'TV',
          alpha3Code: 'TUV',
          capital: 'Funafuti',
          region: 'Oceania',
          subregion: 'Polynesia',
          latlng: [-8, 178],
          demonym: 'Tuvaluan',
          area: 26,
          gini: null,
          borders: [],
          nativeName: 'Tuvalu',
          translations: {
            de: 'Tuvalu',
            es: 'Tuvalu',
            fr: 'Tuvalu',
            ja: 'ツバル',
            it: 'Tuvalu',
            br: 'Tuvalu',
            pt: 'Tuvalu',
            nl: 'Tuvalu',
            hr: 'Tuvalu',
            fa: 'تووالو'
          },
          flag: 'https://restcountries.eu/data/tuv.svg'
        }
      },
      Uganda: {
        name: 'Uganda',
        slug: 'uganda',
        population: 44712143,
        domain: '.ug',
        sex: {
          male: 48.57,
          female: 51.43
        },
        age: [
          {
            group: '0-14 years',
            value: '48.21',
            male: '10548913',
            female: '10304876'
          },
          {
            group: '15-24 years',
            value: '20.25',
            male: '4236231',
            female: '4521698'
          },
          {
            group: '25-54 years',
            value: '26.24',
            male: '5202570',
            female: '6147304'
          },
          {
            group: '55-64 years',
            value: '2.91',
            male: '579110',
            female: '681052'
          },
          {
            group: '65 years and over',
            value: '2.38',
            male: '442159',
            female: '589053'
          }
        ],
        info: {
          name: 'Uganda',
          alpha2Code: 'UG',
          alpha3Code: 'UGA',
          capital: 'Kampala',
          region: 'Africa',
          subregion: 'Eastern Africa',
          latlng: [1, 32],
          demonym: 'Ugandan',
          area: 241550,
          gini: 44.3,
          borders: ['COD', 'KEN', 'RWA', 'SSD', 'TZA'],
          nativeName: 'Uganda',
          translations: {
            de: 'Uganda',
            es: 'Uganda',
            fr: 'Uganda',
            ja: 'ウガンダ',
            it: 'Uganda',
            br: 'Uganda',
            pt: 'Uganda',
            nl: 'Oeganda',
            hr: 'Uganda',
            fa: 'اوگاندا'
          },
          flag: 'https://restcountries.eu/data/uga.svg'
        }
      },
      Ukraine: {
        name: 'Ukraine',
        slug: 'ukraine',
        population: 43745640,
        domain: '.ua',
        sex: {
          male: 46.35,
          female: 53.65
        },
        age: [
          {
            group: '0-14 years',
            value: '16.16',
            male: '3658127',
            female: '3438887'
          },
          {
            group: '15-24 years',
            value: '9.28',
            male: '2087185',
            female: '1987758'
          },
          {
            group: '25-54 years',
            value: '43.66',
            male: '9456905',
            female: '9718758'
          },
          {
            group: '55-64 years',
            value: '13.87',
            male: '2630329',
            female: '3463851'
          },
          {
            group: '65 years and over',
            value: '17.03',
            male: '2523600',
            female: '4957539'
          }
        ],
        info: {
          name: 'Ukraine',
          alpha2Code: 'UA',
          alpha3Code: 'UKR',
          capital: 'Kiev',
          region: 'Europe',
          subregion: 'Eastern Europe',
          latlng: [49, 32],
          demonym: 'Ukrainian',
          area: 603700,
          gini: 26.4,
          borders: ['BLR', 'HUN', 'MDA', 'POL', 'ROU', 'RUS', 'SVK'],
          nativeName: 'Україна',
          translations: {
            de: 'Ukraine',
            es: 'Ucrania',
            fr: 'Ukraine',
            ja: 'ウクライナ',
            it: 'Ucraina',
            br: 'Ucrânia',
            pt: 'Ucrânia',
            nl: 'Oekraïne',
            hr: 'Ukrajina',
            fa: 'وکراین'
          },
          flag: 'https://restcountries.eu/data/ukr.svg'
        }
      },
      'United Arab Emirates': {
        name: 'United Arab Emirates',
        slug: 'united-arab-emirates',
        population: 9856612,
        domain: '.ae',
        sex: {
          male: 71.93,
          female: 28.07
        },
        age: [
          {
            group: '0-14 years',
            value: '14.45',
            male: '745492',
            female: '698330'
          },
          {
            group: '15-24 years',
            value: '7.94',
            male: '431751',
            female: '361804'
          },
          {
            group: '25-54 years',
            value: '68.03',
            male: '5204618',
            female: '1592987'
          },
          {
            group: '55-64 years',
            value: '7.68',
            male: '658892',
            female: '108850'
          },
          {
            group: '65 years and over',
            value: '1.9',
            male: '146221',
            female: '43138'
          }
        ],
        info: {
          name: 'United Arab Emirates',
          alpha2Code: 'AE',
          alpha3Code: 'ARE',
          capital: 'Abu Dhabi',
          region: 'Asia',
          subregion: 'Western Asia',
          latlng: [24, 54],
          demonym: 'Emirati',
          area: 83600,
          gini: null,
          borders: ['OMN', 'SAU'],
          nativeName: 'دولة الإمارات العربية المتحدة',
          translations: {
            de: 'Vereinigte Arabische Emirate',
            es: 'Emiratos Árabes Unidos',
            fr: 'Émirats arabes unis',
            ja: 'アラブ首長国連邦',
            it: 'Emirati Arabi Uniti',
            br: 'Emirados árabes Unidos',
            pt: 'Emirados árabes Unidos',
            nl: 'Verenigde Arabische Emiraten',
            hr: 'Ujedinjeni Arapski Emirati',
            fa: 'امارات متحده عربی'
          },
          flag: 'https://restcountries.eu/data/are.svg'
        }
      },
      'United Kingdom': {
        name: 'United Kingdom',
        slug: 'united-kingdom',
        population: 67886004,
        domain: '.uk',
        sex: {
          male: 49.81,
          female: 50.19
        },
        age: [
          {
            group: '0-14 years',
            value: '17.63',
            male: '5943435',
            female: '5651780'
          },
          {
            group: '15-24 years',
            value: '11.49',
            male: '3860435',
            female: '3692398'
          },
          {
            group: '25-54 years',
            value: '39.67',
            male: '13339965',
            female: '12747598'
          },
          {
            group: '55-64 years',
            value: '12.73',
            male: '4139378',
            female: '4234701'
          },
          {
            group: '65 years and over',
            value: '18.48',
            male: '5470116',
            female: '6681311'
          }
        ],
        info: {
          name: 'United Kingdom of Great Britain and Northern Ireland',
          alpha2Code: 'GB',
          alpha3Code: 'GBR',
          capital: 'London',
          region: 'Europe',
          subregion: 'Northern Europe',
          latlng: [54, -2],
          demonym: 'British',
          area: 242900,
          gini: 34,
          borders: ['IRL'],
          nativeName: 'United Kingdom',
          translations: {
            de: 'Vereinigtes Königreich',
            es: 'Reino Unido',
            fr: 'Royaume-Uni',
            ja: 'イギリス',
            it: 'Regno Unito',
            br: 'Reino Unido',
            pt: 'Reino Unido',
            nl: 'Verenigd Koninkrijk',
            hr: 'Ujedinjeno Kraljevstvo',
            fa: 'بریتانیای کبیر و ایرلند شمالی'
          },
          flag: 'https://restcountries.eu/data/gbr.svg'
        }
      },
      'United States of America': {
        name: 'United States',
        slug: 'united-states',
        population: 334998398,
        domain: '.us',
        sex: {
          male: 49.27,
          female: 50.73
        },
        age: [
          {
            group: '0-14 years',
            value: '18.46',
            male: '31374555',
            female: '30034371'
          },
          {
            group: '15-24 years',
            value: '12.91',
            male: '21931368',
            female: '21006463'
          },
          {
            group: '25-54 years',
            value: '38.92',
            male: '64893670',
            female: '64564565'
          },
          {
            group: '55-64 years',
            value: '12.86',
            male: '20690736',
            female: '22091808'
          },
          {
            group: '65 years and over',
            value: '16.85',
            male: '25014147',
            female: '31037419'
          }
        ],
        info: {
          name: 'United States of America',
          alpha2Code: 'US',
          alpha3Code: 'USA',
          capital: 'Washington, D.C.',
          region: 'Americas',
          subregion: 'Northern America',
          latlng: [38, -97],
          demonym: 'American',
          area: 9629091,
          gini: 48,
          borders: ['CAN', 'MEX'],
          nativeName: 'United States',
          translations: {
            de: 'Vereinigte Staaten von Amerika',
            es: 'Estados Unidos',
            fr: 'États-Unis',
            ja: 'アメリカ合衆国',
            it: "Stati Uniti D'America",
            br: 'Estados Unidos',
            pt: 'Estados Unidos',
            nl: 'Verenigde Staten',
            hr: 'Sjedinjene Američke Države',
            fa: 'ایالات متحده آمریکا'
          },
          flag: 'https://restcountries.eu/data/usa.svg'
        }
      },
      'United States Pacific Island Wildlife Refuges': {
        name: 'United States Pacific Island Wildlife Refuges',
        slug: 'united-states-pacific-island-wildlife-refuges',
        population: 0
      },
      Uruguay: {
        name: 'Uruguay',
        slug: 'uruguay',
        population: 3398239,
        domain: '.uy',
        sex: {
          male: 48.39,
          female: 51.61
        },
        age: [
          {
            group: '0-14 years',
            value: '19.51',
            male: '336336',
            female: '324563'
          },
          {
            group: '15-24 years',
            value: '15.14',
            male: '259904',
            female: '252945'
          },
          {
            group: '25-54 years',
            value: '39.86',
            male: '670295',
            female: '679850'
          },
          {
            group: '55-64 years',
            value: '10.79',
            male: '172313',
            female: '193045'
          },
          {
            group: '65 years and over',
            value: '14.71',
            male: '200516',
            female: '297838'
          }
        ],
        info: {
          name: 'Uruguay',
          alpha2Code: 'UY',
          alpha3Code: 'URY',
          capital: 'Montevideo',
          region: 'Americas',
          subregion: 'South America',
          latlng: [-33, -56],
          demonym: 'Uruguayan',
          area: 181034,
          gini: 39.7,
          borders: ['ARG', 'BRA'],
          nativeName: 'Uruguay',
          translations: {
            de: 'Uruguay',
            es: 'Uruguay',
            fr: 'Uruguay',
            ja: 'ウルグアイ',
            it: 'Uruguay',
            br: 'Uruguai',
            pt: 'Uruguai',
            nl: 'Uruguay',
            hr: 'Urugvaj',
            fa: 'اروگوئه'
          },
          flag: 'https://restcountries.eu/data/ury.svg'
        }
      },
      Uzbekistan: {
        name: 'Uzbekistan',
        slug: 'uzbekistan',
        population: 30842796,
        domain: '.uz',
        sex: {
          male: 49.74,
          female: 50.26
        },
        age: [
          {
            group: '0-14 years',
            value: '23.19',
            male: '3631693',
            female: '3456750'
          },
          {
            group: '15-24 years',
            value: '16.63',
            male: '2601803',
            female: '2481826'
          },
          {
            group: '25-54 years',
            value: '45.68',
            male: '6955260',
            female: '7006172'
          },
          {
            group: '55-64 years',
            value: '8.63',
            male: '1245035',
            female: '1392263'
          },
          {
            group: '65 years and over',
            value: '5.87',
            male: '768769',
            female: '1025840'
          }
        ],
        info: {
          name: 'Uzbekistan',
          alpha2Code: 'UZ',
          alpha3Code: 'UZB',
          capital: 'Tashkent',
          region: 'Asia',
          subregion: 'Central Asia',
          latlng: [41, 64],
          demonym: 'Uzbekistani',
          area: 447400,
          gini: 36.7,
          borders: ['AFG', 'KAZ', 'KGZ', 'TJK', 'TKM'],
          nativeName: 'O‘zbekiston',
          translations: {
            de: 'Usbekistan',
            es: 'Uzbekistán',
            fr: 'Ouzbékistan',
            ja: 'ウズベキスタン',
            it: 'Uzbekistan',
            br: 'Uzbequistão',
            pt: 'Usbequistão',
            nl: 'Oezbekistan',
            hr: 'Uzbekistan',
            fa: 'ازبکستان'
          },
          flag: 'https://restcountries.eu/data/uzb.svg'
        }
      },
      Vanuatu: {
        name: 'Vanuatu',
        slug: 'vanuatu',
        population: 303009,
        domain: '.vu',
        sex: {
          male: 49.8,
          female: 50.2
        },
        age: [
          {
            group: '0-14 years',
            value: '33.65',
            male: '51267',
            female: '49111'
          },
          {
            group: '15-24 years',
            value: '19.99',
            male: '29594',
            female: '30050'
          },
          {
            group: '25-54 years',
            value: '36.09',
            male: '52529',
            female: '55130'
          },
          {
            group: '55-64 years',
            value: '5.89',
            male: '8666',
            female: '8904'
          },
          {
            group: '65 years and over',
            value: '4.39',
            male: '6518',
            female: '6564'
          }
        ],
        info: {
          name: 'Vanuatu',
          alpha2Code: 'VU',
          alpha3Code: 'VUT',
          capital: 'Port Vila',
          region: 'Oceania',
          subregion: 'Melanesia',
          latlng: [-16, 167],
          demonym: 'Ni-Vanuatu',
          area: 12189,
          gini: null,
          borders: [],
          nativeName: 'Vanuatu',
          translations: {
            de: 'Vanuatu',
            es: 'Vanuatu',
            fr: 'Vanuatu',
            ja: 'バヌアツ',
            it: 'Vanuatu',
            br: 'Vanuatu',
            pt: 'Vanuatu',
            nl: 'Vanuatu',
            hr: 'Vanuatu',
            fa: 'وانواتو'
          },
          flag: 'https://restcountries.eu/data/vut.svg'
        }
      },
      Venezuela: {
        name: 'Venezuela',
        slug: 'venezuela',
        population: 29069153,
        domain: '.ve',
        sex: {
          male: 49.75,
          female: 50.25
        },
        age: [
          {
            group: '0-14 years',
            value: '25.66',
            male: '3759280',
            female: '3591897'
          },
          {
            group: '15-24 years',
            value: '16.14',
            male: '2348073',
            female: '2275912'
          },
          {
            group: '25-54 years',
            value: '41.26',
            male: '5869736',
            female: '5949082'
          },
          {
            group: '55-64 years',
            value: '8.76',
            male: '1203430',
            female: '1305285'
          },
          {
            group: '65 years and over',
            value: '8.18',
            male: '1069262',
            female: '1272646'
          }
        ],
        info: {
          name: 'Venezuela (Bolivarian Republic of)',
          alpha2Code: 'VE',
          alpha3Code: 'VEN',
          capital: 'Caracas',
          region: 'Americas',
          subregion: 'South America',
          latlng: [8, -66],
          demonym: 'Venezuelan',
          area: 916445,
          gini: 44.8,
          borders: ['BRA', 'COL', 'GUY'],
          nativeName: 'Venezuela',
          translations: {
            de: 'Venezuela',
            es: 'Venezuela',
            fr: 'Venezuela',
            ja: 'ベネズエラ・ボリバル共和国',
            it: 'Venezuela',
            br: 'Venezuela',
            pt: 'Venezuela',
            nl: 'Venezuela',
            hr: 'Venezuela',
            fa: 'ونزوئلا'
          },
          flag: 'https://restcountries.eu/data/ven.svg'
        }
      },
      Vietnam: {
        name: 'Vietnam',
        slug: 'vietnam',
        population: 102789598,
        domain: '.vn',
        sex: {
          male: 50.17,
          female: 49.83
        },
        age: [
          {
            group: '0-14 years',
            value: '22.61',
            male: '11733704',
            female: '10590078'
          },
          {
            group: '15-24 years',
            value: '15.22',
            male: '7825859',
            female: '7202716'
          },
          {
            group: '25-54 years',
            value: '45.7',
            male: '22852429',
            female: '22262566'
          },
          {
            group: '55-64 years',
            value: '9.55',
            male: '4412111',
            female: '5016880'
          },
          {
            group: '65 years and over',
            value: '6.91',
            male: '2702963',
            female: '4121969'
          }
        ],
        info: {
          name: 'Viet Nam',
          alpha2Code: 'VN',
          alpha3Code: 'VNM',
          capital: 'Hanoi',
          region: 'Asia',
          subregion: 'South-Eastern Asia',
          latlng: [16.16666666, 107.83333333],
          demonym: 'Vietnamese',
          area: 331212,
          gini: 35.6,
          borders: ['KHM', 'CHN', 'LAO'],
          nativeName: 'Việt Nam',
          translations: {
            de: 'Vietnam',
            es: 'Vietnam',
            fr: 'Viêt Nam',
            ja: 'ベトナム',
            it: 'Vietnam',
            br: 'Vietnã',
            pt: 'Vietname',
            nl: 'Vietnam',
            hr: 'Vijetnam',
            fa: 'ویتنام'
          },
          flag: 'https://restcountries.eu/data/vnm.svg'
        }
      },
      'Virgin Islands': {
        name: 'Virgin Islands',
        slug: 'virgin-islands',
        population: 105870,
        domain: '.vi',
        sex: {
          male: 47.59,
          female: 52.41
        },
        age: [
          {
            group: '0-14 years',
            value: '19.71',
            male: '10671',
            female: '10192'
          },
          {
            group: '15-24 years',
            value: '10.16',
            male: '5219',
            female: '5535'
          },
          {
            group: '25-54 years',
            value: '36.07',
            male: '17844',
            female: '20342'
          },
          {
            group: '55-64 years',
            value: '14.24',
            male: '7222',
            female: '7859'
          },
          {
            group: '65 years and over',
            value: '19.82',
            male: '9424',
            female: '11562'
          }
        ],
        info: {
          name: 'Virgin Islands (U.S.)',
          alpha2Code: 'VI',
          alpha3Code: 'VIR',
          capital: 'Charlotte Amalie',
          region: 'Americas',
          subregion: 'Caribbean',
          latlng: [18.34, -64.93],
          demonym: 'Virgin Islander',
          area: 346.36,
          gini: null,
          borders: [],
          nativeName: 'Virgin Islands of the United States',
          translations: {
            de: 'Amerikanische Jungferninseln',
            es: 'Islas Vírgenes de los Estados Unidos',
            fr: 'Îles Vierges des États-Unis',
            ja: 'アメリカ領ヴァージン諸島',
            it: 'Isole Vergini americane',
            br: 'Ilhas Virgens Americanas',
            pt: 'Ilhas Virgens Americanas',
            nl: 'Verenigde Staten Maagdeneilanden',
            hr: null,
            fa: 'جزایر ویرجین آمریکا'
          },
          flag: 'https://restcountries.eu/data/vir.svg'
        }
      },
      'Wake Island': {
        name: 'Wake Island',
        slug: 'wake-island',
        population: 0
      },
      'Wallis and Futuna': {
        name: 'Wallis and Futuna',
        slug: 'wallis-and-futuna',
        population: 15851,
        domain: '.wf',
        sex: {
          male: 50.88,
          female: 49.12
        },
        age: [
          {
            group: '0-14 years',
            value: '20.58',
            male: '1702',
            female: '1561'
          },
          {
            group: '15-24 years',
            value: '14.72',
            male: '1238',
            female: '1095'
          },
          {
            group: '25-54 years',
            value: '43.55',
            male: '3529',
            female: '3376'
          },
          {
            group: '55-64 years',
            value: '9.92',
            male: '742',
            female: '830'
          },
          {
            group: '65 years and over',
            value: '11.23',
            male: '856',
            female: '925'
          }
        ],
        info: {
          name: 'Wallis and Futuna',
          alpha2Code: 'WF',
          alpha3Code: 'WLF',
          capital: 'Mata-Utu',
          region: 'Oceania',
          subregion: 'Polynesia',
          latlng: [-13.3, -176.2],
          demonym: 'Wallis and Futuna Islander',
          area: 142,
          gini: null,
          borders: [],
          nativeName: 'Wallis et Futuna',
          translations: {
            de: 'Wallis und Futuna',
            es: 'Wallis y Futuna',
            fr: 'Wallis-et-Futuna',
            ja: 'ウォリス・フツナ',
            it: 'Wallis e Futuna',
            br: 'Wallis e Futuna',
            pt: 'Wallis e Futuna',
            nl: 'Wallis en Futuna',
            hr: 'Wallis i Fortuna',
            fa: 'والیس و فوتونا'
          },
          flag: 'https://restcountries.eu/data/wlf.svg'
        }
      },
      'West Bank': {
        name: 'West Bank',
        slug: 'west-bank',
        population: 2949246,
        domain: '.psnote - same as Gaza Strip',
        sex: {
          male: 50.86,
          female: 49.14
        },
        age: [
          {
            group: '0-14 years',
            value: '35.31',
            male: '525645',
            female: '498458'
          },
          {
            group: '15-24 years',
            value: '20.75',
            male: '307420',
            female: '294469'
          },
          {
            group: '25-54 years',
            value: '35.19',
            male: '516758',
            female: '503626'
          },
          {
            group: '55-64 years',
            value: '5.12',
            male: '76615',
            female: '72006'
          },
          {
            group: '65 years and over',
            value: '3.62',
            male: '48387',
            female: '56650'
          }
        ]
      },
      World: {
        name: 'World',
        slug: 'world',
        population: 7772850805,
        sex: {
          male: 48.06,
          female: 51.94
        },
        age: [
          {
            group: '0-14 years',
            value: '25.18',
            male: '1010373278',
            female: '946624579'
          },
          {
            group: '15-24 years',
            value: '15.29',
            male: '614046344',
            female: '574513854'
          },
          {
            group: '25-54 years',
            value: '40.6',
            male: '1597805095',
            female: '1557807873'
          },
          {
            group: '55-64 years',
            value: '9.23',
            male: '351094945',
            female: '366240730'
          },
          {
            group: '65 years and over',
            value: '9.69',
            male: '',
            female: '415884753'
          }
        ]
      },
      Yemen: {
        name: 'Yemen',
        slug: 'yemen',
        population: 30399243,
        domain: '.ye',
        sex: {
          male: 50.57,
          female: 49.43
        },
        age: [
          {
            group: '0-14 years',
            value: '39.16',
            male: '5711709',
            female: '5513526'
          },
          {
            group: '15-24 years',
            value: '21.26',
            male: '3089817',
            female: '3005693'
          },
          {
            group: '25-54 years',
            value: '32.78',
            male: '4805059',
            female: '4591811'
          },
          {
            group: '55-64 years',
            value: '4',
            male: '523769',
            female: '623100'
          },
          {
            group: '65 years and over',
            value: '2.8',
            male: '366891',
            female: '435855'
          }
        ],
        info: {
          name: 'Yemen',
          alpha2Code: 'YE',
          alpha3Code: 'YEM',
          capital: "Sana'a",
          region: 'Asia',
          subregion: 'Western Asia',
          latlng: [15, 48],
          demonym: 'Yemeni',
          area: 527968,
          gini: 37.7,
          borders: ['OMN', 'SAU'],
          nativeName: 'اليَمَن',
          translations: {
            de: 'Jemen',
            es: 'Yemen',
            fr: 'Yémen',
            ja: 'イエメン',
            it: 'Yemen',
            br: 'Iêmen',
            pt: 'Iémen',
            nl: 'Jemen',
            hr: 'Jemen',
            fa: 'یمن'
          },
          flag: 'https://restcountries.eu/data/yem.svg'
        }
      },
      Zambia: {
        name: 'Zambia',
        slug: 'zambia',
        population: 19077816,
        domain: '.zm',
        sex: {
          male: 49.96,
          female: 50.04
        },
        age: [
          {
            group: '0-14 years',
            value: '45.74',
            male: '4005134',
            female: '3964969'
          },
          {
            group: '15-24 years',
            value: '20.03',
            male: '1744843',
            female: '1746561'
          },
          {
            group: '25-54 years',
            value: '28.96',
            male: '2539697',
            female: '2506724'
          },
          {
            group: '55-64 years',
            value: '3.01',
            male: '242993',
            female: '280804'
          },
          {
            group: '65 years and over',
            value: '2.27',
            male: '173582',
            female: '221316'
          }
        ],
        info: {
          name: 'Zambia',
          alpha2Code: 'ZM',
          alpha3Code: 'ZMB',
          capital: 'Lusaka',
          region: 'Africa',
          subregion: 'Eastern Africa',
          latlng: [-15, 30],
          demonym: 'Zambian',
          area: 752612,
          gini: 54.6,
          borders: ['AGO', 'BWA', 'COD', 'MWI', 'MOZ', 'NAM', 'TZA', 'ZWE'],
          nativeName: 'Zambia',
          translations: {
            de: 'Sambia',
            es: 'Zambia',
            fr: 'Zambie',
            ja: 'ザンビア',
            it: 'Zambia',
            br: 'Zâmbia',
            pt: 'Zâmbia',
            nl: 'Zambia',
            hr: 'Zambija',
            fa: 'زامبیا'
          },
          flag: 'https://restcountries.eu/data/zmb.svg'
        }
      },
      Martinique: {
        name: 'Martinique',
        topLevelDomain: ['.mq'],
        alpha2Code: 'MQ',
        alpha3Code: 'MTQ',
        callingCodes: ['596'],
        capital: 'Fort-de-France',
        altSpellings: ['MQ'],
        region: 'Americas',
        subregion: 'Caribbean',
        population: 378243,
        latlng: [14.666667, -61],
        demonym: 'French',
        area: null,
        gini: null,
        timezones: ['UTC-04:00'],
        borders: [],
        nativeName: 'Martinique',
        numericCode: '474',

        languages: [
          {
            iso639_1: 'fr',
            iso639_2: 'fra',
            name: 'French',
            nativeName: 'français'
          }
        ],
        translations: {
          de: 'Martinique',
          es: 'Martinica',
          fr: 'Martinique',
          ja: 'マルティニーク',
          it: 'Martinica',
          br: 'Martinica',
          pt: 'Martinica',
          nl: 'Martinique',
          hr: 'Martinique',
          fa: 'مونتسرات'
        },
        flag: 'https://restcountries.eu/data/mtq.svg',
        regionalBlocs: [],
        cioc: ''
      },
      Zimbabwe: {
        name: 'Zimbabwe',
        slug: 'zimbabwe',
        population: 14829988,
        domain: '.zw',
        sex: {
          male: 49.09,
          female: 50.91
        },
        age: [
          {
            group: '0-14 years',
            value: '38.32',
            male: '2759155',
            female: '2814462'
          },
          {
            group: '15-24 years',
            value: '20.16',
            male: '1436710',
            female: '1495440'
          },
          {
            group: '25-54 years',
            value: '32.94',
            male: '2456392',
            female: '2334973'
          },
          {
            group: '55-64 years',
            value: '4.07',
            male: '227506',
            female: '363824'
          },
          {
            group: '65 years and over',
            value: '4.52',
            male: '261456',
            female: '396396'
          }
        ],
        info: {
          name: 'Zimbabwe',
          alpha2Code: 'ZW',
          alpha3Code: 'ZWE',
          capital: 'Harare',
          region: 'Africa',
          subregion: 'Eastern Africa',
          latlng: [-20, 30],
          demonym: 'Zimbabwean',
          area: 390757,
          gini: null,
          borders: ['BWA', 'MOZ', 'ZAF', 'ZMB'],
          nativeName: 'Zimbabwe',
          translations: {
            de: 'Simbabwe',
            es: 'Zimbabue',
            fr: 'Zimbabwe',
            ja: 'ジンバブエ',
            it: 'Zimbabwe',
            br: 'Zimbabwe',
            pt: 'Zimbabué',
            nl: 'Zimbabwe',
            hr: 'Zimbabve',
            fa: 'زیمباوه'
          },
          flag: 'https://restcountries.eu/data/zwe.svg'
        }
      }
    }
  };
}
